(window.webpackJsonp = window.webpackJsonp || []).push([
  [10, 138],
  {
    "/+VL": function (t, e, n) {
      "use strict";
      n.d(e, "a", function () {
        return j;
      });
      var r = n("1OyB"),
        o = n("vuIU"),
        i = n("rePB"),
        a = n("yWgo"),
        c = n("Agtg"),
        s = n("md7G"),
        u = n("foSv"),
        l = n("JX7q"),
        f = n("Ji7U");
      function h(t, e) {
        var n = Object.keys(e).filter(function (n) {
          var r = e[n].options;
          return (function t(e, n) {
            if (e === n) return !0;
            var r = Object.prototype.toString.call(e),
              o = Object.prototype.toString.call(n);
            if (r !== o) return !1;
            if ("[object Object]" !== r && "[object Object]" !== o)
              return e === n;
            if (e && n && "object" === typeof e && "object" === typeof n)
              for (var i in e)
                if (
                  Object.prototype.hasOwnProperty.call(e, i) &&
                  !1 === t(e[i], n[i])
                )
                  return !1;
            return !0;
          })(t, r);
        })[0];
        return e[n];
      }
      function d(t) {
        var e = t.root;
        return JSON.stringify(t, function (t, n) {
          if ("root" === t && e) {
            var r = Array.prototype.slice.call(e.classList).reduce(function (
                t,
                e,
              ) {
                return t + e;
              }, ""),
              o = e.id;
            return "".concat(o, "-").concat(r);
          }
          return n;
        });
      }
      var p = (function () {
          function t() {
            Object(r.default)(this, t),
              Object(i.a)(this, "registry", void 0),
              (this.registry = new WeakMap());
          }
          return (
            Object(o.default)(t, [
              {
                key: "elementExists",
                value: function (t) {
                  return this.registry.has(t);
                },
              },
              {
                key: "getElement",
                value: function (t) {
                  return this.registry.get(t);
                },
              },
              {
                key: "addElement",
                value: function (t, e) {
                  t && this.registry.set(t, e || {});
                },
              },
              {
                key: "removeElement",
                value: function (t) {
                  this.registry.delete(t);
                },
              },
              {
                key: "clear",
                value: function () {
                  this.registry = new WeakMap();
                },
              },
            ]),
            t
          );
        })(),
        v = (function (t) {
          return (t.enter = "enter"), (t.exit = "exit"), t;
        })({});
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e &&
            (r = r.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function g(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? y(Object(n), !0).forEach(function (e) {
                Object(i.a)(t, e, n[e]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
              : y(Object(n)).forEach(function (e) {
                  Object.defineProperty(
                    t,
                    e,
                    Object.getOwnPropertyDescriptor(n, e),
                  );
                });
        }
        return t;
      }
      function m(t, e, n) {
        return (
          (e = Object(u.a)(e)),
          Object(s.a)(
            t,
            (function () {
              try {
                var t = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (t) {}
              return (function () {
                return !!t;
              })();
            })()
              ? Reflect.construct(e, n || [], Object(u.a)(t).constructor)
              : e.apply(t, n),
          )
        );
      }
      var w = (function (t) {
        function e() {
          var t;
          return (
            Object(r.default)(this, e),
            (t = m(this, e)),
            Object(i.a)(Object(l.a)(t), "elementRegistry", void 0),
            (t.elementRegistry = new p()),
            t
          );
        }
        return (
          Object(f.a)(e, t),
          Object(o.default)(e, [
            {
              key: "observeNodeIntersection",
              value: function (t, e, n) {
                var r, o;
                t.inView &&
                  (null === (r = t.callback) ||
                    void 0 === r ||
                    null === (o = r.scrollIntoView) ||
                    void 0 === o ||
                    o.call(r, e),
                  t.startFrameTask());
                this.addCallback(
                  t.element,
                  function () {
                    var n, r;
                    t.inView ||
                      ((t.inView = !0),
                      null === (n = t.callback) ||
                        void 0 === n ||
                        null === (r = n.scrollIntoView) ||
                        void 0 === r ||
                        r.call(n, e),
                      t.startFrameTask());
                  },
                  function () {
                    var n, r;
                    t.inView &&
                      ((t.inView = !1),
                      null === (n = t.callback) ||
                        void 0 === n ||
                        null === (r = n.scrollOutOfWiew) ||
                        void 0 === r ||
                        r.call(n, e),
                      t.stopFrameTask());
                  },
                ),
                  this.observe(t.element, n);
              },
            },
            {
              key: "observe",
              value: function (t) {
                var e =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
                t &&
                  (this.elementRegistry.addElement(t, g({}, e)),
                  this.setupObserver(t, g({}, e)));
              },
            },
            {
              key: "unobserve",
              value: function (t, e) {
                var n = this.findMatchingRootEntry(e);
                (this.elementRegistry.removeElement(t), n) &&
                  n.intersectionObserver.unobserve(t);
              },
            },
            {
              key: "dispatchEnterCallback",
              value: function (t, e) {
                this.dispatchCallback(v.enter, t, e);
              },
            },
            {
              key: "dispatchExitCallback",
              value: function (t, e) {
                this.dispatchCallback(v.exit, t, e);
              },
            },
            {
              key: "destroy",
              value: function () {
                this.elementRegistry.clear();
              },
            },
            {
              key: "handleIntersection",
              value: function (t) {
                var e = this;
                return function (n) {
                  return e.onIntersection(t, n);
                };
              },
            },
            {
              key: "setupObserver",
              value: function (t, e) {
                var n,
                  r = e.root,
                  o = void 0 === r ? window : r,
                  a = this.findRootFromRegistry(o);
                if ((a && (n = h(e, a)), n)) {
                  var c = n,
                    s = c.elements,
                    u = c.intersectionObserver;
                  s.push(t), u && u.observe(t);
                } else {
                  var l = {
                      elements: [t],
                      intersectionObserver: this.newObserver(t, e),
                      options: e,
                    },
                    f = d(e);
                  a
                    ? (a[f] = l)
                    : this.elementRegistry.addElement(o, Object(i.a)({}, f, l));
                }
              },
            },
            {
              key: "newObserver",
              value: function (t, e) {
                var n = e.root,
                  r = e.rootMargin,
                  o = e.threshold,
                  i = new IntersectionObserver(
                    this.handleIntersection(e).bind(this),
                    { root: n, rootMargin: r, threshold: o },
                  );
                return i.observe(t), i;
              },
            },
            {
              key: "onIntersection",
              value: function (t, e) {
                var n = this;
                e.forEach(function (e) {
                  var r = e.isIntersecting,
                    o = e.intersectionRatio,
                    i = t.threshold || 0;
                  Array.isArray(i) && (i = i[i.length - 1]);
                  var a = n.findMatchingRootEntry(t);
                  r || o > i
                    ? a &&
                      a.elements.some(function (t) {
                        return (
                          !(!t || t !== e.target) &&
                          (n.dispatchEnterCallback(t, e), !0)
                        );
                      })
                    : a &&
                      a.elements.some(function (t) {
                        return (
                          !(!t || t !== e.target) &&
                          (n.dispatchExitCallback(t, e), !0)
                        );
                      });
                });
              },
            },
            {
              key: "findRootFromRegistry",
              value: function (t) {
                if (this.elementRegistry)
                  return this.elementRegistry.getElement(t);
              },
            },
            {
              key: "findMatchingRootEntry",
              value: function (t) {
                var e = t.root,
                  n = void 0 === e ? window : e,
                  r = this.findRootFromRegistry(n);
                if (r) return r[d(t)];
              },
            },
          ]),
          e
        );
      })(
        (function () {
          function t() {
            Object(r.default)(this, t),
              Object(i.a)(this, "registry", void 0),
              (this.registry = new p());
          }
          return (
            Object(o.default)(t, [
              {
                key: "addCallback",
                value: function (t, e, n) {
                  var r = Object(i.a)(Object(i.a)({}, v.enter, [e]), v.exit, [
                      n,
                    ]),
                    o = this.registry.getElement(t);
                  o &&
                    (o.enter && (r.enter = o.enter.concat(r.enter || [])),
                    o.exit && (r.exit = o.exit.concat(r.exit || []))),
                    this.registry.addElement(t, r);
                },
              },
              {
                key: "dispatchCallback",
                value: function (t, e, n) {
                  if (t === v.enter) {
                    var r = this.registry.getElement(e);
                    (null === r || void 0 === r ? void 0 : r.enter.length) >
                      0 &&
                      r.enter.forEach(function (t) {
                        t(n);
                      });
                  } else {
                    var o = this.registry.getElement(e);
                    (null === o || void 0 === o ? void 0 : o.exit.length) > 0 &&
                      o.exit.forEach(function (t) {
                        t(n);
                      });
                  }
                },
              },
            ]),
            t
          );
        })(),
      );
      function b(t, e, n) {
        var r, o;
        if (e && !t.inView)
          (t.inView = !0),
            null === (r = t.callback) ||
              void 0 === r ||
              null === (o = r.scrollIntoView) ||
              void 0 === o ||
              o.call(r, n),
            t.startFrameTask();
        else if (!e && t.inView) {
          var i, a;
          (t.inView = !1),
            null === (i = t.callback) ||
              void 0 === i ||
              null === (a = i.scrollOutOfWiew) ||
              void 0 === a ||
              a.call(i, n),
            t.stopFrameTask();
        }
      }
      var _ = 84,
        O = 125,
        E = (function () {
          function t(e) {
            var n = this;
            Object(r.default)(this, t),
              Object(i.a)(this, "dimension", void 0),
              Object(i.a)(this, "monitorTimeout", void 0),
              Object(i.a)(this, "monitoring", !1),
              Object(i.a)(this, "startTime", 0),
              Object(i.a)(this, "frameTime", 0),
              Object(i.a)(this, "accumulateOffsetMills", 0),
              Object(i.a)(this, "totalOffsetMills", void 0),
              Object(i.a)(this, "displayFrameTimes", []),
              Object(i.a)(this, "janks", 0),
              Object(i.a)(this, "bigJanks", 0),
              Object(i.a)(this, "jankList", []),
              Object(i.a)(this, "jankPositionList", []),
              Object(i.a)(this, "dimensionListenerKey", "ScrollMonitor"),
              Object(i.a)(this, "handleScrollStart", function () {
                clearTimeout(n.monitorTimeout),
                  (n.monitorTimeout = void 0),
                  n.start();
              }),
              Object(i.a)(this, "handleScrollEnd", function () {
                n.monitorTimeout = window.setTimeout(function () {
                  n.stop();
                }, 5e3);
              }),
              Object(i.a)(this, "detect", function () {
                var t = window.requestAnimationFrame;
                n.startTime = performance.now();
                n.monitoring &&
                  (function e() {
                    if (n.monitoring) {
                      var r = performance.now();
                      n.accumulateOffsetMills = r - n.totalOffsetMills;
                      var o = Number((r - n.frameTime).toFixed(3));
                      n.displayFrameTimes.push(o),
                        n.displayFrameTimes.length > 4 &&
                          n.displayFrameTimes.shift(),
                        o >
                          ((n.displayFrameTimes[0] +
                            n.displayFrameTimes[1] +
                            n.displayFrameTimes[2]) /
                            3) *
                            2 &&
                          o > _ &&
                          (o > O
                            ? ((n.bigJanks += 1),
                              n.jankList.push(o),
                              n.jankPositionList.push({
                                pos: n.dimension.pageOffsetY,
                                type: 1,
                              }))
                            : ((n.janks += 1),
                              n.jankList.push(o),
                              n.jankPositionList.push({
                                pos: n.dimension.pageOffsetY,
                                type: 0,
                              }))),
                        n.accumulateOffsetMills >= 1e3 &&
                          (n.totalOffsetMills += n.accumulateOffsetMills),
                        (n.frameTime = r),
                        t(e);
                    }
                  })();
              }),
              Object(i.a)(this, "calculate", function () {
                var t = performance.now() - n.startTime,
                  e = "time:"
                    .concat(t, "ms jankList:")
                    .concat(n.jankList, " jankPosition:")
                    .concat(
                      n.jankPositionList.map(function (t) {
                        return t.pos;
                      }),
                    );
                console.log(e);
                var r = 0,
                  o = 0;
                n.jankList.forEach(function (t) {
                  (r += t), t > O && (o += t);
                });
                var i = Number(((100 * r) / t).toFixed(2)),
                  a = Number(((100 * o) / t).toFixed(2)),
                  c = "jankCount:"
                    .concat(n.janks, " bigJankCount:")
                    .concat(n.bigJanks, " jankRate:")
                    .concat(i, "% bigJankRate:")
                    .concat(a, "%");
                console.log(c), n.clear(), n.report(e, c, i);
              }),
              (this.dimension = e);
          }
          return (
            Object(o.default)(t, [
              {
                key: "init",
                value: function () {
                  var t = this;
                  window.addEventListener("load", function () {
                    setTimeout(function () {
                      t.checkEnvironment() &&
                        (t.dimension.addDimensionListener(
                          t.dimensionListenerKey,
                          {
                            onScrollStart: t.handleScrollStart,
                            onScrollEnd: t.handleScrollEnd,
                          },
                        ),
                        document.addEventListener(
                          "visibilitychange",
                          function () {
                            document.hidden && t.stop();
                          },
                        ));
                    }, 2e3);
                  });
                },
              },
              {
                key: "checkEnvironment",
                value: function () {
                  return (
                    ("Sentry" in window &&
                      "object" === typeof window.Sentry &&
                      "captureEvent" in window.Sentry) ||
                    (console.log(
                      "ScrollMonitor::checkEnvironment return false: Sentry is illegal",
                    ),
                    !1)
                  );
                },
              },
              {
                key: "start",
                value: function () {
                  this.monitoring || ((this.monitoring = !0), this.detect());
                },
              },
              {
                key: "stop",
                value: function () {
                  this.monitoring && ((this.monitoring = !1), this.calculate());
                },
              },
              {
                key: "report",
                value: function (t, e, n) {
                  var r,
                    o,
                    i = window.location.pathname;
                  (r = n > 8 ? "8+" : n > 4 ? "4+" : "0~4"),
                    window.sensorsDataAnalytic201505 &&
                      (o =
                        window.sensorsDataAnalytic201505.quick(
                          "getAnonymousID",
                        ));
                  var a = {
                      message: "Performance JANKRATE event from scroll monitor",
                      level: "log",
                      tags: {
                        category: "Custom Event",
                        path: i,
                        rates: t,
                        jankcounts: e,
                        jankRate: n,
                        baseline: r,
                        userId: o,
                      },
                    },
                    c = window.Sentry.captureEvent(a);
                  this.reportMeasurements(n, c);
                },
              },
              {
                key: "clear",
                value: function () {
                  (this.startTime = 0),
                    (this.frameTime = 0),
                    (this.accumulateOffsetMills = 0),
                    (this.displayFrameTimes = []),
                    (this.janks = 0),
                    (this.bigJanks = 0),
                    (this.jankList = []),
                    (this.jankPositionList = []);
                },
              },
              {
                key: "generateSentryTraceID",
                value: function (t, e) {
                  for (var n = e, r = "", o = n.length, i = 0; i < t; i++)
                    r += n.charAt(Math.floor(Math.random() * o));
                  return r;
                },
              },
              {
                key: "reportMeasurements",
                value: function (t, e) {
                  var n = t / 100,
                    r = window.Sentry.getCurrentHub().getClient().getDsn(),
                    o = r.publicKey,
                    i = r.host,
                    c = document.referrer,
                    s = Object(a.n)() ? "prod" : "test",
                    u = window.location.href,
                    l = navigator.userAgent,
                    f = this.generateSentryTraceID(32, e),
                    h = this.generateSentryTraceID(32, e),
                    d = this.generateSentryTraceID(32, e),
                    p = this.generateSentryTraceID(16, e),
                    v = Date.now() / 1e3;
                  fetch(
                    "https://"
                      .concat(i, "/api/698/envelope/?sentry_key=")
                      .concat(
                        o,
                        "&sentry_version=7&sentry_client=sentry.javascript.react%2F7.61.1",
                      ),
                    {
                      referrer: c,
                      referrerPolicy: "origin",
                      body: '{"event_id":"'
                        .concat(
                          f,
                          '","sdk":{"name":"sentry.javascript.react","version":"7.61.1"},"trace":{"environment":"',
                        )
                        .concat(s, '","release":"0.0.1","public_key":"')
                        .concat(o, '","trace_id":"')
                        .concat(
                          h,
                          '"}}\n{"type":"transaction"}\n{"contexts":{"trace":{"op":"jankrate","span_id":"',
                        )
                        .concat(p, '","tags":{"jankEventID":"')
                        .concat(e, '"},"trace_id":"')
                        .concat(d, '"}},"spans":[],"start_timestamp":')
                        .concat(v, ',"tags":{},"timestamp":')
                        .concat(
                          v,
                          ',"transaction":"performance JANKRATE","type":"transaction","transaction_info":{"source":"url"},"measurements":{"jankRate":{"value":',
                        )
                        .concat(
                          n,
                          ',"unit":"percent"}},"platform":"javascript","event_id":"',
                        )
                        .concat(f, '","environment":"')
                        .concat(
                          s,
                          '","release":"0.0.1","sdk":{"integrations":[],"name":"sentry.javascript.react","version":"7.61.1","packages":[]},"breadcrumbs":[{}],"request":{"url":"',
                        )
                        .concat(u, '","headers":{"Referer":"')
                        .concat(c, '","User-Agent":"')
                        .concat(l, '"}}}'),
                      method: "POST",
                      mode: "no-cors",
                      credentials: "omit",
                    },
                  );
                },
              },
            ]),
            t
          );
        })();
      function S(t, e) {
        var n = t.top,
          r = t.left,
          o = t.width,
          i = t.height;
        return (
          n < e.pageOffsetY + e.innerHeight &&
          r < e.pageOffsetX + e.innerWidth &&
          n + i > e.pageOffsetY &&
          r + o > e.pageOffsetX
        );
      }
      var x = (function () {
          function t(e, n, o) {
            Object(r.default)(this, t),
              Object(i.a)(this, "scrollElement", void 0),
              Object(i.a)(this, "scrollTaskList", void 0),
              Object(i.a)(this, "scrollCallback", void 0),
              Object(i.a)(this, "nodeInfo", void 0),
              Object(i.a)(this, "frameTaskRunning", !1),
              (this.scrollElement = e),
              (this.nodeInfo = {
                top: 0,
                left: 0,
                width: 0,
                height: 0,
                inView: !1,
              }),
              (this.scrollTaskList = []),
              o && this.addTask(o),
              n && (this.scrollCallback = n);
          }
          return (
            Object(o.default)(t, [
              {
                key: "element",
                get: function () {
                  return this.scrollElement;
                },
              },
              {
                key: "callback",
                get: function () {
                  return this.scrollCallback;
                },
              },
              {
                key: "IScrollNode",
                get: function () {
                  return this.nodeInfo;
                },
              },
              {
                key: "top",
                get: function () {
                  return this.nodeInfo.top;
                },
              },
              {
                key: "left",
                get: function () {
                  return this.nodeInfo.left;
                },
              },
              {
                key: "width",
                get: function () {
                  return this.nodeInfo.width;
                },
              },
              {
                key: "height",
                get: function () {
                  return this.nodeInfo.height;
                },
              },
              {
                key: "inView",
                get: function () {
                  return this.nodeInfo.inView;
                },
                set: function (t) {
                  this.nodeInfo.inView = t;
                },
              },
              {
                key: "equals",
                value: function (t) {
                  return this.scrollElement.isSameNode(t);
                },
              },
              {
                key: "refreshPosition",
                value: function (t) {
                  (this.nodeInfo.top = this.scrollElement.offsetTop),
                    (this.nodeInfo.left = this.scrollElement.offsetLeft),
                    (this.nodeInfo.width = this.scrollElement.offsetWidth),
                    (this.nodeInfo.height = this.scrollElement.offsetHeight);
                  for (var e = this.scrollElement.offsetParent; e; )
                    (this.nodeInfo.top += e.offsetTop),
                      (this.nodeInfo.left += e.offsetLeft),
                      (e = e.offsetParent);
                  this.inView = S(this, t);
                },
              },
              {
                key: "addTask",
                value: function (t) {
                  this.scrollTaskList = this.scrollTaskList.concat(t);
                },
              },
              {
                key: "runFrameTask",
                value: function () {
                  var t = this;
                  this.frameTaskRunning &&
                    setTimeout(function () {
                      t.inView &&
                        t.scrollTaskList.length > 0 &&
                        t.scrollTaskList.forEach(function (e, n, r) {
                          var o = e(t);
                          !0 === Boolean(o) && r.splice(n, 1);
                        }),
                        t.runFrameTask();
                    }, 60);
                },
              },
              {
                key: "startFrameTask",
                value: function () {
                  !this.frameTaskRunning &&
                    this.scrollTaskList.length > 0 &&
                    ((this.frameTaskRunning = !0), this.runFrameTask());
                },
              },
              {
                key: "stopFrameTask",
                value: function () {
                  this.frameTaskRunning = !1;
                },
              },
            ]),
            t
          );
        })(),
        j = (function () {
          function t() {
            (Object(r.default)(this, t),
            Object(i.a)(this, "scrollNodes", []),
            Object(i.a)(this, "dimension", void 0),
            Object(i.a)(this, "sharedIntersectionObserver", void 0),
            Object(i.a)(this, "isSupportIntersectionObserver", !1),
            Object(i.a)(this, "checkElementTaskRunning", !1),
            (this.isSupportIntersectionObserver =
              window &&
              "IntersectionObserver" in window &&
              "isIntersecting" in window.IntersectionObserverEntry.prototype),
            (this.dimension = new c.b()),
            this.isSupportIntersectionObserver &&
              (this.sharedIntersectionObserver = new w()),
            !Object(a.n)() || Math.random() < 0.1) &&
              new E(this.dimension).init();
          }
          return (
            Object(o.default)(
              t,
              [
                {
                  key: "addNode",
                  value: function (t, e, n, r, o, i) {
                    if (!t || !window)
                      return (
                        console.warn(
                          "ScrollManager::addNode attempt adding an illegal element",
                        ),
                        null
                      );
                    if (n) {
                      var a = this.scrollNodes[this.findScrollNode(t)];
                      if (!a || o) {
                        var c = this.addScrollNode(t, e, n),
                          s = this.scrollNodes[c];
                        return this.observeInView(s, r, i), s;
                      }
                      return a.refreshPosition(this.dimension), a;
                    }
                    var u = new x(t, e, n);
                    return (
                      u.refreshPosition(this.dimension),
                      this.observeInView(u, r, i),
                      u
                    );
                  },
                },
                {
                  key: "removeNode",
                  value: function (t) {
                    var e = this.findScrollNode(t);
                    return -1 !== e
                      ? (this.scrollNodes.splice(e, 1),
                        this.unObserveInView(t),
                        !0)
                      : (this.unObserveInView(t), !1);
                  },
                },
                {
                  key: "addTask",
                  value: function (t, e) {
                    var n = this.scrollNodes[this.findScrollNode(t)];
                    return n
                      ? (n.addTask(e),
                        this.checkElementTaskRunning ||
                          this.isSupportIntersectionObserver ||
                          ((this.checkElementTaskRunning = !0),
                          this.runCheckElementTask()),
                        !0)
                      : (console.warn(
                          "ScrollManager::addTask cannot find target node",
                        ),
                        !1);
                  },
                },
                {
                  key: "getDimension",
                  value: function () {
                    return this.dimension;
                  },
                },
                {
                  key: "checkElementInView",
                  value: function (t) {
                    var e =
                      !(arguments.length > 1 && void 0 !== arguments[1]) ||
                      arguments[1];
                    if (!t)
                      return (
                        console.warn(
                          "ScrollManager::checkElementInView attempt checking an empty target element",
                        ),
                        !1
                      );
                    var n = this.scrollNodes[this.findScrollNode(t)];
                    if (!n)
                      return (
                        console.warn(
                          "ScrollManager::checkElementInView attempt checking an illegal target element",
                        ),
                        !1
                      );
                    if (!e) {
                      n.refreshPosition(this.dimension);
                      var r = S(n, this.dimension);
                      b(n, r, this.dimension);
                    }
                    return n.inView;
                  },
                },
                {
                  key: "runCheckElementTask",
                  value: function () {
                    var t = this;
                    setTimeout(function () {
                      !t.dimension.isOffsetValid && t.dimension.updateOffset();
                      for (var e = 0; e < t.scrollNodes.length; e++) {
                        var n = t.scrollNodes[e];
                        b(n, S(n, t.dimension), t.dimension);
                      }
                      t.runCheckElementTask();
                    }, 150);
                  },
                },
                {
                  key: "addScrollNode",
                  value: function (t, e, n) {
                    var r = this,
                      o = new x(t, e, n);
                    if (0 === this.scrollNodes.length)
                      return this.scrollNodes.push(o), 0;
                    var i = -1;
                    return (
                      this.scrollNodes.every(function (t, e) {
                        if (t.top >= o.top)
                          return r.scrollNodes.splice(e, 0, o), (i = e), !1;
                        var n = r.scrollNodes.length;
                        return (
                          e === n - 1 && ((i = n), r.scrollNodes.push(o)), !0
                        );
                      }),
                      i
                    );
                  },
                },
                {
                  key: "findScrollNode",
                  value: function (t) {
                    var e = -1;
                    return (
                      this.scrollNodes.every(function (n, r) {
                        return !n.element.isSameNode(t) || ((e = r), !1);
                      }),
                      e
                    );
                  },
                },
                {
                  key: "observeInView",
                  value: function (t) {
                    var e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 500,
                      n = arguments.length > 2 ? arguments[2] : void 0;
                    if (this.isSupportIntersectionObserver)
                      this.sharedIntersectionObserver.observeNodeIntersection(
                        t,
                        this.dimension,
                        { rootMargin: "".concat(e, "px"), threshold: n || 0 },
                      );
                    else {
                      var r = S(t, this.dimension);
                      b(t, r, this.dimension),
                        this.checkElementTaskRunning ||
                          ((this.checkElementTaskRunning = !0),
                          this.runCheckElementTask());
                    }
                  },
                },
                {
                  key: "unObserveInView",
                  value: function (t) {
                    this.isSupportIntersectionObserver &&
                      this.sharedIntersectionObserver.unobserve(t, { root: t });
                  },
                },
              ],
              [
                {
                  key: "getInstance",
                  value: function () {
                    return (
                      this.instance || (this.instance = new t()), this.instance
                    );
                  },
                },
              ],
            ),
            t
          );
        })();
      Object(i.a)(j, "instance", void 0);
    },
    "1TCz": function (t, e, n) {
      "use strict";
      n.r(e);
      var r = n("HaE+"),
        o = n("1OyB"),
        i = n("vuIU"),
        a = n("md7G"),
        c = n("foSv"),
        s = n("JX7q"),
        u = n("Ji7U"),
        l = n("rePB"),
        f = n("q1tI"),
        h = n.n(f),
        d = n("/MKj"),
        p = n("8Bbg"),
        v = n.n(p),
        y = (function () {
          var t = function (e, n) {
            return (t =
              Object.setPrototypeOf ||
              ({ __proto__: [] } instanceof Array &&
                function (t, e) {
                  t.__proto__ = e;
                }) ||
              function (t, e) {
                for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
              })(e, n);
          };
          return function (e, n) {
            function r() {
              this.constructor = e;
            }
            t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((r.prototype = n.prototype), new r()));
          };
        })(),
        g = function () {
          return (g =
            Object.assign ||
            function (t) {
              for (var e, n = 1, r = arguments.length; n < r; n++)
                for (var o in (e = arguments[n]))
                  Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }).apply(this, arguments);
        },
        m = function (t, e, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(t) {
              try {
                s(r.next(t));
              } catch (Te) {
                i(Te);
              }
            }
            function c(t) {
              try {
                s(r.throw(t));
              } catch (Te) {
                i(Te);
              }
            }
            function s(t) {
              t.done
                ? o(t.value)
                : new n(function (e) {
                    e(t.value);
                  }).then(a, c);
            }
            s((r = r.apply(t, e || [])).next());
          });
        },
        w = function (t, e) {
          var n,
            r,
            o,
            i,
            a = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (i = { next: c(0), throw: c(1), return: c(2) }),
            "function" === typeof Symbol &&
              (i[Symbol.iterator] = function () {
                return this;
              }),
            i
          );
          function c(i) {
            return function (c) {
              return (function (i) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & i[0]
                            ? r.return
                            : i[0]
                              ? r.throw || ((o = r.return) && o.call(r), 0)
                              : r.next) &&
                        !(o = o.call(r, i[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (i = [2 & i[0], o.value]), i[0])) {
                      case 0:
                      case 1:
                        o = i;
                        break;
                      case 4:
                        return a.label++, { value: i[1], done: !1 };
                      case 5:
                        a.label++, (r = i[1]), (i = [0]);
                        continue;
                      case 7:
                        (i = a.ops.pop()), a.trys.pop();
                        continue;
                      default:
                        if (
                          !(o = (o = a.trys).length > 0 && o[o.length - 1]) &&
                          (6 === i[0] || 2 === i[0])
                        ) {
                          a = 0;
                          continue;
                        }
                        if (
                          3 === i[0] &&
                          (!o || (i[1] > o[0] && i[1] < o[3]))
                        ) {
                          a.label = i[1];
                          break;
                        }
                        if (6 === i[0] && a.label < o[1]) {
                          (a.label = o[1]), (o = i);
                          break;
                        }
                        if (o && a.label < o[2]) {
                          (a.label = o[2]), a.ops.push(i);
                          break;
                        }
                        o[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    i = e.call(t, a);
                  } catch (Te) {
                    (i = [6, Te]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & i[0]) throw i[1];
                return { value: i[0] ? i[1] : void 0, done: !0 };
              })([i, c]);
            };
          }
        },
        b = function (t, e) {
          var n = {};
          for (var r in t)
            Object.prototype.hasOwnProperty.call(t, r) &&
              e.indexOf(r) < 0 &&
              (n[r] = t[r]);
          if (null != t && "function" === typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(t); o < r.length; o++)
              e.indexOf(r[o]) < 0 &&
                Object.prototype.propertyIsEnumerable.call(t, r[o]) &&
                (n[r[o]] = t[r[o]]);
          }
          return n;
        },
        _ = {
          storeKey: "__NEXT_REDUX_STORE__",
          debug: !1,
          serializeState: function (t) {
            return t;
          },
          deserializeState: function (t) {
            return t;
          },
        },
        O = n("ANjH"),
        E = n("ODXe"),
        S = n("LpSC"),
        x = n.n(S),
        j = n("cr+I"),
        k = n.n(j),
        L = n("MqDS");
      function T() {
        T = function () {
          return e;
        };
        var t,
          e = {},
          n = Object.prototype,
          r = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function u(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          u({}, "");
        } catch (t) {
          u = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function l(t, e, n, r) {
          var i = e && e.prototype instanceof g ? e : g,
            a = Object.create(i.prototype),
            c = new P(r || []);
          return o(a, "_invoke", { value: j(t, n, c) }), a;
        }
        function f(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        e.wrap = l;
        var h = "suspendedStart",
          d = "suspendedYield",
          p = "executing",
          v = "completed",
          y = {};
        function g() {}
        function m() {}
        function w() {}
        var b = {};
        u(b, a, function () {
          return this;
        });
        var _ = Object.getPrototypeOf,
          O = _ && _(_(I([])));
        O && O !== n && r.call(O, a) && (b = O);
        var E = (w.prototype = g.prototype = Object.create(b));
        function S(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function x(t, e) {
          function n(o, i, a, c) {
            var s = f(t[o], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                l = u.value;
              return l && "object" == typeof l && r.call(l, "__await")
                ? e.resolve(l.__await).then(
                    function (t) {
                      n("next", t, a, c);
                    },
                    function (t) {
                      n("throw", t, a, c);
                    },
                  )
                : e.resolve(l).then(
                    function (t) {
                      (u.value = t), a(u);
                    },
                    function (t) {
                      return n("throw", t, a, c);
                    },
                  );
            }
            c(s.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (t, r) {
              function o() {
                return new e(function (e, o) {
                  n(t, r, e, o);
                });
              }
              return (i = i ? i.then(o, o) : o());
            },
          });
        }
        function j(e, n, r) {
          var o = h;
          return function (i, a) {
            if (o === p) throw new Error("Generator is already running");
            if (o === v) {
              if ("throw" === i) throw a;
              return { value: t, done: !0 };
            }
            for (r.method = i, r.arg = a; ; ) {
              var c = r.delegate;
              if (c) {
                var s = k(c, r);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if (o === h) throw ((o = v), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              o = p;
              var u = f(e, n, r);
              if ("normal" === u.type) {
                if (((o = r.done ? v : d), u.arg === y)) continue;
                return { value: u.arg, done: r.done };
              }
              "throw" === u.type &&
                ((o = v), (r.method = "throw"), (r.arg = u.arg));
            }
          };
        }
        function k(e, n) {
          var r = n.method,
            o = e.iterator[r];
          if (o === t)
            return (
              (n.delegate = null),
              ("throw" === r &&
                e.iterator.return &&
                ((n.method = "return"),
                (n.arg = t),
                k(e, n),
                "throw" === n.method)) ||
                ("return" !== r &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + r + "' method",
                  )))),
              y
            );
          var i = f(o, e.iterator, n.arg);
          if ("throw" === i.type)
            return (
              (n.method = "throw"), (n.arg = i.arg), (n.delegate = null), y
            );
          var a = i.arg;
          return a
            ? a.done
              ? ((n[e.resultName] = a.value),
                (n.next = e.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = t)),
                (n.delegate = null),
                y)
              : a
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function L(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function A(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function P(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(L, this),
            this.reset(!0);
        }
        function I(e) {
          if (e || "" === e) {
            var n = e[a];
            if (n) return n.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (i.next = i);
            }
          }
          throw new TypeError(typeof e + " is not iterable");
        }
        return (
          (m.prototype = w),
          o(E, "constructor", { value: w, configurable: !0 }),
          o(w, "constructor", { value: m, configurable: !0 }),
          (m.displayName = u(w, s, "GeneratorFunction")),
          (e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === m || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (e.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, w)
                : ((t.__proto__ = w), u(t, s, "GeneratorFunction")),
              (t.prototype = Object.create(E)),
              t
            );
          }),
          (e.awrap = function (t) {
            return { __await: t };
          }),
          S(x.prototype),
          u(x.prototype, c, function () {
            return this;
          }),
          (e.AsyncIterator = x),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new x(l(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          S(E),
          u(E, s, "Generator"),
          u(E, a, function () {
            return this;
          }),
          u(E, "toString", function () {
            return "[object Generator]";
          }),
          (e.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (e.values = I),
          (P.prototype = {
            constructor: P,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = t),
                this.tryEntries.forEach(A),
                !e)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = "throw"),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, "catchLoc"),
                    u = r.call(a, "finallyLoc");
                  if (s && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                y
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), A(n), y;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    A(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: I(e), resultName: n, nextLoc: r }),
                "next" === this.method && (this.arg = t),
                y
              );
            },
          }),
          e
        );
      }
      function A(t) {
        return P.apply(this, arguments);
      }
      function P() {
        return (P = Object(r.default)(
          T().mark(function t(e) {
            var n, r, o, i;
            return T().wrap(function (t) {
              for (;;)
                switch ((t.prev = t.next)) {
                  case 0:
                    if ((n = e.response)) {
                      t.next = 3;
                      break;
                    }
                    return t.abrupt("return", e);
                  case 3:
                    return (
                      (r = n.ok),
                      (o = Object.assign({}, e)),
                      r ||
                        (((i = new Error(n.statusText)).response = n),
                        (i.status = n.status),
                        (i.data = e.data),
                        Object.assign(o, { error: i })),
                      t.abrupt("return", o)
                    );
                  case 7:
                  case "end":
                    return t.stop();
                }
            }, t);
          }),
        )).apply(this, arguments);
      }
      function I(t) {
        return N.apply(this, arguments);
      }
      function N() {
        return (N = Object(r.default)(
          T().mark(function t(e) {
            var n, r, o, i, a, c, s;
            return T().wrap(function (t) {
              for (;;)
                switch ((t.prev = t.next)) {
                  case 0:
                    if (((n = Object.assign({}, e)), (r = e.response))) {
                      t.next = 4;
                      break;
                    }
                    return t.abrupt("return", e);
                  case 4:
                    if (
                      ((o = r.headers),
                      (i = o.get("content-type")),
                      (a = null),
                      !/json/.test(i))
                    ) {
                      t.next = 13;
                      break;
                    }
                    return (t.next = 10), r.json();
                  case 10:
                    (a = t.sent), (t.next = 21);
                    break;
                  case 13:
                    if (!/text/.test(i)) {
                      t.next = 20;
                      break;
                    }
                    return (t.next = 16), r.text();
                  case 16:
                    c = t.sent;
                    try {
                      a = JSON.parse(c);
                    } catch (Te) {
                      a = c;
                    }
                    t.next = 21;
                    break;
                  case 20:
                    a = r || {};
                  case 21:
                    return Object.assign(n, { data: a }), (t.next = 24), A(n);
                  case 24:
                    return (s = t.sent), t.abrupt("return", s);
                  case 26:
                  case "end":
                    return t.stop();
                }
            }, t);
          }),
        )).apply(this, arguments);
      }
      function C(t) {
        return D.apply(this, arguments);
      }
      function D() {
        return (D = Object(r.default)(
          T().mark(function t(e) {
            var n, r;
            return T().wrap(function (t) {
              for (;;)
                switch ((t.prev = t.next)) {
                  case 0:
                    if (((n = e.data), !(r = e.error))) {
                      t.next = 3;
                      break;
                    }
                    throw r;
                  case 3:
                    return t.abrupt("return", n);
                  case 4:
                  case "end":
                    return t.stop();
                }
            }, t);
          }),
        )).apply(this, arguments);
      }
      function R() {
        R = function () {
          return e;
        };
        var t,
          e = {},
          n = Object.prototype,
          r = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function u(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          u({}, "");
        } catch (t) {
          u = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function l(t, e, n, r) {
          var i = e && e.prototype instanceof g ? e : g,
            a = Object.create(i.prototype),
            c = new A(r || []);
          return o(a, "_invoke", { value: j(t, n, c) }), a;
        }
        function f(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        e.wrap = l;
        var h = "suspendedStart",
          d = "suspendedYield",
          p = "executing",
          v = "completed",
          y = {};
        function g() {}
        function m() {}
        function w() {}
        var b = {};
        u(b, a, function () {
          return this;
        });
        var _ = Object.getPrototypeOf,
          O = _ && _(_(P([])));
        O && O !== n && r.call(O, a) && (b = O);
        var E = (w.prototype = g.prototype = Object.create(b));
        function S(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function x(t, e) {
          function n(o, i, a, c) {
            var s = f(t[o], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                l = u.value;
              return l && "object" == typeof l && r.call(l, "__await")
                ? e.resolve(l.__await).then(
                    function (t) {
                      n("next", t, a, c);
                    },
                    function (t) {
                      n("throw", t, a, c);
                    },
                  )
                : e.resolve(l).then(
                    function (t) {
                      (u.value = t), a(u);
                    },
                    function (t) {
                      return n("throw", t, a, c);
                    },
                  );
            }
            c(s.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (t, r) {
              function o() {
                return new e(function (e, o) {
                  n(t, r, e, o);
                });
              }
              return (i = i ? i.then(o, o) : o());
            },
          });
        }
        function j(e, n, r) {
          var o = h;
          return function (i, a) {
            if (o === p) throw new Error("Generator is already running");
            if (o === v) {
              if ("throw" === i) throw a;
              return { value: t, done: !0 };
            }
            for (r.method = i, r.arg = a; ; ) {
              var c = r.delegate;
              if (c) {
                var s = k(c, r);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if (o === h) throw ((o = v), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              o = p;
              var u = f(e, n, r);
              if ("normal" === u.type) {
                if (((o = r.done ? v : d), u.arg === y)) continue;
                return { value: u.arg, done: r.done };
              }
              "throw" === u.type &&
                ((o = v), (r.method = "throw"), (r.arg = u.arg));
            }
          };
        }
        function k(e, n) {
          var r = n.method,
            o = e.iterator[r];
          if (o === t)
            return (
              (n.delegate = null),
              ("throw" === r &&
                e.iterator.return &&
                ((n.method = "return"),
                (n.arg = t),
                k(e, n),
                "throw" === n.method)) ||
                ("return" !== r &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + r + "' method",
                  )))),
              y
            );
          var i = f(o, e.iterator, n.arg);
          if ("throw" === i.type)
            return (
              (n.method = "throw"), (n.arg = i.arg), (n.delegate = null), y
            );
          var a = i.arg;
          return a
            ? a.done
              ? ((n[e.resultName] = a.value),
                (n.next = e.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = t)),
                (n.delegate = null),
                y)
              : a
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function L(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function T(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function A(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(L, this),
            this.reset(!0);
        }
        function P(e) {
          if (e || "" === e) {
            var n = e[a];
            if (n) return n.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (i.next = i);
            }
          }
          throw new TypeError(typeof e + " is not iterable");
        }
        return (
          (m.prototype = w),
          o(E, "constructor", { value: w, configurable: !0 }),
          o(w, "constructor", { value: m, configurable: !0 }),
          (m.displayName = u(w, s, "GeneratorFunction")),
          (e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === m || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (e.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, w)
                : ((t.__proto__ = w), u(t, s, "GeneratorFunction")),
              (t.prototype = Object.create(E)),
              t
            );
          }),
          (e.awrap = function (t) {
            return { __await: t };
          }),
          S(x.prototype),
          u(x.prototype, c, function () {
            return this;
          }),
          (e.AsyncIterator = x),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new x(l(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          S(E),
          u(E, s, "Generator"),
          u(E, a, function () {
            return this;
          }),
          u(E, "toString", function () {
            return "[object Generator]";
          }),
          (e.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (e.values = P),
          (A.prototype = {
            constructor: A,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = t),
                this.tryEntries.forEach(T),
                !e)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = "throw"),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, "catchLoc"),
                    u = r.call(a, "finallyLoc");
                  if (s && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                y
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), T(n), y;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    T(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: P(e), resultName: n, nextLoc: r }),
                "next" === this.method && (this.arg = t),
                y
              );
            },
          }),
          e
        );
      }
      var M = n("r6IF"),
        F = { country: "US", language: "en", languageAlias: "" },
        U = n("WlAH"),
        G = n("2oH+"),
        B = n.n(G),
        H = { loadingState: U.a.INITIAL, error: null, data: {}, editting: {} },
        z = {
          mobileMode: !1,
          originPath: "",
          subdomain: void 0,
          withPathProject: [],
        },
        V = { settings: {}, editData: {}, translation: {} },
        W = n("KQm4");
      function q(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e &&
            (r = r.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function J(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? q(Object(n), !0).forEach(function (e) {
                Object(l.a)(t, e, n[e]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
              : q(Object(n)).forEach(function (e) {
                  Object.defineProperty(
                    t,
                    e,
                    Object.getOwnPropertyDescriptor(n, e),
                  );
                });
        }
        return t;
      }
      var Y = {
        edittingId: null,
        loadingState: U.a.INITIAL,
        error: null,
        data: {},
      };
      function K(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e &&
            (r = r.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function $(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? K(Object(n), !0).forEach(function (e) {
                Object(l.a)(t, e, n[e]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
              : K(Object(n)).forEach(function (e) {
                  Object.defineProperty(
                    t,
                    e,
                    Object.getOwnPropertyDescriptor(n, e),
                  );
                });
        }
        return t;
      }
      var X = { loadingState: U.a.INITIAL, error: null, data: {} };
      var Q = { loadingState: U.a.INITIAL, error: null, data: {} },
        Z = { loadingState: U.a.INITIAL, error: null, data: {} },
        tt = { loadingState: U.a.INITIAL, error: null, data: {} },
        et = { resize: [], scroll: [] };
      var nt = Object(O.c)({
          localization: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : F,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.SET_CONTEXT:
                return Object.assign({}, t, {
                  country: e.data.country,
                  language: e.data.language,
                  languageAlias: e.data.languageAlias,
                });
              default:
                return t;
            }
          },
          translation: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : H,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.FETCH_TRANSLATION_REQUEST:
                return Object.assign({}, t, { loadingState: U.a.LOADING });
              case M.a.FETCH_TRANSLATION_SUCCESS:
                return Object.assign({}, t, {
                  loadingState: U.a.SUCCESS,
                  data: B()(t.data, e.payload.data),
                });
              case M.a.FETCH_TRANSLATION_FAILURE:
                return Object.assign({}, t, {
                  loadingState: U.a.FAILURE,
                  error: e.payload,
                });
              case M.a.INIT_TRANSLATION:
                return Object.assign({}, t, {
                  loadingState: U.a.SUCCESS,
                  data: e.text,
                });
              case M.a.UPDATE_TRANSLATION_DATA:
                var n = Object.assign({}, t),
                  r = e.key,
                  o = e.value,
                  i = e.language,
                  a = n.data[r];
                return (
                  a || (n.data[r] = {}),
                  "object" === typeof a
                    ? (a[i] = o)
                    : (a = Object(l.a)({}, i, o)),
                  (n.data[r] = a),
                  (n.editting[r] = o),
                  n
                );
              case M.a.CLEAR_TRANSLATION_KEY:
                var c = Object.assign({}, t),
                  s = e.key;
                return delete c.data[s], delete c.editting[s], c;
              case M.a.UPDATE_EDITING_DATA:
                var u = Object.assign({}, t);
                return (
                  e.reset && (u.data = e.translation), (u.editting = {}), u
                );
              default:
                return t;
            }
          },
          context: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : z,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.SET_CONTEXT:
                return Object.assign({}, t, {
                  mobileMode: e.data.mobileMode,
                  originPath: e.data.originPath,
                  subdomain: e.data.subdomain,
                  withPathProject: e.data.env.withPathProject,
                });
              default:
                return t;
            }
          },
          editSetting: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : V,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.SET_EDIT_SETTING:
                return t.editData.id !== e.editData.id
                  ? Object.assign({}, t, {
                      settings: e.editSetting,
                      editData: e.editData,
                      originData: e.originData,
                      editType: e.editType,
                      translation: e.translation,
                    })
                  : t;
              case M.a.CLEAR_EDIT_SETTING:
                return Object.assign({}, t, {
                  settings: {},
                  editData: {},
                  editType: null,
                  translation: {},
                });
              default:
                return t;
            }
          },
          editPageData: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : Y,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.FETCH_EDIT_PAGE_DATA_REQUEST:
                return J(J({}, t), {}, { loadingState: U.a.INITIAL });
              case M.a.FETCH_EDIT_PAGE_DATA_SUCCESS:
                return J(
                  J({}, t),
                  {},
                  { loadingState: U.a.SUCCESS, data: e.payload },
                );
              case M.a.FETCH_EDIT_PAGE_DATA_FAILURE:
                return J(
                  J({}, t),
                  {},
                  { loadingState: U.a.FAILURE, error: e.payload },
                );
              case M.a.INIT_EDIT_PAGE_DATA:
                return J(
                  J({}, t),
                  {},
                  { loadingState: U.a.SUCCESS, data: e.data },
                );
              case M.a.SET_EDIT_PAGE_DATA:
                var n = J({}, t);
                return (
                  n.data.components_data.forEach(function (t) {
                    t.data.id === e.data.id &&
                      ((t.data.translation_data = e.data.translation_data),
                      (t.data.component_data = e.data.component_data));
                  }),
                  n
                );
              case M.a.UPDATE_COMPONENT_DATA:
                var r = J({}, t);
                return (
                  (r.data.components_data = Object(W.a)(
                    r.data.components_data,
                  )),
                  r.data.components_data.forEach(function (t) {
                    t.data.id === e.id &&
                      (t.data.component_data || (t.data.component_data = {}),
                      (t.data.component_data[e.name] = e.value));
                  }),
                  r
                );
              case M.a.UPDATE_EDITING_DATA:
                var o = J({}, t);
                return (
                  (o.edittingId = null),
                  o.data.components_data.forEach(function (t) {
                    e.editData.id === t.data.id && (t.data = e.editData),
                      (t.data.activeState = null);
                  }),
                  o
                );
              case M.a.ACTIVATE_COMPONENT:
                var i = J({}, t);
                return (
                  i.edittingId !== e.id &&
                    ((i.edittingId = e.id),
                    i.data.components_data.forEach(function (t) {
                      t.data.id === e.id
                        ? (t.data.activeState = "active")
                        : (t.data.activeState = "inactive");
                    })),
                  i
                );
              default:
                return t;
            }
          },
          page: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : X,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.INIT_PAGE_DATA:
                return $(
                  $({}, t),
                  {},
                  { loadingState: U.a.SUCCESS, data: e.data },
                );
              case M.a.UPDATE_EDITING_DATA:
                var n = $({}, t);
                return (
                  (n.data.components_data = Object(W.a)(
                    n.data.components_data,
                  )),
                  n.data.components_data.forEach(function (t) {
                    e.editData.id === t.data.id && (t.data = e.editData),
                      (t.data.activeState = null);
                  }),
                  n
                );
              default:
                return t;
            }
          },
          header: function () {
            var t,
              e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : X,
              n =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {},
              r = [];
            switch (n.type) {
              case M.a.INIT_HEADER_FOOTER:
                return (
                  null === (t = n.header) ||
                    void 0 === t ||
                    t.forEach(function (t) {
                      var e = {
                        title: "",
                        display_type: "",
                        link: "",
                        link_type: "",
                      };
                      t.title && (e.title = t.title),
                        t.display_type && (e.display_type = t.display_type),
                        t.link && (e.link = t.link),
                        t.link_type && (e.link_type = t.link_type),
                        r.push(e);
                    }),
                  (n.header = r),
                  $($({}, e), {}, { loadingState: U.a.SUCCESS, data: n.header })
                );
              default:
                return e;
            }
          },
          footer: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : X,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.INIT_HEADER_FOOTER:
                return $(
                  $({}, t),
                  {},
                  { loadingState: U.a.SUCCESS, data: e.footer },
                );
              default:
                return t;
            }
          },
          product: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : Q,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.FETCH_PRODUCT_REQUEST:
                return Object.assign({}, t, { loadingState: U.a.LOADING });
              case M.a.FETCH_PRODUCT_SUCCESS:
                return Object.assign({}, t, {
                  loadingState: U.a.SUCCESS,
                  data: e.payload,
                });
              case M.a.FETCH_PRODUCT_FAILURE:
                return Object.assign({}, t, {
                  loadingState: U.a.FAILURE,
                  error: e.payload,
                });
              default:
                return t;
            }
          },
          order: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : Z,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.FETCH_ORDER_REQUEST:
                return Object.assign({}, t, { loadingState: U.a.LOADING });
              case M.a.FETCH_ORDER_SUCCESS:
                return Object.assign({}, t, {
                  loadingState: U.a.SUCCESS,
                  data: e.payload,
                });
              case M.a.FETCH_ORDER_FAILURE:
                return Object.assign({}, t, {
                  loadingState: U.a.FAILURE,
                  error: e.payload,
                });
              default:
                return t;
            }
          },
          continent: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : tt,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            switch (e.type) {
              case M.a.FETCH_CONTINENTS_REQUEST:
                return Object.assign({}, t, { loadingState: U.a.LOADING });
              case M.a.FETCH_CONTINENTS_SUCCESS:
                return Object.assign({}, t, {
                  loadingState: U.a.SUCCESS,
                  data: e.payload,
                });
              case M.a.FETCH_CONTINENTS_FAILURE:
                return Object.assign({}, t, {
                  loadingState: U.a.FAILURE,
                  error: e.payload,
                });
              default:
                return t;
            }
          },
          customEventList: function () {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : et,
              e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {},
              n = e.type,
              r = e.eventName,
              o = e.eventFunc;
            switch (n) {
              case M.a.ADD_CUSTOM_EVENT:
                t[r] ? t[r].push(o) : (t[r] = [o]);
                break;
              case M.a.REMOVE_CUSTOM_EVENT:
                if (t[r]) {
                  var i = t[r].findIndex(o);
                  i > -1 && t[r].splice(i, 1);
                }
            }
            return t;
          },
        }),
        rt = [
          function (t) {
            return function (e) {
              return (function () {
                var n = Object(r.default)(
                  R().mark(function n(r) {
                    var o,
                      i,
                      a,
                      c,
                      s,
                      u,
                      l,
                      f,
                      h,
                      d,
                      p,
                      v,
                      y,
                      g,
                      m,
                      w,
                      b,
                      _,
                      O,
                      S,
                      j,
                      T,
                      A,
                      P;
                    return R().wrap(
                      function (n) {
                        for (;;)
                          switch ((n.prev = n.next)) {
                            case 0:
                              if ((o = r[L.a]) && "object" === typeof o) {
                                n.next = 3;
                                break;
                              }
                              return n.abrupt("return", e(r));
                            case 3:
                              if (
                                ((i = o.query),
                                (a = o.method),
                                (c = o.url),
                                (s = o.data),
                                (u = o.types),
                                "string" === typeof c)
                              ) {
                                n.next = 6;
                                break;
                              }
                              throw new Error("Specify a string endpoint URL");
                            case 6:
                              if (
                                Array.isArray(u) &&
                                3 === u.length &&
                                u.every(function (t) {
                                  return "string" === typeof t;
                                })
                              ) {
                                n.next = 8;
                                break;
                              }
                              throw new TypeError("expect types as an array.");
                            case 8:
                              return (
                                (l = function () {}),
                                (f = function () {}),
                                (h = Object(E.a)(u, 3)),
                                (d = h[0]),
                                (p = h[1]),
                                (v = h[2]),
                                o.isSuccess &&
                                  "function" === typeof o.isSuccess &&
                                  (l = o.isSuccess),
                                o.success &&
                                  "function" === typeof o.success &&
                                  (f = o.success),
                                e({ type: d, payload: o.data || {} }),
                                (y = {
                                  method: a || "GET",
                                  headers: {
                                    "Content-Type":
                                      "application/json; charset=utf-8",
                                  },
                                  credentials: "include",
                                  query: i,
                                  body: null,
                                }),
                                s
                                  ? (y.body = JSON.stringify(s))
                                  : delete y.body,
                                (g = k.a.stringify(i)),
                                (m = t.getState()),
                                (w = m.localization),
                                (b = w.language),
                                (_ = w.country),
                                (O = c),
                                (O += "".concat(
                                  g
                                    ? ""
                                        .concat(O.indexOf("?") < 0 ? "?" : "&")
                                        .concat(g)
                                    : "",
                                )),
                                (O += ""
                                  .concat(O.indexOf("?") < 0 ? "?" : "&")
                                  .concat(
                                    void 0 !== b ? "language=".concat(b) : "",
                                  )),
                                void 0 === k.a.parse(k.a.extract(O)).country &&
                                  (O += _ ? "&country=".concat(_) : ""),
                                (S = {
                                  options: y,
                                  url: O,
                                  response: null,
                                  error: null,
                                  data: null,
                                }),
                                (n.prev = 26),
                                (n.next = 29),
                                x()(O, y)
                              );
                            case 29:
                              (j = n.sent),
                                Object.assign(S, { response: j }),
                                (n.next = 36);
                              break;
                            case 33:
                              (n.prev = 33),
                                (n.t0 = n.catch(26)),
                                Object.assign(S, { error: n.t0 });
                            case 36:
                              return (n.next = 38), I(S);
                            case 38:
                              return (
                                (T = n.sent), (n.prev = 39), (n.next = 42), C(T)
                              );
                            case 42:
                              if (((A = n.sent), (P = l(A)))) {
                                n.next = 47;
                                break;
                              }
                              return (
                                f.call(null, T),
                                n.abrupt("return", e({ type: p, payload: A }))
                              );
                            case 47:
                              return (
                                console.log("Call Api Error:", O, P),
                                n.abrupt(
                                  "return",
                                  e({ type: v, payload: P, error: !0 }),
                                )
                              );
                            case 51:
                              return (
                                (n.prev = 51),
                                (n.t1 = n.catch(39)),
                                console.log(
                                  "Call Api Error:",
                                  O,
                                  n.t1.status,
                                  n.t1,
                                ),
                                n.abrupt(
                                  "return",
                                  e({ type: v, payload: n.t1, error: !0 }),
                                )
                              );
                            case 55:
                            case "end":
                              return n.stop();
                          }
                      },
                      n,
                      null,
                      [
                        [26, 33],
                        [39, 51],
                      ],
                    );
                  }),
                );
                return function (t) {
                  return n.apply(this, arguments);
                };
              })();
            };
          },
        ],
        ot = Object(O.d)(function (t) {
          return t;
        }),
        it = O.a.apply(void 0, rt)(O.e),
        at = n("8Kt/"),
        ct = n.n(at),
        st = n("iVi/"),
        ut = n.n(st);
      var lt = n("Ukc1");
      n("S5C5");
      var ft = n("efpO");
      var ht = n("xk4V"),
        dt = n.n(ht),
        pt = n("u11H");
      function vt() {
        vt = function () {
          return e;
        };
        var t,
          e = {},
          n = Object.prototype,
          r = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function u(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          u({}, "");
        } catch (t) {
          u = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function l(t, e, n, r) {
          var i = e && e.prototype instanceof g ? e : g,
            a = Object.create(i.prototype),
            c = new A(r || []);
          return o(a, "_invoke", { value: j(t, n, c) }), a;
        }
        function f(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        e.wrap = l;
        var h = "suspendedStart",
          d = "suspendedYield",
          p = "executing",
          v = "completed",
          y = {};
        function g() {}
        function m() {}
        function w() {}
        var b = {};
        u(b, a, function () {
          return this;
        });
        var _ = Object.getPrototypeOf,
          O = _ && _(_(P([])));
        O && O !== n && r.call(O, a) && (b = O);
        var E = (w.prototype = g.prototype = Object.create(b));
        function S(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function x(t, e) {
          function n(o, i, a, c) {
            var s = f(t[o], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                l = u.value;
              return l && "object" == typeof l && r.call(l, "__await")
                ? e.resolve(l.__await).then(
                    function (t) {
                      n("next", t, a, c);
                    },
                    function (t) {
                      n("throw", t, a, c);
                    },
                  )
                : e.resolve(l).then(
                    function (t) {
                      (u.value = t), a(u);
                    },
                    function (t) {
                      return n("throw", t, a, c);
                    },
                  );
            }
            c(s.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (t, r) {
              function o() {
                return new e(function (e, o) {
                  n(t, r, e, o);
                });
              }
              return (i = i ? i.then(o, o) : o());
            },
          });
        }
        function j(e, n, r) {
          var o = h;
          return function (i, a) {
            if (o === p) throw new Error("Generator is already running");
            if (o === v) {
              if ("throw" === i) throw a;
              return { value: t, done: !0 };
            }
            for (r.method = i, r.arg = a; ; ) {
              var c = r.delegate;
              if (c) {
                var s = k(c, r);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if (o === h) throw ((o = v), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              o = p;
              var u = f(e, n, r);
              if ("normal" === u.type) {
                if (((o = r.done ? v : d), u.arg === y)) continue;
                return { value: u.arg, done: r.done };
              }
              "throw" === u.type &&
                ((o = v), (r.method = "throw"), (r.arg = u.arg));
            }
          };
        }
        function k(e, n) {
          var r = n.method,
            o = e.iterator[r];
          if (o === t)
            return (
              (n.delegate = null),
              ("throw" === r &&
                e.iterator.return &&
                ((n.method = "return"),
                (n.arg = t),
                k(e, n),
                "throw" === n.method)) ||
                ("return" !== r &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + r + "' method",
                  )))),
              y
            );
          var i = f(o, e.iterator, n.arg);
          if ("throw" === i.type)
            return (
              (n.method = "throw"), (n.arg = i.arg), (n.delegate = null), y
            );
          var a = i.arg;
          return a
            ? a.done
              ? ((n[e.resultName] = a.value),
                (n.next = e.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = t)),
                (n.delegate = null),
                y)
              : a
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function L(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function T(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function A(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(L, this),
            this.reset(!0);
        }
        function P(e) {
          if (e || "" === e) {
            var n = e[a];
            if (n) return n.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (i.next = i);
            }
          }
          throw new TypeError(typeof e + " is not iterable");
        }
        return (
          (m.prototype = w),
          o(E, "constructor", { value: w, configurable: !0 }),
          o(w, "constructor", { value: m, configurable: !0 }),
          (m.displayName = u(w, s, "GeneratorFunction")),
          (e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === m || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (e.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, w)
                : ((t.__proto__ = w), u(t, s, "GeneratorFunction")),
              (t.prototype = Object.create(E)),
              t
            );
          }),
          (e.awrap = function (t) {
            return { __await: t };
          }),
          S(x.prototype),
          u(x.prototype, c, function () {
            return this;
          }),
          (e.AsyncIterator = x),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new x(l(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          S(E),
          u(E, s, "Generator"),
          u(E, a, function () {
            return this;
          }),
          u(E, "toString", function () {
            return "[object Generator]";
          }),
          (e.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (e.values = P),
          (A.prototype = {
            constructor: A,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = t),
                this.tryEntries.forEach(T),
                !e)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = "throw"),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, "catchLoc"),
                    u = r.call(a, "finallyLoc");
                  if (s && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                y
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), T(n), y;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    T(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: P(e), resultName: n, nextLoc: r }),
                "next" === this.method && (this.arg = t),
                y
              );
            },
          }),
          e
        );
      }
      var yt = n("yWgo"),
        gt = n("XnI8"),
        mt = n("Ntax"),
        wt = (n("nSXv"), h.a.createElement);
      function bt(t, e, n) {
        return (
          (e = Object(c.a)(e)),
          Object(a.a)(
            t,
            (function () {
              try {
                var t = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (t) {}
              return (function () {
                return !!t;
              })();
            })()
              ? Reflect.construct(e, n || [], Object(c.a)(t).constructor)
              : e.apply(t, n),
          )
        );
      }
      var _t = (function (t) {
        function e() {
          return Object(o.default)(this, e), bt(this, e, arguments);
        }
        return (
          Object(u.a)(e, t),
          Object(i.default)(e, [
            {
              key: "render",
              value: function () {
                var t = this.props,
                  e = t.t,
                  n = t.logo,
                  r = t.chrome,
                  o = t.firefox,
                  i = t.edge,
                  a = t.safair;
                return wt(
                  "div",
                  { className: "style__browserIncompatible-content___1c1_p" },
                  wt("div", { className: "style__browser-modal___FH6Pe" }),
                  wt(
                    "div",
                    { className: "style__brower-box___2zTyx" },
                    wt(
                      "div",
                      { className: "style__browser-content___1bEYn" },
                      wt(
                        "div",
                        null,
                        wt("div", {
                          className: "style__browser-dji-logo___1dy2f",
                          style: Object(mt.c)(n),
                        }),
                        wt(
                          "div",
                          { className: "style__browser-text-title___Bj-Yi" },
                          e("v1.modal.browser.title"),
                        ),
                        wt(
                          "p",
                          { className: "style__browser-text-desc___v7EoX" },
                          e("v1.modal.browser.desc"),
                        ),
                      ),
                      wt(
                        "div",
                        { className: "style__browser-list___U3Mhg" },
                        wt(
                          "div",
                          { className: "style__browser-item___1XFaD" },
                          wt(
                            "a",
                            { href: e("v1.modal.browser.chrome.link") },
                            wt("div", {
                              className: "style__browser-chrome___12_0k",
                              style: Object(mt.c)(r),
                            }),
                            wt(
                              "h4",
                              { className: "style__name___3jE11" },
                              e("v1.modal.browser.chrome.name"),
                            ),
                          ),
                        ),
                        wt(
                          "div",
                          { className: "style__browser-item___1XFaD" },
                          wt(
                            "a",
                            { href: e("v1.modal.browser.firefox.link") },
                            wt("div", {
                              className: "style__browser-fiefox___2Ieax",
                              style: Object(mt.c)(o),
                            }),
                            wt(
                              "h4",
                              { className: "style__name___3jE11" },
                              e("v1.modal.browser.firefox.name"),
                            ),
                          ),
                        ),
                        wt(
                          "div",
                          { className: "style__browser-item___1XFaD" },
                          wt(
                            "a",
                            { href: e("v1.modal.browser.safair.link") },
                            wt("div", {
                              className: "style__browser-safair___3RZmj",
                              style: Object(mt.c)(a),
                            }),
                            wt(
                              "h4",
                              { className: "style__name___3jE11" },
                              e("v1.modal.browser.safair.name"),
                            ),
                          ),
                        ),
                        wt(
                          "div",
                          { className: "style__browser-item___1XFaD" },
                          wt(
                            "a",
                            { href: e("v1.modal.browser.edge.link") },
                            wt("div", {
                              className: "style__browser-edge___1ZY3b",
                              style: Object(mt.c)(i),
                            }),
                            wt(
                              "h4",
                              { className: "style__name___3jE11" },
                              e("v1.modal.browser.edge.name"),
                            ),
                          ),
                        ),
                      ),
                    ),
                  ),
                );
              },
            },
          ]),
          e
        );
      })(h.a.PureComponent);
      Object(l.a)(_t, "defaultProps", {
        t: function () {},
        logo: "a722e747aaaffbef0c556f5125dbc802.png",
        chrome: "0bec16d49b322faacc2ea14797e3b990.jpg",
        firefox: "7d2cc073446426b7624d29155b886360.jpg",
        edge: "e64d0e3ca43f33ecf381486c6e1aa9e4.jpg",
        safair: "31f61db378d71ea41c55d5db9913045f.jpg",
      });
      var Ot = Object(gt.a)(_t),
        Et = n("iKuz"),
        St = n.n(Et),
        xt = (n("mp3y"), h.a.createElement),
        jt = {
          "./style.css": {
            "workspace-container": "style__workspace-container___UjlRD",
            "workspace-hide": "style__workspace-hide___a1mMf",
            info: "style__info___2oN47",
            hide: "style__hide___1FUw2",
            close: "style__close___2G0r8",
          },
        };
      function kt() {
        kt = function () {
          return e;
        };
        var t,
          e = {},
          n = Object.prototype,
          r = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function u(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          u({}, "");
        } catch (t) {
          u = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function l(t, e, n, r) {
          var i = e && e.prototype instanceof g ? e : g,
            a = Object.create(i.prototype),
            c = new A(r || []);
          return o(a, "_invoke", { value: j(t, n, c) }), a;
        }
        function f(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        e.wrap = l;
        var h = "suspendedStart",
          d = "suspendedYield",
          p = "executing",
          v = "completed",
          y = {};
        function g() {}
        function m() {}
        function w() {}
        var b = {};
        u(b, a, function () {
          return this;
        });
        var _ = Object.getPrototypeOf,
          O = _ && _(_(P([])));
        O && O !== n && r.call(O, a) && (b = O);
        var E = (w.prototype = g.prototype = Object.create(b));
        function S(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function x(t, e) {
          function n(o, i, a, c) {
            var s = f(t[o], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                l = u.value;
              return l && "object" == typeof l && r.call(l, "__await")
                ? e.resolve(l.__await).then(
                    function (t) {
                      n("next", t, a, c);
                    },
                    function (t) {
                      n("throw", t, a, c);
                    },
                  )
                : e.resolve(l).then(
                    function (t) {
                      (u.value = t), a(u);
                    },
                    function (t) {
                      return n("throw", t, a, c);
                    },
                  );
            }
            c(s.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (t, r) {
              function o() {
                return new e(function (e, o) {
                  n(t, r, e, o);
                });
              }
              return (i = i ? i.then(o, o) : o());
            },
          });
        }
        function j(e, n, r) {
          var o = h;
          return function (i, a) {
            if (o === p) throw new Error("Generator is already running");
            if (o === v) {
              if ("throw" === i) throw a;
              return { value: t, done: !0 };
            }
            for (r.method = i, r.arg = a; ; ) {
              var c = r.delegate;
              if (c) {
                var s = k(c, r);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if (o === h) throw ((o = v), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              o = p;
              var u = f(e, n, r);
              if ("normal" === u.type) {
                if (((o = r.done ? v : d), u.arg === y)) continue;
                return { value: u.arg, done: r.done };
              }
              "throw" === u.type &&
                ((o = v), (r.method = "throw"), (r.arg = u.arg));
            }
          };
        }
        function k(e, n) {
          var r = n.method,
            o = e.iterator[r];
          if (o === t)
            return (
              (n.delegate = null),
              ("throw" === r &&
                e.iterator.return &&
                ((n.method = "return"),
                (n.arg = t),
                k(e, n),
                "throw" === n.method)) ||
                ("return" !== r &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + r + "' method",
                  )))),
              y
            );
          var i = f(o, e.iterator, n.arg);
          if ("throw" === i.type)
            return (
              (n.method = "throw"), (n.arg = i.arg), (n.delegate = null), y
            );
          var a = i.arg;
          return a
            ? a.done
              ? ((n[e.resultName] = a.value),
                (n.next = e.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = t)),
                (n.delegate = null),
                y)
              : a
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function L(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function T(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function A(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(L, this),
            this.reset(!0);
        }
        function P(e) {
          if (e || "" === e) {
            var n = e[a];
            if (n) return n.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (i.next = i);
            }
          }
          throw new TypeError(typeof e + " is not iterable");
        }
        return (
          (m.prototype = w),
          o(E, "constructor", { value: w, configurable: !0 }),
          o(w, "constructor", { value: m, configurable: !0 }),
          (m.displayName = u(w, s, "GeneratorFunction")),
          (e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === m || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (e.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, w)
                : ((t.__proto__ = w), u(t, s, "GeneratorFunction")),
              (t.prototype = Object.create(E)),
              t
            );
          }),
          (e.awrap = function (t) {
            return { __await: t };
          }),
          S(x.prototype),
          u(x.prototype, c, function () {
            return this;
          }),
          (e.AsyncIterator = x),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new x(l(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          S(E),
          u(E, s, "Generator"),
          u(E, a, function () {
            return this;
          }),
          u(E, "toString", function () {
            return "[object Generator]";
          }),
          (e.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (e.values = P),
          (A.prototype = {
            constructor: A,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = t),
                this.tryEntries.forEach(T),
                !e)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = "throw"),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, "catchLoc"),
                    u = r.call(a, "finallyLoc");
                  if (s && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                y
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), T(n), y;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    T(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: P(e), resultName: n, nextLoc: r }),
                "next" === this.method && (this.arg = t),
                y
              );
            },
          }),
          e
        );
      }
      var Lt = function (t) {
          var e = Object(f.useState)(""),
            n = e[0],
            o = e[1],
            i = Object(f.useState)(!0),
            a = i[0],
            c = i[1],
            s = Object(f.useState)(!1),
            u = s[0],
            l = s[1],
            h = t.workspace,
            d = t.path,
            p = (function () {
              var t = Object(r.default)(
                kt().mark(function t() {
                  var e, n, r, i;
                  return kt().wrap(function (t) {
                    for (;;)
                      switch ((t.prev = t.next)) {
                        case 0:
                          return (
                            (t.next = 2),
                            fetch(
                              "/api/workspace/get-workspace?workspace="
                                .concat(h, "&path=")
                                .concat(d),
                            )
                          );
                        case 2:
                          return (e = t.sent), (t.next = 5), e.json();
                        case 5:
                          (n = t.sent).success &&
                            ((r = n.data || {}), (i = r.title) && o(i));
                        case 7:
                        case "end":
                          return t.stop();
                      }
                  }, t);
                }),
              );
              return function () {
                return t.apply(this, arguments);
              };
            })();
          Object(f.useEffect)(function () {
            h && p();
          }, []);
          var v = h
            ? "\u5f53\u524d\u9884\u89c8\u5de5\u4f5c\u533a"
                .concat(n ? "" : "id", "\uff1a")
                .concat(n || h)
            : "\u65e0\u5de5\u4f5c\u533a";
          return xt(
            "div",
            {
              style: { display: a ? "flex" : "none" },
              className: St()(
                "workspace-container ".concat(u ? "workspace-hide" : ""),
                jt,
                {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                },
              ),
            },
            xt("div", { className: "style__info___2oN47" }, v),
            xt(
              "div",
              {
                className: "style__hide___1FUw2",
                onClick: function () {
                  return l(!u);
                },
              },
              u ? "\u5c55\u5f00" : "\u6536\u8d77",
            ),
            xt(
              "div",
              {
                className: "style__close___2G0r8",
                onClick: function () {
                  return c(!1);
                },
              },
              xt(
                "svg",
                { viewBox: "0 0 8 8", xmlns: "http://www.w3.org/2000/svg" },
                xt("path", {
                  fillrule: "evenodd",
                  cliprule: "evenodd",
                  d: "M4.84609 3.99987L7.4021 1.44386L7.92921 0.916753C8.00696 0.838996 8.00696 0.712641 7.92921 0.634884L7.36522 0.0708961C7.28746 -0.00686093 7.16111 -0.00686093 7.08335 0.0708961L4.00023 3.15401L0.917119 0.0706469C0.839362 -0.00711015 0.713007 -0.00711015 0.63525 0.0706469L0.0710131 0.634634C-0.00674394 0.712391 -0.00674394 0.838747 0.0710131 0.916504L3.15438 3.99987L0.0710131 7.08298C-0.00674394 7.16074 -0.00674394 7.2871 0.0710131 7.36485L0.635001 7.92884C0.712758 8.0066 0.839113 8.0066 0.91687 7.92884L4.00023 4.84572L6.55625 7.40174L7.08335 7.92884C7.16111 8.0066 7.28746 8.0066 7.36522 7.92884L7.92921 7.36485C8.00696 7.2871 8.00696 7.16074 7.92921 7.08298L4.84609 3.99987Z",
                }),
              ),
            ),
          );
        },
        Tt = function () {},
        At = function () {};
      function Pt(t) {
        var e, n;
        for (e = 0; e < t.length; e += 1) {
          if ((n = t[e]).dataset && n.dataset.aos) return !0;
          if (n.children && Pt(n.children)) return !0;
        }
        return !1;
      }
      function It() {
        return (
          window.MutationObserver ||
          window.WebKitMutationObserver ||
          window.MozMutationObserver
        );
      }
      function Nt(t) {
        t.forEach(function (t) {
          if (Pt(Array.prototype.slice.call(t.addedNodes))) return Tt();
        });
      }
      function Ct(t) {
        t.forEach(function (t) {
          if (Pt(Array.prototype.slice.call(t.removedNodes))) return At();
        });
      }
      var Dt = {
          isSupported: function () {
            return !!It();
          },
          onUpdate: function (t) {
            var e = window.document,
              n = new (It())(Nt);
            (Tt = t),
              n.observe(e.documentElement, {
                childList: !0,
                subtree: !0,
                removedNodes: !1,
              });
          },
          onRemove: function (t) {
            var e = window.document,
              n = new (It())(Ct);
            (At = t),
              n.observe(e.documentElement, {
                childList: !0,
                subtree: !0,
                removedNodes: !0,
              });
          },
        },
        Rt = n("9/5/"),
        Mt = n.n(Rt),
        Ft = n("/+VL"),
        Ut = function (t, e) {
          if (
            t.some(function (t) {
              return !t.animated;
            })
          ) {
            var n = Ft.a.getInstance();
            if (
              t.some(function (t) {
                return t.inView;
              })
            ) {
              var r = n.getDimension(),
                o = r.pageOffsetY;
              if (!r.isFastScroll) {
                var i = r.innerHeight;
                t.forEach(function (t, n, r) {
                  !t.animated &&
                    t.inView &&
                    (function (t, e, n) {
                      var r = t.node,
                        o = r.getAttribute("data-aos-once"),
                        i = r.classList;
                      e > t.position
                        ? ((t.animated = !0), i.add("aos-animate"))
                        : "undefined" !== typeof o &&
                          ("false" === o || (!n && "true" !== o)) &&
                          (i.remove("aos-animate"), (t.animated = !1));
                    })(t, i + o, e);
                });
              }
            }
          }
        },
        Gt = function (t) {
          for (var e = 0, n = t ? t.offsetTop : void 0; !isNaN(n); )
            (e += n - ("BODY" != t.tagName ? t.scrollTop : 0)),
              (n = (t = t.offsetParent) ? t.offsetTop : void 0);
          return { top: e };
        },
        Bt = function (t, e) {
          var n = 0,
            r = 0,
            o = window.innerHeight,
            i = {
              offset: t.getAttribute("data-aos-offset"),
              anchor: t.getAttribute("data-aos-anchor"),
              anchorPlacement: t.getAttribute("data-aos-anchor-placement"),
            };
          switch (
            (i.offset && !isNaN(i.offset) && (r = parseInt(i.offset)),
            i.anchor &&
              document.querySelectorAll(i.anchor) &&
              (t = document.querySelectorAll(i.anchor)[0]),
            (n = Gt(t).top),
            i.anchorPlacement)
          ) {
            case "top-bottom":
              break;
            case "center-bottom":
              n += t.offsetHeight / 2;
              break;
            case "bottom-bottom":
              n += t.offsetHeight;
              break;
            case "top-center":
              n += o / 2;
              break;
            case "bottom-center":
              n += o / 2 + t.offsetHeight;
              break;
            case "center-center":
              n += o / 2 + t.offsetHeight / 2;
              break;
            case "top-top":
              n += o;
              break;
            case "bottom-top":
              n += t.offsetHeight + o;
              break;
            case "center-top":
              n += t.offsetHeight / 2 + o;
          }
          return i.anchorPlacement || i.offset || isNaN(e) || (r = e), n + r;
        },
        Ht = function (t, e, n) {
          return (
            t.forEach(function (t, r) {
              Ft.a.getInstance().addNode(
                t.node.parentNode,
                {
                  scrollIntoView: function () {
                    (t.inView = !0),
                      t.animated ||
                        (t.node.classList.add("aos-init"),
                        (t.position = Bt(t.node, e.offset)),
                        null === n || void 0 === n || n());
                  },
                  scrollOutOfWiew: function () {
                    t.inView = !1;
                  },
                },
                void 0,
                100,
                !0,
                0.5,
              );
            }),
            t
          );
        },
        zt = function t() {
          var e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : [],
            n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            r =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : {},
            o = [];
          (t.durations && t.delays) || ((t.durations = {}), (t.delays = {})),
            e.forEach(function (e) {
              var o = e.node;
              if (o && o.dataset) {
                var i = o.dataset,
                  a = i.aosDuration,
                  c = i.aosDelay;
                a && !t.durations[a] && (n[a] = "exists"),
                  c && !t.delays[c] && (r[c] = "exists");
              }
            });
          var i = Object.keys(n);
          i.forEach(function (e) {
            t.durations[e] = "exists";
            var n = parseFloat(e) / 1e3,
              r = '\n        [data-aos][data-aos][data-aos-duration="'
                .concat(e, '"],\n        body[data-aos-duration="')
                .concat(e, '"] [data-aos] {\n          transition-duration: ')
                .concat(n, "s\n        }");
            o.push(r);
          });
          var a = Object.keys(r);
          if (
            (a.forEach(function (e) {
              t.delays[e] = "exists";
              var n = parseFloat(e) / 1e3,
                r = '\n        [data-aos][data-aos][data-aos-delay="'
                  .concat(e, '"],\n        body[data-aos-delay="')
                  .concat(
                    e,
                    '"] [data-aos] {\n          transition-delay: 0\n        }\n\n        [data-aos][data-aos][data-aos-delay="',
                  )
                  .concat(e, '"].aos-animate,\n        body[data-aos-delay="')
                  .concat(
                    e,
                    '"] [data-aos].aos-animate {\n          transition-delay: ',
                  )
                  .concat(n, "s\n        }");
              o.push(r);
            }),
            o.length)
          ) {
            var c = document.createElement("style");
            (c.type = "text/css"),
              c.setAttribute("data-aos-css-durations", i.join("-")),
              c.setAttribute("data-aos-css-delays", a.join("-")),
              (c.innerHTML = o.join("\n")),
              document.getElementsByTagName("head")[0].appendChild(c);
          }
        },
        Vt = function (t, e) {
          var n = document.querySelectorAll('[data-aos]:not([data-aos="none"]');
          if (t) {
            var r = !1;
            return (
              (n = document.querySelectorAll(
                '[data-aos]:not([data-aos="none"]',
              )).forEach(function (e) {
                if (
                  -1 ===
                  t.findIndex(function (t) {
                    return t.node.isSameNode(e);
                  })
                ) {
                  r = !0;
                  var n = [{ node: e }];
                  zt(n), t.push.apply(t, n);
                }
              }),
              r && e(!0),
              t
            );
          }
          var o = Array.prototype.map.call(n, function (t) {
            return { node: t };
          });
          return zt(o), o;
        },
        Wt = [],
        qt = {
          offset: 120,
          delay: 0,
          easing: "ease",
          duration: 400,
          disable: !1,
          once: !0,
          startEvent: "DOMContentLoaded",
          throttleDelay: 99,
          debounceDelay: 1e3,
          disableMutationObserver: !1,
        },
        Jt = function () {
          return (
            (Wt = Ht(Wt, qt)),
            setTimeout(function () {
              Ut(Wt, qt.once);
            }, 100),
            Wt
          );
        },
        Yt = function () {
          Wt = Vt(Wt, Jt);
        },
        Kt = function () {
          (Wt = Vt()), Jt();
        },
        $t = function (t) {
          (qt.once = !0), (qt = Object.assign(qt, t)), (Wt = Vt());
          var e,
            n = document.all && !window.atob;
          return !0 === (e = qt.disable) ||
            ("function" === typeof e && !0 === e()) ||
            n
            ? (Wt.forEach(function (t, e) {
                t.node.removeAttribute("data-aos"),
                  t.node.removeAttribute("data-aos-easing"),
                  t.node.removeAttribute("data-aos-duration"),
                  t.node.removeAttribute("data-aos-delay");
              }),
              void Ft.a
                .getInstance()
                .getDimension()
                .removeDimensionListener("aos"))
            : (qt.disableMutationObserver ||
                Dt.isSupported() ||
                (console.info(
                  '\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "onMutationChange()" by yourself.\n    ',
                ),
                (qt.disableMutationObserver = !0)),
              (document.querySelector("body").dataset.aosEasing = qt.easing),
              (document.querySelector("body").dataset.aosDuration =
                qt.duration),
              (document.querySelector("body").dataset.aosDelay = qt.delay),
              zt(
                [],
                Object(l.a)(
                  Object(l.a)({}, qt.duration, "exists"),
                  qt.delay,
                  "exists",
                ),
              ),
              "DOMContentLoaded" === qt.startEvent &&
              ["complete", "interactive"].includes(document.readyState)
                ? Jt()
                : "load" === qt.startEvent
                  ? window.addEventListener(qt.startEvent, function () {
                      Jt();
                    })
                  : document.addEventListener(qt.startEvent, function () {
                      Jt();
                    }),
              Ft.a
                .getInstance()
                .getDimension()
                .addDimensionListener("aos", {
                  onScroll: function () {
                    Ut(Wt, qt.once);
                  },
                  onScrollEnd: function () {
                    Ut(Wt, qt.once);
                  },
                  onResize: Jt,
                  onRotate: Jt,
                }),
              qt.disableMutationObserver ||
                (Dt.onRemove(Mt()(Kt, qt.debounceDelay, !0)),
                Dt.onUpdate(Mt()(Yt, qt.debounceDelay, !0))),
              window && (window.onNodeRemove = Kt),
              Wt);
        };
      function Xt(t, e) {
        var n =
          ("undefined" !== typeof Symbol && t[Symbol.iterator]) ||
          t["@@iterator"];
        if (!n) {
          if (
            Array.isArray(t) ||
            (n = (function (t, e) {
              if (!t) return;
              if ("string" === typeof t) return Qt(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              "Object" === n && t.constructor && (n = t.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(t);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return Qt(t, e);
            })(t)) ||
            (e && t && "number" === typeof t.length)
          ) {
            n && (t = n);
            var r = 0,
              o = function () {};
            return {
              s: o,
              n: function () {
                return r >= t.length
                  ? { done: !0 }
                  : { done: !1, value: t[r++] };
              },
              e: function (t) {
                throw t;
              },
              f: o,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var i,
          a = !0,
          c = !1;
        return {
          s: function () {
            n = n.call(t);
          },
          n: function () {
            var t = n.next();
            return (a = t.done), t;
          },
          e: function (t) {
            (c = !0), (i = t);
          },
          f: function () {
            try {
              a || null == n.return || n.return();
            } finally {
              if (c) throw i;
            }
          },
        };
      }
      function Qt(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
      }
      var Zt = (function () {
          function t() {
            var e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {};
            return (
              Object(o.default)(this, t),
              t.instance
                ? (t.instance.debug("already consturcted."), t.instance)
                : ((t.instance = this), this.init(e), this)
            );
          }
          return (
            Object(i.default)(
              t,
              [
                {
                  key: "init",
                  value: function () {
                    var t = this,
                      e =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : {},
                      n = {
                        maxPrefetchOnLoadLimit: 1,
                        maxPrefetchOnVisibleLimit: 5,
                        hoverDelay: 300,
                        maxHoverPrefetchLimit: 3,
                        maxTouchStartOrMouseDownPrefetchLimit: 3,
                        prefetchDocumentWhitelistReg:
                          /REGEXP_MATCH_WHITE_LIST_IS_DISABLED/,
                        maxPrefetchMainDocumentCount: 3,
                        prefetchMainDocumentOnVisible: !1,
                        prefetchMainDocumentOnHover: !1,
                        prefetchMainDocumentOnTouchStartOrMouseDown: !1,
                        APIURL: "http://localhost:1338/api/prophet",
                        debug: !1,
                        enable: !0,
                        minLoadEnableThreshold: 800,
                        maxLoadEnableThreshold: 5e3,
                      },
                      r = Object.assign({}, n, e);
                    "string" === typeof r.prefetchDocumentWhitelistReg &&
                      (r.prefetchDocumentWhitelistReg = new RegExp(
                        r.prefetchDocumentWhitelistReg,
                      )),
                      (this.config = {
                        maxPrefetchOnLoadLimit: r.maxPrefetchOnLoadLimit,
                        maxPrefetchOnVisibleLimit: r.maxPrefetchOnVisibleLimit,
                        hoverDelay: r.hoverDelay,
                        maxHoverPrefetchLimit: r.maxHoverPrefetchLimit,
                        maxTouchStartOrMouseDownPrefetchLimit:
                          r.maxTouchStartOrMouseDownPrefetchLimit,
                        prefetchDocumentWhitelistReg:
                          r.prefetchDocumentWhitelistReg,
                        maxPrefetchMainDocumentCount:
                          r.maxPrefetchMainDocumentCount,
                        prefetchMainDocumentOnVisible:
                          r.prefetchMainDocumentOnVisible,
                        prefetchMainDocumentOnHover:
                          r.prefetchMainDocumentOnHover,
                        prefetchMainDocumentOnTouchStartOrMouseDown:
                          r.prefetchMainDocumentOnTouchStartOrMouseDown,
                        APIURL: r.APIURL,
                        debug: r.debug,
                        enable: r.enable,
                        minLoadEnableThreshold: r.minLoadEnableThreshold,
                        maxLoadEnableThreshold: r.maxLoadEnableThreshold,
                      }),
                      (this.predictionData = []),
                      (this.linkVisibleObserver = []),
                      (this.prefetchedResource = {}),
                      (this.prefetchOnVisibleCount = 0),
                      (this.prefetchOnHoverCount = 0),
                      (this.hoverActivatedDOM = new Set()),
                      (this.prefetchOnTouchStartOrMouseDownCount = 0),
                      (this.touchActivatedDOM = new Set()),
                      (this.prefetchMainDocumentCount = 0),
                      (this.prefetchedMainDocument = {}),
                      (this.shoulEnablePrefetch =
                        this.determineShouldEnablePrefetch()),
                      this.shoulEnablePrefetch &&
                        (this.addForEachPolyfill(),
                        this.detectPrefetchCompatibility(),
                        this.detectAlreadyPreloadedResources(),
                        (this.predictionPromise = this.fetchPredictionAndConfig(
                          this.config.APIURL,
                        )),
                        this.predictionPromise.then(
                          function () {
                            t.debug("Prediction map get, resolved."),
                              t.prefetchTopPageOnLoad(),
                              t.observeAllLinksVisibility(),
                              t.initMouseOverEventHandler(),
                              t.initMouseDownOrTouchStartEventHandler(),
                              t.initHitRateTracker();
                          },
                          function (e) {
                            t.debug("Rejected, reason:", e);
                          },
                        ));
                  },
                },
                {
                  key: "checkIsFireFox",
                  value: function () {
                    if ("undefined" !== typeof this.checkIsFireFox.cache)
                      return this.checkIsFireFox.cache;
                    var t = window.navigator.userAgent;
                    return (
                      (this.checkIsFireFox.cache = /firefox/i.test(t)),
                      this.checkIsFireFox.cache
                    );
                  },
                },
                {
                  key: "checkIsSafari",
                  value: function () {
                    if ("undefined" !== typeof this.checkIsSafari.cache)
                      return this.checkIsSafari.cache;
                    var t = window.navigator.userAgent;
                    return (
                      (this.checkIsSafari.cache =
                        /Safari/i.test(t) && !/Chrome/i.test(t)),
                      this.checkIsSafari.cache
                    );
                  },
                },
                {
                  key: "checkIsIE",
                  value: function () {
                    if ("undefined" !== typeof this.checkIsIE.cache)
                      return this.checkIsIE.cache;
                    var t = !1,
                      e = window.navigator.userAgent,
                      n = e.indexOf("MSIE "),
                      r = e.indexOf("Trident/"),
                      o = e.indexOf("Edge/");
                    return (
                      (n > 0 || r > 0 || o > 0) && (t = !0),
                      (this.checkIsIE.cache = t),
                      this.checkIsIE.cache
                    );
                  },
                },
                {
                  key: "determineShouldEnablePrefetch",
                  value: function () {
                    var t = !0;
                    !1 === this.config.enable && (t = !1);
                    var e = window.location.search;
                    if (
                      (/prophet-client=disable/.test("".concat(e)) && (t = !1),
                      window.navigator.connection &&
                        window.navigator.connection.saveData &&
                        (t = !1),
                      this.config.minLoadEnableThreshold >= 0 &&
                        this.config.maxLoadEnableThreshold >= 0)
                    ) {
                      var n = 0;
                      window.performance &&
                        (window.performance.getEntriesByType("navigation")[0]
                          ? (n = Math.round(
                              window.performance.getEntriesByType(
                                "navigation",
                              )[0].loadEventStart,
                            ))
                          : window.performance.timing &&
                            (n = Math.round(
                              window.performance.timing.loadEventStart -
                                window.performance.timing.navigationStart,
                            ))),
                        this.debug("loadEventStartTime>>>", n),
                        (this.config.minLoadEnableThreshold > n ||
                          this.config.maxLoadEnableThreshold < n) &&
                          (t = !1);
                    }
                    return this.debug("shouldEnableProphetClient>>>", t), t;
                  },
                },
                {
                  key: "debug",
                  value: function () {
                    var t;
                    if (this.config.debug) {
                      for (
                        var e = arguments.length, n = new Array(e), r = 0;
                        r < e;
                        r++
                      )
                        n[r] = arguments[r];
                      (t = console).log.apply(
                        t,
                        ["[PROPHET-CLIENT]"].concat(n),
                      );
                    }
                  },
                },
                {
                  key: "addForEachPolyfill",
                  value: function () {
                    window.NodeList &&
                      !NodeList.prototype.forEach &&
                      (NodeList.prototype.forEach = Array.prototype.forEach);
                  },
                },
                {
                  key: "detectAlreadyPreloadedResources",
                  value: function () {
                    var t = this;
                    document
                      .querySelectorAll("link[rel=preload")
                      .forEach(function (e) {
                        var n = e.getAttribute("href");
                        t.prefetchedResource[n] = !0;
                      });
                    var e = /^PROPHET_CLINET_PREFETCH_/;
                    Object.keys(sessionStorage).forEach(function (n) {
                      if (e.test(n)) {
                        var r = n.replace(e, "");
                        t.prefetchedResource[r] = !0;
                      }
                    }),
                      this.debug(
                        "detectAlreadyPreloadedResources this.prefetchedResource is",
                        this.prefetchedResource,
                      );
                  },
                },
                {
                  key: "detectPrefetchCompatibility",
                  value: function () {
                    this.relPrefetch =
                      this.hasRel("preload") && !this.hasRel("prefetch")
                        ? "preload"
                        : "prefetch";
                  },
                },
                {
                  key: "hasRel",
                  value: function (t, e) {
                    try {
                      return document.createElement("link").relList.supports(t);
                    } catch (Te) {}
                  },
                },
                {
                  key: "prefetchTopPageOnLoad",
                  value: function () {
                    for (
                      var t = 0;
                      t < this.config.maxPrefetchOnLoadLimit;
                      t++
                    ) {
                      var e = this.getPredictionFromIndex(t);
                      if (e) {
                        var n = e.pagePath,
                          r = this.prefetchAPage(n, !1);
                        this.debug(
                          "STAGE1 Prefetch Status: "
                            .concat(r, ", pagePath:")
                            .concat(n, ", index:")
                            .concat(t),
                        );
                      } else
                        this.debug(
                          "STAGE1 Prefetch nextPage not found for index:".concat(
                            t,
                            ", not prefetching.",
                          ),
                        );
                    }
                  },
                },
                {
                  key: "fetchPredictionAndConfig",
                  value: function (t) {
                    var e = this;
                    return new Promise(function (n, r) {
                      try {
                        var o = new XMLHttpRequest(),
                          i = window.location,
                          a = i.hostname,
                          c = i.pathname;
                        o.open(
                          "get",
                          ""
                            .concat(t, "?hostname=")
                            .concat(a, "&pathname=")
                            .concat(c),
                        ),
                          (o.withCredentials = !0),
                          (o.onreadystatechange = function () {
                            try {
                              if (4 === o.readyState) {
                                var t = o.status;
                                if (0 === t || 200 === t) {
                                  var i = JSON.parse(o.responseText);
                                  (e.predictionData = i),
                                    i &&
                                      i.config &&
                                      Object.assign(e.config, i.config),
                                    e.debug("this.config >>> ", e.config),
                                    e.debug(
                                      "this.predictionData >>> ",
                                      e.predictionData,
                                    ),
                                    n(i);
                                } else r(o);
                              }
                            } catch (Te) {
                              r(Te);
                            }
                          }),
                          o.send();
                      } catch (Te) {
                        r(Te);
                      }
                    });
                  },
                },
                {
                  key: "observeAllLinksVisibility",
                  value: function () {
                    var t = this;
                    "function" === typeof IntersectionObserver &&
                      "function" === typeof IntersectionObserverEntry &&
                      0 !== this.predictionData.nextPages.length &&
                      (document
                        .querySelectorAll("a[href]")
                        .forEach(function (e) {
                          t.observeLinks(e);
                        }),
                      (this.DOMMutationObserver = new MutationObserver(
                        function (e) {
                          var n,
                            r = Xt(e);
                          try {
                            for (r.s(); !(n = r.n()).done; ) {
                              var o = n.value;
                              "childList" === o.type &&
                                o.addedNodes.length > 0 &&
                                o.addedNodes.forEach(function (e) {
                                  "function" === typeof e.querySelectorAll &&
                                    e
                                      .querySelectorAll("a[href]")
                                      .forEach(function (e) {
                                        t.observeLinks(e);
                                      });
                                });
                            }
                          } catch (i) {
                            r.e(i);
                          } finally {
                            r.f();
                          }
                        },
                      )),
                      this.DOMMutationObserver.observe(document.body, {
                        attributes: !1,
                        childList: !0,
                        subtree: !0,
                      }));
                  },
                },
                {
                  key: "observeLinks",
                  value: function (t) {
                    var e = this,
                      n = new IntersectionObserver(function (t) {
                        t.forEach(function (t) {
                          if (
                            (e.prefetchOnVisibleCount >=
                              e.config.maxPrefetchOnVisibleLimit &&
                              e.linkVisibleObserver.length > 0 &&
                              e.DOMMutationObserver &&
                              (e.debug(
                                "STAGE2 this.config.maxPrefetchOnVisibleLimit reached, disconnecting all the observers.",
                              ),
                              e.linkVisibleObserver.forEach(function (t) {
                                t.disconnect();
                              }),
                              (e.linkVisibleObserver = []),
                              e.DOMMutationObserver.disconnect(),
                              delete e.DOMMutationObserver),
                            t.isIntersecting)
                          ) {
                            n.disconnect();
                            for (
                              var r = t.target.getAttribute("href"),
                                o = e.hrefKeyGenerator(r),
                                i = 0;
                              i < e.config.maxPrefetchOnVisibleLimit &&
                              i < e.predictionData.nextPages.length &&
                              e.prefetchOnVisibleCount <
                                e.config.maxPrefetchOnVisibleLimit;
                              i++
                            )
                              if (
                                e.predictionData.nextPages[i].pagePath === o
                              ) {
                                var a = !1;
                                e.config.prefetchMainDocumentOnVisible &&
                                  e.prefetchMainDocumentCount <
                                    e.config.maxPrefetchMainDocumentCount &&
                                  (a = !0);
                                var c = e.doPrefetch(r, t.target, a);
                                e.debug(
                                  "STAGE2 entry.isIntersecting. shouldPrefetchMainDocument"
                                    .concat(a, ", result: ")
                                    .concat(c, ", href:")
                                    .concat(r, ", hrefKey:")
                                    .concat(o, ", index:")
                                    .concat(i, ", entry.target:"),
                                  t.target,
                                ),
                                  c &&
                                    ((e.prefetchOnVisibleCount += 1),
                                    a && (e.prefetchMainDocumentCount += 1));
                              }
                          }
                        });
                      });
                    n.observe(t), this.linkVisibleObserver.push(n);
                  },
                },
                {
                  key: "initMouseOverEventHandler",
                  value: function () {
                    var t = this;
                    document.addEventListener("mouseover", function e(n) {
                      t.prefetchOnHoverCount >= t.config.maxHoverPrefetchLimit
                        ? (t.debug(
                            "STAGE3 this.config.maxHoverPrefetchLimit reached, removing event handler.",
                          ),
                          document.removeEventListener("mouseover", e))
                        : t.mouseOverElementHandler(n.target);
                    });
                  },
                },
                {
                  key: "mouseOverElementHandler",
                  value: function (t) {
                    var e = this;
                    if (t && this.predictionData && this.isElement(t))
                      if (this.hoverActivatedDOM.has(t))
                        this.debug(
                          "STAGE3 MouseOver target alerady activated, won't activate again. >>>",
                          t,
                        );
                      else {
                        var n = t.getAttribute("href");
                        if (!n)
                          return this.isElement(t.parentNode)
                            ? this.mouseOverElementHandler(t.parentNode)
                            : void 0;
                        var r = setTimeout(function () {
                          e.debug("STAGE3 MouseOver Trigger >>>", t);
                          var r = !1;
                          e.config.prefetchMainDocumentOnHover &&
                            e.prefetchMainDocumentCount <
                              e.config.maxPrefetchMainDocumentCount &&
                            (r = !0);
                          var o = e.doPrefetch(n, t, r);
                          e.debug("STAGE3 MouseOver Trigger Result >>>", o),
                            o &&
                              (e.hoverActivatedDOM.add(t),
                              (e.prefetchOnHoverCount += 1),
                              r && (e.prefetchMainDocumentCount += 1));
                        }, this.config.hoverDelay);
                        t.addEventListener("mouseout", function e() {
                          clearTimeout(r), t.removeEventListener("mouseout", e);
                        });
                      }
                  },
                },
                {
                  key: "initMouseDownOrTouchStartEventHandler",
                  value: function () {
                    var t = this,
                      e = function e(n) {
                        t.prefetchOnTouchStartOrMouseDownCount >=
                        t.config.maxTouchStartOrMouseDownPrefetchLimit
                          ? (t.debug(
                              "STAGE4 this.config.maxTouchStartOrMouseDownPrefetchLimit reached, removing event handler.",
                            ),
                            document.removeEventListener("mousedown", e),
                            document.removeEventListener("touchstart", e))
                          : t.touchStartOrMouseDownELementHandler(n.target);
                      };
                    document.addEventListener("mousedown", e),
                      document.addEventListener("touchstart", e);
                  },
                },
                {
                  key: "touchStartOrMouseDownELementHandler",
                  value: function (t) {
                    if (t && this.predictionData && this.isElement(t))
                      if (this.touchActivatedDOM.has(t))
                        this.debug(
                          "STAGE4 touchStartOrMouseDown target alerady activated, won't activate again. >>>",
                          t,
                        );
                      else {
                        var e = t.getAttribute("href");
                        if (!e)
                          return this.isElement(t.parentNode)
                            ? this.touchStartOrMouseDownELementHandler(
                                t.parentNode,
                              )
                            : void 0;
                        var n = !1;
                        this.config
                          .prefetchMainDocumentOnTouchStartOrMouseDown &&
                          this.prefetchMainDocumentCount <
                            this.config.maxPrefetchMainDocumentCount &&
                          (n = !0),
                          this.debug(
                            "STAGE4 touchStartOrMouseDown Trigger >>>",
                            e,
                            t,
                            t,
                            n,
                          );
                        var r = this.doPrefetch(e, t, n);
                        r &&
                          (this.touchActivatedDOM.add(t),
                          (this.prefetchOnTouchStartOrMouseDownCount += 1),
                          n && (this.prefetchMainDocumentCount += 1)),
                          this.debug(
                            "STAGE4 touchStartOrMouseDown Result, this.prefetchOnTouchStartOrMouseDownCount",
                            r,
                            this.prefetchOnTouchStartOrMouseDownCount,
                          );
                      }
                  },
                },
                {
                  key: "initHitRateTracker",
                  value: function () {
                    var t = this;
                    if ("function" === typeof ga) {
                      document.addEventListener("click", function e(n) {
                        var r = n.target || n;
                        if (r && t.predictionData && t.isElement(r)) {
                          var o = r.getAttribute("href");
                          if (!o)
                            return t.isElement(r.parentNode)
                              ? e(r.parentNode)
                              : void 0;
                          var i = {
                            hitType: "event",
                            eventCategory: "Prophet-Client-Path-".concat(
                              window.location.pathname,
                            ),
                            eventAction: "predict-".concat(o),
                            eventLabel: t.prefetchedMainDocument[o]
                              ? "success"
                              : "fail",
                          };
                          t.debug("sending GA event >>>>", i), ga("send", i);
                        }
                      });
                    }
                  },
                },
                {
                  key: "doPrefetch",
                  value: function (t, e, n) {
                    var r = this.prefetchAPage(t, n);
                    return (
                      this.debug(
                        "href, dom, prefetchMainDocument, prefetchSuccess >>>",
                        t,
                        e,
                        n,
                        r,
                      ),
                      this.config.debug &&
                        (r || this.prefetchedMainDocument[t]
                          ? (e.style.background = n
                              ? "rgba(255,0,0,0.3)"
                              : "rgba(255,255,0,0.3)")
                          : (e.style.background = "rgba(0,255,255,0.3) ")),
                      r
                    );
                  },
                },
                {
                  key: "prefetchAPage",
                  value: function (t) {
                    var e = this,
                      n =
                        arguments.length > 1 &&
                        void 0 !== arguments[1] &&
                        arguments[1];
                    if (this.prefetchedMainDocument[t])
                      return (
                        this.debug(
                          "prefetchAPage tthis.prefetchedMainDocument[href] is "
                            .concat(
                              this.prefetchedMainDocument[t],
                              ", returning.(href: ",
                            )
                            .concat(t, ")"),
                        ),
                        !1
                      );
                    var r = this.hrefKeyGenerator(t),
                      o = this.getPredictionSkeleton(r),
                      i = Array.isArray(o) && o.length > 0,
                      a = this.config.prefetchDocumentWhitelistReg.test(t);
                    if (
                      /javascript\:\;/.test(r) ||
                      "" === r ||
                      window.location.pathname === r
                    )
                      return (
                        this.debug(
                          "prefetchAPage not prefetching because ther href is invalid. >>> ",
                          t,
                        ),
                        !1
                      );
                    if (!i && /^(\/\/|http:\/\/|https:\/\/)/.test(t) && !a)
                      return (
                        this.debug(
                          "prefetchAPage not prefetching because this.config.prefetchDocumentWhitelistReg not match >>> ",
                          t,
                        ),
                        !1
                      );
                    this.debug("prefetchAPage href,hrefKey >>> ", t, r);
                    var c = [],
                      s = !1,
                      u = !1;
                    this.checkIsSafari() ||
                      this.checkIsFireFox() ||
                      this.checkIsIE() ||
                      !n ||
                      (!i && !a) ||
                      (this.debug("prefetchAPage prefetchMainDocument >>> ", r),
                      c.push(this.prefetchNodeGenerator(t, !1, "document")),
                      (this.prefetchedMainDocument[t] = !0),
                      (s = !0)),
                      i &&
                        (this.debug("prefetchAPage nextPageSkeleton >>>", o),
                        o.forEach(function (t) {
                          var n = t.url;
                          "image" === t.as &&
                            window.devicePixelRatio > 1 &&
                            /@1x\./.test(n) &&
                            (n = n.replace("@1x", "")),
                            e.prefetchedResource[n] ||
                              t.cors ||
                              (c.push(e.prefetchNodeGenerator(n, t.cors, t.as)),
                              (e.prefetchedResource[n] = !0));
                        }),
                        (u = !0)),
                      u ||
                        this.debug(
                          "prefetchAPage pageSkeleton not found >>> ",
                          r,
                        );
                    for (
                      var l = function () {
                          var t = c.slice(f, f + 5),
                            e = document.createDocumentFragment();
                          t.forEach(function (t) {
                            e.appendChild(t);
                          });
                          var n = function () {
                            document.head.appendChild(e);
                          };
                          window.requestIdleCallback
                            ? window.requestIdleCallback(n)
                            : setTimeout(n, 5 * f);
                        },
                        f = 0;
                      f < c.length;
                      f += 5
                    )
                      l();
                    this.syncPrefetchedResourceToStorage();
                    var h = !1;
                    return n ? s && (h = !0) : (h = u), h;
                  },
                },
                {
                  key: "syncPrefetchedResourceToStorage",
                  value: function () {
                    Object.keys(this.prefetchedResource).forEach(function (t) {
                      sessionStorage.setItem(
                        "PROPHET_CLINET_PREFETCH_".concat(t),
                        "true",
                      );
                    });
                  },
                },
                {
                  key: "getPredictionFromIndex",
                  value: function (t) {
                    return this.predictionData &&
                      Array.isArray(this.predictionData.nextPages) &&
                      this.predictionData.nextPages.length > 0
                      ? this.predictionData.nextPages[t]
                      : null;
                  },
                },
                {
                  key: "getPredictionSkeleton",
                  value: function (t) {
                    if (
                      this.predictionData &&
                      Array.isArray(this.predictionData.nextPages)
                    ) {
                      var e,
                        n = Xt(this.predictionData.nextPages);
                      try {
                        for (n.s(); !(e = n.n()).done; ) {
                          var r = e.value;
                          if (r.pagePath === t && Array.isArray(r.pageSkeleton))
                            return r.pageSkeleton;
                        }
                      } catch (o) {
                        n.e(o);
                      } finally {
                        n.f();
                      }
                    }
                    return null;
                  },
                },
                {
                  key: "isElement",
                  value: function (t) {
                    return (
                      t instanceof Element ||
                      (t instanceof HTMLDocument &&
                        "function" === typeof t.getAttribute)
                    );
                  },
                },
                {
                  key: "hrefKeyGenerator",
                  value: function (t) {
                    var e = t;
                    return (
                      /\?.*$/.test(t) && (e = t.replace(/\?.*$/, "")),
                      /\#.*$/.test(t) && (e = e.replace(/\#.*$/, "")),
                      "" ===
                        (e = (e = e.replace(
                          window.location.origin,
                          "",
                        )).replace(/\/$/, "")) && (e = "/"),
                      e
                    );
                  },
                },
                {
                  key: "prefetchNodeGenerator",
                  value: function (t, e, n) {
                    var r = document.createElement("link");
                    return (
                      (r.rel = this.relPrefetch),
                      (r.href = t),
                      e && r.setAttribute("crossorgin", "anonymous"),
                      n && (r.as = n),
                      r
                    );
                  },
                },
              ],
              [
                {
                  key: "getInstance",
                  value: function () {
                    var e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : {};
                    return new t(e);
                  },
                },
              ],
            ),
            t
          );
        })(),
        te = n("dhHj"),
        ee = n("p46w"),
        ne = n.n(ee),
        re = (n("lrw0"), n("RpOT"), n("0b+E"));
      n("m40j");
      function oe() {
        oe = function () {
          return e;
        };
        var t,
          e = {},
          n = Object.prototype,
          r = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function u(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          u({}, "");
        } catch (t) {
          u = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function l(t, e, n, r) {
          var i = e && e.prototype instanceof g ? e : g,
            a = Object.create(i.prototype),
            c = new A(r || []);
          return o(a, "_invoke", { value: j(t, n, c) }), a;
        }
        function f(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        e.wrap = l;
        var h = "suspendedStart",
          d = "suspendedYield",
          p = "executing",
          v = "completed",
          y = {};
        function g() {}
        function m() {}
        function w() {}
        var b = {};
        u(b, a, function () {
          return this;
        });
        var _ = Object.getPrototypeOf,
          O = _ && _(_(P([])));
        O && O !== n && r.call(O, a) && (b = O);
        var E = (w.prototype = g.prototype = Object.create(b));
        function S(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function x(t, e) {
          function n(o, i, a, c) {
            var s = f(t[o], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                l = u.value;
              return l && "object" == typeof l && r.call(l, "__await")
                ? e.resolve(l.__await).then(
                    function (t) {
                      n("next", t, a, c);
                    },
                    function (t) {
                      n("throw", t, a, c);
                    },
                  )
                : e.resolve(l).then(
                    function (t) {
                      (u.value = t), a(u);
                    },
                    function (t) {
                      return n("throw", t, a, c);
                    },
                  );
            }
            c(s.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (t, r) {
              function o() {
                return new e(function (e, o) {
                  n(t, r, e, o);
                });
              }
              return (i = i ? i.then(o, o) : o());
            },
          });
        }
        function j(e, n, r) {
          var o = h;
          return function (i, a) {
            if (o === p) throw new Error("Generator is already running");
            if (o === v) {
              if ("throw" === i) throw a;
              return { value: t, done: !0 };
            }
            for (r.method = i, r.arg = a; ; ) {
              var c = r.delegate;
              if (c) {
                var s = k(c, r);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if (o === h) throw ((o = v), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              o = p;
              var u = f(e, n, r);
              if ("normal" === u.type) {
                if (((o = r.done ? v : d), u.arg === y)) continue;
                return { value: u.arg, done: r.done };
              }
              "throw" === u.type &&
                ((o = v), (r.method = "throw"), (r.arg = u.arg));
            }
          };
        }
        function k(e, n) {
          var r = n.method,
            o = e.iterator[r];
          if (o === t)
            return (
              (n.delegate = null),
              ("throw" === r &&
                e.iterator.return &&
                ((n.method = "return"),
                (n.arg = t),
                k(e, n),
                "throw" === n.method)) ||
                ("return" !== r &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + r + "' method",
                  )))),
              y
            );
          var i = f(o, e.iterator, n.arg);
          if ("throw" === i.type)
            return (
              (n.method = "throw"), (n.arg = i.arg), (n.delegate = null), y
            );
          var a = i.arg;
          return a
            ? a.done
              ? ((n[e.resultName] = a.value),
                (n.next = e.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = t)),
                (n.delegate = null),
                y)
              : a
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function L(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function T(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function A(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(L, this),
            this.reset(!0);
        }
        function P(e) {
          if (e || "" === e) {
            var n = e[a];
            if (n) return n.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (i.next = i);
            }
          }
          throw new TypeError(typeof e + " is not iterable");
        }
        return (
          (m.prototype = w),
          o(E, "constructor", { value: w, configurable: !0 }),
          o(w, "constructor", { value: m, configurable: !0 }),
          (m.displayName = u(w, s, "GeneratorFunction")),
          (e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === m || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (e.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, w)
                : ((t.__proto__ = w), u(t, s, "GeneratorFunction")),
              (t.prototype = Object.create(E)),
              t
            );
          }),
          (e.awrap = function (t) {
            return { __await: t };
          }),
          S(x.prototype),
          u(x.prototype, c, function () {
            return this;
          }),
          (e.AsyncIterator = x),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new x(l(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          S(E),
          u(E, s, "Generator"),
          u(E, a, function () {
            return this;
          }),
          u(E, "toString", function () {
            return "[object Generator]";
          }),
          (e.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (e.values = P),
          (A.prototype = {
            constructor: A,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = t),
                this.tryEntries.forEach(T),
                !e)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = "throw"),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, "catchLoc"),
                    u = r.call(a, "finallyLoc");
                  if (s && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                y
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), T(n), y;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    T(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: P(e), resultName: n, nextLoc: r }),
                "next" === this.method && (this.arg = t),
                y
              );
            },
          }),
          e
        );
      }
      function ie(t) {
        return ae.apply(this, arguments);
      }
      function ae() {
        return (ae = Object(r.default)(
          oe().mark(function t(e) {
            var n, r, o, i;
            return oe().wrap(function (t) {
              for (;;)
                switch ((t.prev = t.next)) {
                  case 0:
                    return (
                      (n =
                        document.head ||
                        document.getElementsByTagName("head")[0]),
                      (r = document.createElement("script")),
                      (o = new Promise(function (t, e) {
                        (r.onload = t), (r.onerror = e);
                      })),
                      (i =
                        "prod" === e
                          ? "https://account.djicdn.com"
                          : "https://account-cdn.dbeta.me"),
                      (i += "/account-center-feedback-fe/".concat(
                        e,
                        "/generate.umd.cjs",
                      )),
                      r.setAttribute(
                        "src",
                        "".concat(i, "?t=").concat(new Date().getTime()),
                      ),
                      (r.async = !0),
                      n.append(r),
                      (t.next = 10),
                      o
                    );
                  case 10:
                    if (window.accountCenterFeedback) {
                      t.next = 15;
                      break;
                    }
                    return (
                      (t.next = 13),
                      new Promise(function (t) {
                        setTimeout(t, 300);
                      })
                    );
                  case 13:
                    t.next = 10;
                    break;
                  case 15:
                  case "end":
                    return t.stop();
                }
            }, t);
          }),
        )).apply(this, arguments);
      }
      function ce(t, e, n, r) {
        var o = {
          en: "en_US",
          "zh-CN": "zh_CN",
          "zh-TW": "zh_TW",
          ja: "ja_JP",
          ko: "ko_KR",
          fr: "fr_FR",
          de: "DE_DE",
          es: "es_ES",
          it: "it_IT",
          ru: "ru_RU",
          "pt-BR": "pt_BR",
        };
        window.accountCenterFeedback.updateConfig({
          bottom: "140px",
          right: "2%",
          zindex: "9101",
          lang: o[r] || o.en,
          appId: "dji-official-fe",
          appName: "\u5927\u7586\u5b98\u7f51",
          appUserId: ne.a.get("fb_v1") || t,
          region: n,
          login: !!ne.a.get("fb_v1"),
          env: e,
          supportMobile: !0,
        });
      }
      function se() {
        return (se = Object(r.default)(
          oe().mark(function t(e, n, o, i) {
            return oe().wrap(function (t) {
              for (;;)
                switch ((t.prev = t.next)) {
                  case 0:
                    window.showOfficialAccountCenterFeedback = (function () {
                      var t = Object(r.default)(
                        oe().mark(function t(r) {
                          return oe().wrap(function (t) {
                            for (;;)
                              switch ((t.prev = t.next)) {
                                case 0:
                                  if (r) {
                                    t.next = 2;
                                    break;
                                  }
                                  return t.abrupt("return");
                                case 2:
                                  if (!window.location.pathname.match(r)) {
                                    t.next = 6;
                                    break;
                                  }
                                  return (t.next = 5), ie(n);
                                case 5:
                                  ce(e, n, o, i);
                                case 6:
                                case "end":
                                  return t.stop();
                              }
                          }, t);
                        }),
                      );
                      return function (e) {
                        return t.apply(this, arguments);
                      };
                    })();
                  case 1:
                  case "end":
                    return t.stop();
                }
            }, t);
          }),
        )).apply(this, arguments);
      }
      function ue() {
        ue = function () {
          return t;
        };
        var t = {},
          e = Object.prototype,
          n = e.hasOwnProperty,
          r =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          a = o.asyncIterator || "@@asyncIterator",
          c = o.toStringTag || "@@toStringTag";
        function s(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          s({}, "");
        } catch (L) {
          s = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function u(t, e, n, o) {
          var i = e && e.prototype instanceof h ? e : h,
            a = Object.create(i.prototype),
            c = new x(o || []);
          return r(a, "_invoke", { value: _(t, n, c) }), a;
        }
        function l(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (L) {
            return { type: "throw", arg: L };
          }
        }
        t.wrap = u;
        var f = {};
        function h() {}
        function d() {}
        function p() {}
        var v = {};
        s(v, i, function () {
          return this;
        });
        var y = Object.getPrototypeOf,
          g = y && y(y(j([])));
        g && g !== e && n.call(g, i) && (v = g);
        var m = (p.prototype = h.prototype = Object.create(v));
        function w(t) {
          ["next", "throw", "return"].forEach(function (e) {
            s(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function b(t, e) {
          var o;
          r(this, "_invoke", {
            value: function (r, i) {
              function a() {
                return new e(function (o, a) {
                  !(function r(o, i, a, c) {
                    var s = l(t[o], t, i);
                    if ("throw" !== s.type) {
                      var u = s.arg,
                        f = u.value;
                      return f && "object" == ve(f) && n.call(f, "__await")
                        ? e.resolve(f.__await).then(
                            function (t) {
                              r("next", t, a, c);
                            },
                            function (t) {
                              r("throw", t, a, c);
                            },
                          )
                        : e.resolve(f).then(
                            function (t) {
                              (u.value = t), a(u);
                            },
                            function (t) {
                              return r("throw", t, a, c);
                            },
                          );
                    }
                    c(s.arg);
                  })(r, i, o, a);
                });
              }
              return (o = o ? o.then(a, a) : a());
            },
          });
        }
        function _(t, e, n) {
          var r = "suspendedStart";
          return function (o, i) {
            if ("executing" === r)
              throw new Error("Generator is already running");
            if ("completed" === r) {
              if ("throw" === o) throw i;
              return k();
            }
            for (n.method = o, n.arg = i; ; ) {
              var a = n.delegate;
              if (a) {
                var c = O(a, n);
                if (c) {
                  if (c === f) continue;
                  return c;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;
              else if ("throw" === n.method) {
                if ("suspendedStart" === r) throw ((r = "completed"), n.arg);
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = "executing";
              var s = l(t, e, n);
              if ("normal" === s.type) {
                if (
                  ((r = n.done ? "completed" : "suspendedYield"), s.arg === f)
                )
                  continue;
                return { value: s.arg, done: n.done };
              }
              "throw" === s.type &&
                ((r = "completed"), (n.method = "throw"), (n.arg = s.arg));
            }
          };
        }
        function O(t, e) {
          var n = e.method,
            r = t.iterator[n];
          if (void 0 === r)
            return (
              (e.delegate = null),
              ("throw" === n &&
                t.iterator.return &&
                ((e.method = "return"),
                (e.arg = void 0),
                O(t, e),
                "throw" === e.method)) ||
                ("return" !== n &&
                  ((e.method = "throw"),
                  (e.arg = new TypeError(
                    "The iterator does not provide a '" + n + "' method",
                  )))),
              f
            );
          var o = l(r, t.iterator, e.arg);
          if ("throw" === o.type)
            return (
              (e.method = "throw"), (e.arg = o.arg), (e.delegate = null), f
            );
          var i = o.arg;
          return i
            ? i.done
              ? ((e[t.resultName] = i.value),
                (e.next = t.nextLoc),
                "return" !== e.method &&
                  ((e.method = "next"), (e.arg = void 0)),
                (e.delegate = null),
                f)
              : i
            : ((e.method = "throw"),
              (e.arg = new TypeError("iterator result is not an object")),
              (e.delegate = null),
              f);
        }
        function E(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function S(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function x(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(E, this),
            this.reset(!0);
        }
        function j(t) {
          if (t) {
            var e = t[i];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var r = -1,
                o = function e() {
                  for (; ++r < t.length; )
                    if (n.call(t, r)) return (e.value = t[r]), (e.done = !1), e;
                  return (e.value = void 0), (e.done = !0), e;
                };
              return (o.next = o);
            }
          }
          return { next: k };
        }
        function k() {
          return { value: void 0, done: !0 };
        }
        return (
          (d.prototype = p),
          r(m, "constructor", { value: p, configurable: !0 }),
          r(p, "constructor", { value: d, configurable: !0 }),
          (d.displayName = s(p, c, "GeneratorFunction")),
          (t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === d || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (t.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, p)
                : ((t.__proto__ = p), s(t, c, "GeneratorFunction")),
              (t.prototype = Object.create(m)),
              t
            );
          }),
          (t.awrap = function (t) {
            return { __await: t };
          }),
          w(b.prototype),
          s(b.prototype, a, function () {
            return this;
          }),
          (t.AsyncIterator = b),
          (t.async = function (e, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new b(u(e, n, r, o), i);
            return t.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          w(m),
          s(m, c, "Generator"),
          s(m, i, function () {
            return this;
          }),
          s(m, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (t.values = j),
          (x.prototype = {
            constructor: x,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = void 0),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = void 0),
                this.tryEntries.forEach(S),
                !t)
              )
                for (var e in this)
                  "t" === e.charAt(0) &&
                    n.call(this, e) &&
                    !isNaN(+e.slice(1)) &&
                    (this[e] = void 0);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var e = this;
              function r(n, r) {
                return (
                  (a.type = "throw"),
                  (a.arg = t),
                  (e.next = n),
                  r && ((e.method = "next"), (e.arg = void 0)),
                  !!r
                );
              }
              for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                var i = this.tryEntries[o],
                  a = i.completion;
                if ("root" === i.tryLoc) return r("end");
                if (i.tryLoc <= this.prev) {
                  var c = n.call(i, "catchLoc"),
                    s = n.call(i, "finallyLoc");
                  if (c && s) {
                    if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                  } else if (c) {
                    if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                  } else {
                    if (!s)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var o = this.tryEntries[r];
                if (
                  o.tryLoc <= this.prev &&
                  n.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), f)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                f
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), S(n), f;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    S(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, e, n) {
              return (
                (this.delegate = { iterator: j(t), resultName: e, nextLoc: n }),
                "next" === this.method && (this.arg = void 0),
                f
              );
            },
          }),
          t
        );
      }
      function le(t, e) {
        return (
          (function (t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function (t, e) {
            var n =
              null == t
                ? null
                : ("undefined" != typeof Symbol && t[Symbol.iterator]) ||
                  t["@@iterator"];
            if (null != n) {
              var r,
                o,
                i,
                a,
                c = [],
                s = !0,
                u = !1;
              try {
                if (((i = (n = n.call(t)).next), 0 === e)) {
                  if (Object(n) !== n) return;
                  s = !1;
                } else
                  for (
                    ;
                    !(s = (r = i.call(n)).done) &&
                    (c.push(r.value), c.length !== e);
                    s = !0
                  );
              } catch (l) {
                (u = !0), (o = l);
              } finally {
                try {
                  if (
                    !s &&
                    null != n.return &&
                    ((a = n.return()), Object(a) !== a)
                  )
                    return;
                } finally {
                  if (u) throw o;
                }
              }
              return c;
            }
          })(t, e) ||
          ye(t, e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function fe(t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      }
      function he(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            "value" in r && (r.writable = !0),
            Object.defineProperty(t, pe(r.key), r);
        }
      }
      function de(t, e, n) {
        return (
          e && he(t.prototype, e),
          n && he(t, n),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          t
        );
      }
      function pe(t) {
        var e = (function (t, e) {
          if ("object" !== ve(t) || null === t) return t;
          var n = t[Symbol.toPrimitive];
          if (void 0 !== n) {
            var r = n.call(t, e || "default");
            if ("object" !== ve(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === e ? String : Number)(t);
        })(t, "string");
        return "symbol" === ve(e) ? e : String(e);
      }
      function ve(t) {
        return (ve =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function ye(t, e) {
        if (t) {
          if ("string" === typeof t) return ge(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return (
            "Object" === n && t.constructor && (n = t.constructor.name),
            "Map" === n || "Set" === n
              ? Array.from(t)
              : "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                ? ge(t, e)
                : void 0
          );
        }
      }
      function ge(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
      }
      var me = Object.defineProperty,
        we = Object.defineProperties,
        be = Object.getOwnPropertyDescriptors,
        _e = Object.getOwnPropertySymbols,
        Oe = Object.prototype.hasOwnProperty,
        Ee = Object.prototype.propertyIsEnumerable,
        Se = function (t, e, n) {
          return e in t
            ? me(t, e, {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: n,
              })
            : (t[e] = n);
        },
        xe = function (t, e) {
          for (var n in e || (e = {})) Oe.call(e, n) && Se(t, n, e[n]);
          if (_e) {
            var r,
              o = (function (t, e) {
                var n =
                  ("undefined" !== typeof Symbol && t[Symbol.iterator]) ||
                  t["@@iterator"];
                if (!n) {
                  if (
                    Array.isArray(t) ||
                    (n = ye(t)) ||
                    (e && t && "number" === typeof t.length)
                  ) {
                    n && (t = n);
                    var r = 0,
                      o = function () {};
                    return {
                      s: o,
                      n: function () {
                        return r >= t.length
                          ? { done: !0 }
                          : { done: !1, value: t[r++] };
                      },
                      e: function (t) {
                        throw t;
                      },
                      f: o,
                    };
                  }
                  throw new TypeError(
                    "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
                  );
                }
                var i,
                  a = !0,
                  c = !1;
                return {
                  s: function () {
                    n = n.call(t);
                  },
                  n: function () {
                    var t = n.next();
                    return (a = t.done), t;
                  },
                  e: function (t) {
                    (c = !0), (i = t);
                  },
                  f: function () {
                    try {
                      a || null == n.return || n.return();
                    } finally {
                      if (c) throw i;
                    }
                  },
                };
              })(_e(e));
            try {
              for (o.s(); !(r = o.n()).done; ) {
                n = r.value;
                Ee.call(e, n) && Se(t, n, e[n]);
              }
            } catch (i) {
              o.e(i);
            } finally {
              o.f();
            }
          }
          return t;
        },
        je = function (t, e, n) {
          return Se(t, "symbol" != ve(e) ? e + "" : e, n), n;
        },
        ke = function (t, e, n) {
          return new Promise(function (r, o) {
            var i = function (t) {
                try {
                  c(n.next(t));
                } catch (e) {
                  o(e);
                }
              },
              a = function (t) {
                try {
                  c(n.throw(t));
                } catch (e) {
                  o(e);
                }
              },
              c = function (t) {
                return t.done
                  ? r(t.value)
                  : Promise.resolve(t.value).then(i, a);
              };
            c((n = n.apply(t, e)).next());
          });
        };
      function Le(t, e) {
        return function () {
          return t.apply(e, arguments);
        };
      }
      var Te,
        Ae = Object.prototype.toString,
        Pe = Object.getPrototypeOf,
        Ie =
          ((Te = Object.create(null)),
          function (t) {
            var e = Ae.call(t);
            return Te[e] || (Te[e] = e.slice(8, -1).toLowerCase());
          }),
        Ne = function (t) {
          return (
            (t = t.toLowerCase()),
            function (e) {
              return Ie(e) === t;
            }
          );
        },
        Ce = function (t) {
          return function (e) {
            return ve(e) === t;
          };
        },
        De = Array.isArray,
        Re = Ce("undefined");
      var Me = Ne("ArrayBuffer");
      var Fe = Ce("string"),
        Ue = Ce("function"),
        Ge = Ce("number"),
        Be = function (t) {
          return null !== t && "object" == ve(t);
        },
        He = function (t) {
          if ("object" !== Ie(t)) return !1;
          var e = Pe(t);
          return (
            (null === e ||
              e === Object.prototype ||
              null === Object.getPrototypeOf(e)) &&
            !(Symbol.toStringTag in t) &&
            !(Symbol.iterator in t)
          );
        },
        ze = Ne("Date"),
        Ve = Ne("File"),
        We = Ne("Blob"),
        qe = Ne("FileList"),
        Je = Ne("URLSearchParams");
      function Ye(t, e) {
        var n,
          r,
          o = (
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}
          ).allOwnKeys,
          i = void 0 !== o && o;
        if (null !== t && "undefined" != typeof t)
          if (("object" != ve(t) && (t = [t]), De(t)))
            for (n = 0, r = t.length; n < r; n++) e.call(null, t[n], n, t);
          else {
            var a,
              c = i ? Object.getOwnPropertyNames(t) : Object.keys(t),
              s = c.length;
            for (n = 0; n < s; n++) (a = c[n]), e.call(null, t[a], a, t);
          }
      }
      function Ke(t, e) {
        e = e.toLowerCase();
        for (var n, r = Object.keys(t), o = r.length; o-- > 0; )
          if (e === (n = r[o]).toLowerCase()) return n;
        return null;
      }
      var $e =
          "undefined" != typeof globalThis
            ? globalThis
            : "undefined" != typeof self
              ? self
              : "undefined" != typeof window
                ? window
                : global,
        Xe = function (t) {
          return !Re(t) && t !== $e;
        };
      var Qe = (function (t) {
          return function (e) {
            return t && e instanceof t;
          };
        })("undefined" != typeof Uint8Array && Pe(Uint8Array)),
        Ze = Ne("HTMLFormElement"),
        tn = (function (t) {
          var e = Object.prototype.hasOwnProperty;
          return function (t, n) {
            return e.call(t, n);
          };
        })(),
        en = Ne("RegExp"),
        nn = function (t, e) {
          var n = Object.getOwnPropertyDescriptors(t),
            r = {};
          Ye(n, function (n, o) {
            !1 !== e(n, o, t) && (r[o] = n);
          }),
            Object.defineProperties(t, r);
        },
        rn = "abcdefghijklmnopqrstuvwxyz",
        on = "0123456789",
        an = { DIGIT: on, ALPHA: rn, ALPHA_DIGIT: rn + rn.toUpperCase() + on };
      var cn = Ne("AsyncFunction"),
        sn = {
          isArray: De,
          isArrayBuffer: Me,
          isBuffer: function (t) {
            return (
              null !== t &&
              !Re(t) &&
              null !== t.constructor &&
              !Re(t.constructor) &&
              Ue(t.constructor.isBuffer) &&
              t.constructor.isBuffer(t)
            );
          },
          isFormData: function (t) {
            var e;
            return (
              t &&
              (("function" == typeof FormData && t instanceof FormData) ||
                (Ue(t.append) &&
                  ("formdata" === (e = Ie(t)) ||
                    ("object" === e &&
                      Ue(t.toString) &&
                      "[object FormData]" === t.toString()))))
            );
          },
          isArrayBufferView: function (t) {
            return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView
              ? ArrayBuffer.isView(t)
              : t && t.buffer && Me(t.buffer);
          },
          isString: Fe,
          isNumber: Ge,
          isBoolean: function (t) {
            return !0 === t || !1 === t;
          },
          isObject: Be,
          isPlainObject: He,
          isUndefined: Re,
          isDate: ze,
          isFile: Ve,
          isBlob: We,
          isRegExp: en,
          isFunction: Ue,
          isStream: function (t) {
            return Be(t) && Ue(t.pipe);
          },
          isURLSearchParams: Je,
          isTypedArray: Qe,
          isFileList: qe,
          forEach: Ye,
          merge: function t() {
            for (
              var e = ((Xe(this) && this) || {}).caseless,
                n = {},
                r = function (r, o) {
                  var i = (e && Ke(n, o)) || o;
                  He(n[i]) && He(r)
                    ? (n[i] = t(n[i], r))
                    : He(r)
                      ? (n[i] = t({}, r))
                      : De(r)
                        ? (n[i] = r.slice())
                        : (n[i] = r);
                },
                o = 0,
                i = arguments.length;
              o < i;
              o++
            )
              arguments[o] && Ye(arguments[o], r);
            return n;
          },
          extend: function (t, e, n) {
            var r =
                arguments.length > 3 && void 0 !== arguments[3]
                  ? arguments[3]
                  : {},
              o = r.allOwnKeys;
            return (
              Ye(
                e,
                function (e, r) {
                  n && Ue(e) ? (t[r] = Le(e, n)) : (t[r] = e);
                },
                { allOwnKeys: o },
              ),
              t
            );
          },
          trim: function (t) {
            return t.trim
              ? t.trim()
              : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
          },
          stripBOM: function (t) {
            return 65279 === t.charCodeAt(0) && (t = t.slice(1)), t;
          },
          inherits: function (t, e, n, r) {
            (t.prototype = Object.create(e.prototype, r)),
              (t.prototype.constructor = t),
              Object.defineProperty(t, "super", { value: e.prototype }),
              n && Object.assign(t.prototype, n);
          },
          toFlatObject: function (t, e, n, r) {
            var o,
              i,
              a,
              c = {};
            if (((e = e || {}), null == t)) return e;
            do {
              for (i = (o = Object.getOwnPropertyNames(t)).length; i-- > 0; )
                (a = o[i]),
                  (!r || r(a, t, e)) && !c[a] && ((e[a] = t[a]), (c[a] = !0));
              t = !1 !== n && Pe(t);
            } while (t && (!n || n(t, e)) && t !== Object.prototype);
            return e;
          },
          kindOf: Ie,
          kindOfTest: Ne,
          endsWith: function (t, e, n) {
            (t = String(t)),
              (void 0 === n || n > t.length) && (n = t.length),
              (n -= e.length);
            var r = t.indexOf(e, n);
            return -1 !== r && r === n;
          },
          toArray: function (t) {
            if (!t) return null;
            if (De(t)) return t;
            var e = t.length;
            if (!Ge(e)) return null;
            for (var n = new Array(e); e-- > 0; ) n[e] = t[e];
            return n;
          },
          forEachEntry: function (t, e) {
            for (
              var n, r = (t && t[Symbol.iterator]).call(t);
              (n = r.next()) && !n.done;

            ) {
              var o = n.value;
              e.call(t, o[0], o[1]);
            }
          },
          matchAll: function (t, e) {
            for (var n, r = []; null !== (n = t.exec(e)); ) r.push(n);
            return r;
          },
          isHTMLForm: Ze,
          hasOwnProperty: tn,
          hasOwnProp: tn,
          reduceDescriptors: nn,
          freezeMethods: function (t) {
            nn(t, function (e, n) {
              if (Ue(t) && -1 !== ["arguments", "caller", "callee"].indexOf(n))
                return !1;
              var r = t[n];
              if (Ue(r)) {
                if (((e.enumerable = !1), "writable" in e))
                  return void (e.writable = !1);
                e.set ||
                  (e.set = function () {
                    throw Error("Can not rewrite read-only method '" + n + "'");
                  });
              }
            });
          },
          toObjectSet: function (t, e) {
            var n = {},
              r = function (t) {
                t.forEach(function (t) {
                  n[t] = !0;
                });
              };
            return De(t) ? r(t) : r(String(t).split(e)), n;
          },
          toCamelCase: function (t) {
            return t
              .toLowerCase()
              .replace(/[-_\s]([a-z\d])(\w*)/g, function (t, e, n) {
                return e.toUpperCase() + n;
              });
          },
          noop: function () {},
          toFiniteNumber: function (t, e) {
            return (t = +t), Number.isFinite(t) ? t : e;
          },
          findKey: Ke,
          global: $e,
          isContextDefined: Xe,
          ALPHABET: an,
          generateString: function () {
            for (
              var t =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : 16,
                e =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : an.ALPHA_DIGIT,
                n = "",
                r = e.length;
              t--;

            )
              n += e[(Math.random() * r) | 0];
            return n;
          },
          isSpecCompliantForm: function (t) {
            return !!(
              t &&
              Ue(t.append) &&
              "FormData" === t[Symbol.toStringTag] &&
              t[Symbol.iterator]
            );
          },
          toJSONObject: function (t) {
            var e = new Array(10);
            return (function t(n, r) {
              if (Be(n)) {
                if (e.indexOf(n) >= 0) return;
                if (!("toJSON" in n)) {
                  e[r] = n;
                  var o = De(n) ? [] : {};
                  return (
                    Ye(n, function (e, n) {
                      var i = t(e, r + 1);
                      !Re(i) && (o[n] = i);
                    }),
                    (e[r] = void 0),
                    o
                  );
                }
              }
              return n;
            })(t, 0);
          },
          isAsyncFn: cn,
          isThenable: function (t) {
            return t && (Be(t) || Ue(t)) && Ue(t.then) && Ue(t.catch);
          },
        };
      function un(t, e, n, r, o) {
        Error.call(this),
          Error.captureStackTrace
            ? Error.captureStackTrace(this, this.constructor)
            : (this.stack = new Error().stack),
          (this.message = t),
          (this.name = "AxiosError"),
          e && (this.code = e),
          n && (this.config = n),
          r && (this.request = r),
          o && (this.response = o);
      }
      sn.inherits(un, Error, {
        toJSON: function () {
          return {
            message: this.message,
            name: this.name,
            description: this.description,
            number: this.number,
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            config: sn.toJSONObject(this.config),
            code: this.code,
            status:
              this.response && this.response.status
                ? this.response.status
                : null,
          };
        },
      });
      var ln = un.prototype,
        fn = {};
      [
        "ERR_BAD_OPTION_VALUE",
        "ERR_BAD_OPTION",
        "ECONNABORTED",
        "ETIMEDOUT",
        "ERR_NETWORK",
        "ERR_FR_TOO_MANY_REDIRECTS",
        "ERR_DEPRECATED",
        "ERR_BAD_RESPONSE",
        "ERR_BAD_REQUEST",
        "ERR_CANCELED",
        "ERR_NOT_SUPPORT",
        "ERR_INVALID_URL",
      ].forEach(function (t) {
        fn[t] = { value: t };
      }),
        Object.defineProperties(un, fn),
        Object.defineProperty(ln, "isAxiosError", { value: !0 }),
        (un.from = function (t, e, n, r, o, i) {
          var a = Object.create(ln);
          return (
            sn.toFlatObject(
              t,
              a,
              function (t) {
                return t !== Error.prototype;
              },
              function (t) {
                return "isAxiosError" !== t;
              },
            ),
            un.call(a, t.message, e, n, r, o),
            (a.cause = t),
            (a.name = t.name),
            i && Object.assign(a, i),
            a
          );
        });
      function hn(t) {
        return sn.isPlainObject(t) || sn.isArray(t);
      }
      function dn(t) {
        return sn.endsWith(t, "[]") ? t.slice(0, -2) : t;
      }
      function pn(t, e, n) {
        return t
          ? t
              .concat(e)
              .map(function (t, e) {
                return (t = dn(t)), !n && e ? "[" + t + "]" : t;
              })
              .join(n ? "." : "")
          : e;
      }
      var vn = sn.toFlatObject(sn, {}, null, function (t) {
        return /^is[A-Z]/.test(t);
      });
      function yn(t, e, n) {
        if (!sn.isObject(t)) throw new TypeError("target must be an object");
        e = e || new FormData();
        var r = (n = sn.toFlatObject(
            n,
            { metaTokens: !0, dots: !1, indexes: !1 },
            !1,
            function (t, e) {
              return !sn.isUndefined(e[t]);
            },
          )).metaTokens,
          o = n.visitor || u,
          i = n.dots,
          a = n.indexes,
          c =
            (n.Blob || ("undefined" != typeof Blob && Blob)) &&
            sn.isSpecCompliantForm(e);
        if (!sn.isFunction(o))
          throw new TypeError("visitor must be a function");
        function s(t) {
          if (null === t) return "";
          if (sn.isDate(t)) return t.toISOString();
          if (!c && sn.isBlob(t))
            throw new un("Blob is not supported. Use a Buffer instead.");
          return sn.isArrayBuffer(t) || sn.isTypedArray(t)
            ? c && "function" == typeof Blob
              ? new Blob([t])
              : Buffer.from(t)
            : t;
        }
        function u(t, n, o) {
          var c = t;
          if (t && !o && "object" == ve(t))
            if (sn.endsWith(n, "{}"))
              (n = r ? n : n.slice(0, -2)), (t = JSON.stringify(t));
            else if (
              (sn.isArray(t) &&
                (function (t) {
                  return sn.isArray(t) && !t.some(hn);
                })(t)) ||
              ((sn.isFileList(t) || sn.endsWith(n, "[]")) &&
                (c = sn.toArray(t)))
            )
              return (
                (n = dn(n)),
                c.forEach(function (t, r) {
                  !sn.isUndefined(t) &&
                    null !== t &&
                    e.append(
                      !0 === a ? pn([n], r, i) : null === a ? n : n + "[]",
                      s(t),
                    );
                }),
                !1
              );
          return !!hn(t) || (e.append(pn(o, n, i), s(t)), !1);
        }
        var l = [],
          f = Object.assign(vn, {
            defaultVisitor: u,
            convertValue: s,
            isVisitable: hn,
          });
        if (!sn.isObject(t)) throw new TypeError("data must be an object");
        return (
          (function t(n, r) {
            if (!sn.isUndefined(n)) {
              if (-1 !== l.indexOf(n))
                throw Error("Circular reference detected in " + r.join("."));
              l.push(n),
                sn.forEach(n, function (n, i) {
                  !0 ===
                    (!(sn.isUndefined(n) || null === n) &&
                      o.call(e, n, sn.isString(i) ? i.trim() : i, r, f)) &&
                    t(n, r ? r.concat(i) : [i]);
                }),
                l.pop();
            }
          })(t),
          e
        );
      }
      function gn(t) {
        var e = {
          "!": "%21",
          "'": "%27",
          "(": "%28",
          ")": "%29",
          "~": "%7E",
          "%20": "+",
          "%00": "\0",
        };
        return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function (t) {
          return e[t];
        });
      }
      function mn(t, e) {
        (this._pairs = []), t && yn(t, this, e);
      }
      var wn = mn.prototype;
      function bn(t) {
        return encodeURIComponent(t)
          .replace(/%3A/gi, ":")
          .replace(/%24/g, "$")
          .replace(/%2C/gi, ",")
          .replace(/%20/g, "+")
          .replace(/%5B/gi, "[")
          .replace(/%5D/gi, "]");
      }
      function _n(t, e, n) {
        if (!e) return t;
        var r,
          o = (n && n.encode) || bn,
          i = n && n.serialize;
        if (
          (r = i
            ? i(e, n)
            : sn.isURLSearchParams(e)
              ? e.toString()
              : new mn(e, n).toString(o))
        ) {
          var a = t.indexOf("#");
          -1 !== a && (t = t.slice(0, a)),
            (t += (-1 === t.indexOf("?") ? "?" : "&") + r);
        }
        return t;
      }
      (wn.append = function (t, e) {
        this._pairs.push([t, e]);
      }),
        (wn.toString = function (t) {
          var e = t
            ? function (e) {
                return t.call(this, e, gn);
              }
            : gn;
          return this._pairs
            .map(function (t) {
              return e(t[0]) + "=" + e(t[1]);
            }, "")
            .join("&");
        });
      var On = (function () {
          function t() {
            fe(this, t), (this.handlers = []);
          }
          return (
            de(t, [
              {
                key: "use",
                value: function (t, e, n) {
                  return (
                    this.handlers.push({
                      fulfilled: t,
                      rejected: e,
                      synchronous: !!n && n.synchronous,
                      runWhen: n ? n.runWhen : null,
                    }),
                    this.handlers.length - 1
                  );
                },
              },
              {
                key: "eject",
                value: function (t) {
                  this.handlers[t] && (this.handlers[t] = null);
                },
              },
              {
                key: "clear",
                value: function () {
                  this.handlers && (this.handlers = []);
                },
              },
              {
                key: "forEach",
                value: function (t) {
                  sn.forEach(this.handlers, function (e) {
                    null !== e && t(e);
                  });
                },
              },
            ]),
            t
          );
        })(),
        En = {
          silentJSONParsing: !0,
          forcedJSONParsing: !0,
          clarifyTimeoutError: !1,
        },
        Sn = {
          isBrowser: !0,
          classes: {
            URLSearchParams:
              "undefined" != typeof URLSearchParams ? URLSearchParams : mn,
            FormData: "undefined" != typeof FormData ? FormData : null,
            Blob: "undefined" != typeof Blob ? Blob : null,
          },
          isStandardBrowserEnv: (function () {
            var t;
            return (
              ("undefined" == typeof navigator ||
                ("ReactNative" !== (t = navigator.product) &&
                  "NativeScript" !== t &&
                  "NS" !== t)) &&
              "undefined" != typeof window &&
              "undefined" != typeof document
            );
          })(),
          isStandardBrowserWebWorkerEnv:
            "undefined" != typeof WorkerGlobalScope &&
            self instanceof WorkerGlobalScope &&
            "function" == typeof self.importScripts,
          protocols: ["http", "https", "file", "blob", "url", "data"],
        };
      function xn(t) {
        function e(t, n, r, o) {
          var i = t[o++],
            a = Number.isFinite(+i),
            c = o >= t.length;
          return (
            (i = !i && sn.isArray(r) ? r.length : i),
            c
              ? (sn.hasOwnProp(r, i) ? (r[i] = [r[i], n]) : (r[i] = n), !a)
              : ((!r[i] || !sn.isObject(r[i])) && (r[i] = []),
                e(t, n, r[i], o) &&
                  sn.isArray(r[i]) &&
                  (r[i] = (function (t) {
                    var e,
                      n,
                      r = {},
                      o = Object.keys(t),
                      i = o.length;
                    for (e = 0; e < i; e++) r[(n = o[e])] = t[n];
                    return r;
                  })(r[i])),
                !a)
          );
        }
        if (sn.isFormData(t) && sn.isFunction(t.entries)) {
          var n = {};
          return (
            sn.forEachEntry(t, function (t, r) {
              e(
                (function (t) {
                  return sn.matchAll(/\w+|\[(\w*)]/g, t).map(function (t) {
                    return "[]" === t[0] ? "" : t[1] || t[0];
                  });
                })(t),
                r,
                n,
                0,
              );
            }),
            n
          );
        }
        return null;
      }
      var jn = { "Content-Type": void 0 };
      var kn = {
        transitional: En,
        adapter: ["xhr", "http"],
        transformRequest: [
          function (t, e) {
            var n,
              r = e.getContentType() || "",
              o = r.indexOf("application/json") > -1,
              i = sn.isObject(t);
            if (
              (i && sn.isHTMLForm(t) && (t = new FormData(t)), sn.isFormData(t))
            )
              return o && o ? JSON.stringify(xn(t)) : t;
            if (
              sn.isArrayBuffer(t) ||
              sn.isBuffer(t) ||
              sn.isStream(t) ||
              sn.isFile(t) ||
              sn.isBlob(t)
            )
              return t;
            if (sn.isArrayBufferView(t)) return t.buffer;
            if (sn.isURLSearchParams(t))
              return (
                e.setContentType(
                  "application/x-www-form-urlencoded;charset=utf-8",
                  !1,
                ),
                t.toString()
              );
            if (i) {
              if (r.indexOf("application/x-www-form-urlencoded") > -1)
                return (function (t, e) {
                  return yn(
                    t,
                    new Sn.classes.URLSearchParams(),
                    Object.assign(
                      {
                        visitor: function (t, e, n, r) {
                          return Sn.isNode && sn.isBuffer(t)
                            ? (this.append(e, t.toString("base64")), !1)
                            : r.defaultVisitor.apply(this, arguments);
                        },
                      },
                      e,
                    ),
                  );
                })(t, this.formSerializer).toString();
              if (
                (n = sn.isFileList(t)) ||
                r.indexOf("multipart/form-data") > -1
              ) {
                var a = this.env && this.env.FormData;
                return yn(
                  n ? { "files[]": t } : t,
                  a && new a(),
                  this.formSerializer,
                );
              }
            }
            return i || o
              ? (e.setContentType("application/json", !1),
                (function (t, e, n) {
                  if (sn.isString(t))
                    try {
                      return (e || JSON.parse)(t), sn.trim(t);
                    } catch (r) {
                      if ("SyntaxError" !== r.name) throw r;
                    }
                  return (n || JSON.stringify)(t);
                })(t))
              : t;
          },
        ],
        transformResponse: [
          function (t) {
            var e = this.transitional || kn.transitional,
              n = e && e.forcedJSONParsing,
              r = "json" === this.responseType;
            if (t && sn.isString(t) && ((n && !this.responseType) || r)) {
              var o = !(e && e.silentJSONParsing) && r;
              try {
                return JSON.parse(t);
              } catch (i) {
                if (o)
                  throw "SyntaxError" === i.name
                    ? un.from(i, un.ERR_BAD_RESPONSE, this, null, this.response)
                    : i;
              }
            }
            return t;
          },
        ],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        maxBodyLength: -1,
        env: { FormData: Sn.classes.FormData, Blob: Sn.classes.Blob },
        validateStatus: function (t) {
          return t >= 200 && t < 300;
        },
        headers: { common: { Accept: "application/json, text/plain, */*" } },
      };
      sn.forEach(["delete", "get", "head"], function (t) {
        kn.headers[t] = {};
      }),
        sn.forEach(["post", "put", "patch"], function (t) {
          kn.headers[t] = sn.merge(jn);
        });
      var Ln = kn,
        Tn = sn.toObjectSet([
          "age",
          "authorization",
          "content-length",
          "content-type",
          "etag",
          "expires",
          "from",
          "host",
          "if-modified-since",
          "if-unmodified-since",
          "last-modified",
          "location",
          "max-forwards",
          "proxy-authorization",
          "referer",
          "retry-after",
          "user-agent",
        ]),
        An = Symbol("internals");
      function Pn(t) {
        return t && String(t).trim().toLowerCase();
      }
      function In(t) {
        return !1 === t || null == t
          ? t
          : sn.isArray(t)
            ? t.map(In)
            : String(t);
      }
      function Nn(t, e, n, r, o) {
        if (sn.isFunction(r)) return r.call(this, e, n);
        if ((o && (e = n), sn.isString(e))) {
          if (sn.isString(r)) return -1 !== e.indexOf(r);
          if (sn.isRegExp(r)) return r.test(e);
        }
      }
      var Cn = (function (t, e) {
        function n(t) {
          fe(this, n), t && this.set(t);
        }
        return (
          de(
            n,
            [
              {
                key: "set",
                value: function (t, e, n) {
                  var r = this;
                  function o(t, e, n) {
                    var o = Pn(e);
                    if (!o)
                      throw new Error("header name must be a non-empty string");
                    var i = sn.findKey(r, o);
                    (!i ||
                      void 0 === r[i] ||
                      !0 === n ||
                      (void 0 === n && !1 !== r[i])) &&
                      (r[i || e] = In(t));
                  }
                  var i = function (t, e) {
                    return sn.forEach(t, function (t, n) {
                      return o(t, n, e);
                    });
                  };
                  return (
                    sn.isPlainObject(t) || t instanceof this.constructor
                      ? i(t, e)
                      : sn.isString(t) &&
                          (t = t.trim()) &&
                          !(function (t) {
                            return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(
                              t.trim(),
                            );
                          })(t)
                        ? i(
                            (function (t) {
                              var e,
                                n,
                                r,
                                o = {};
                              return (
                                t &&
                                  t.split("\n").forEach(function (t) {
                                    (r = t.indexOf(":")),
                                      (e = t
                                        .substring(0, r)
                                        .trim()
                                        .toLowerCase()),
                                      (n = t.substring(r + 1).trim()),
                                      !(!e || (o[e] && Tn[e])) &&
                                        ("set-cookie" === e
                                          ? o[e]
                                            ? o[e].push(n)
                                            : (o[e] = [n])
                                          : (o[e] = o[e]
                                              ? o[e] + ", " + n
                                              : n));
                                  }),
                                o
                              );
                            })(t),
                            e,
                          )
                        : null != t && o(e, t, n),
                    this
                  );
                },
              },
              {
                key: "get",
                value: function (t, e) {
                  if ((t = Pn(t))) {
                    var n = sn.findKey(this, t);
                    if (n) {
                      var r = this[n];
                      if (!e) return r;
                      if (!0 === e)
                        return (function (t) {
                          for (
                            var e,
                              n = Object.create(null),
                              r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
                            (e = r.exec(t));

                          )
                            n[e[1]] = e[2];
                          return n;
                        })(r);
                      if (sn.isFunction(e)) return e.call(this, r, n);
                      if (sn.isRegExp(e)) return e.exec(r);
                      throw new TypeError(
                        "parser must be boolean|regexp|function",
                      );
                    }
                  }
                },
              },
              {
                key: "has",
                value: function (t, e) {
                  if ((t = Pn(t))) {
                    var n = sn.findKey(this, t);
                    return !(
                      !n ||
                      void 0 === this[n] ||
                      (e && !Nn(0, this[n], n, e))
                    );
                  }
                  return !1;
                },
              },
              {
                key: "delete",
                value: function (t, e) {
                  var n = this,
                    r = !1;
                  function o(t) {
                    if ((t = Pn(t))) {
                      var o = sn.findKey(n, t);
                      o && (!e || Nn(0, n[o], o, e)) && (delete n[o], (r = !0));
                    }
                  }
                  return sn.isArray(t) ? t.forEach(o) : o(t), r;
                },
              },
              {
                key: "clear",
                value: function (t) {
                  for (var e = Object.keys(this), n = e.length, r = !1; n--; ) {
                    var o = e[n];
                    (!t || Nn(0, this[o], o, t, !0)) &&
                      (delete this[o], (r = !0));
                  }
                  return r;
                },
              },
              {
                key: "normalize",
                value: function (t) {
                  var e = this,
                    n = {};
                  return (
                    sn.forEach(this, function (r, o) {
                      var i = sn.findKey(n, o);
                      if (i) return (e[i] = In(r)), void delete e[o];
                      var a = t
                        ? (function (t) {
                            return t
                              .trim()
                              .toLowerCase()
                              .replace(/([a-z\d])(\w*)/g, function (t, e, n) {
                                return e.toUpperCase() + n;
                              });
                          })(o)
                        : String(o).trim();
                      a !== o && delete e[o], (e[a] = In(r)), (n[a] = !0);
                    }),
                    this
                  );
                },
              },
              {
                key: "concat",
                value: function () {
                  for (
                    var t, e = arguments.length, n = new Array(e), r = 0;
                    r < e;
                    r++
                  )
                    n[r] = arguments[r];
                  return (t = this.constructor).concat.apply(
                    t,
                    [this].concat(n),
                  );
                },
              },
              {
                key: "toJSON",
                value: function (t) {
                  var e = Object.create(null);
                  return (
                    sn.forEach(this, function (n, r) {
                      null != n &&
                        !1 !== n &&
                        (e[r] = t && sn.isArray(n) ? n.join(", ") : n);
                    }),
                    e
                  );
                },
              },
              {
                key: Symbol.iterator,
                value: function () {
                  return Object.entries(this.toJSON())[Symbol.iterator]();
                },
              },
              {
                key: "toString",
                value: function () {
                  return Object.entries(this.toJSON())
                    .map(function (t) {
                      var e = le(t, 2);
                      return e[0] + ": " + e[1];
                    })
                    .join("\n");
                },
              },
              {
                key: Symbol.toStringTag,
                get: function () {
                  return "AxiosHeaders";
                },
              },
            ],
            [
              {
                key: "from",
                value: function (t) {
                  return t instanceof this ? t : new this(t);
                },
              },
              {
                key: "concat",
                value: function (t) {
                  for (
                    var e = new this(t),
                      n = arguments.length,
                      r = new Array(n > 1 ? n - 1 : 0),
                      o = 1;
                    o < n;
                    o++
                  )
                    r[o - 1] = arguments[o];
                  return (
                    r.forEach(function (t) {
                      return e.set(t);
                    }),
                    e
                  );
                },
              },
              {
                key: "accessor",
                value: function (t) {
                  var e = (this[An] = this[An] = { accessors: {} }).accessors,
                    n = this.prototype;
                  function r(t) {
                    var r = Pn(t);
                    e[r] ||
                      ((function (t, e) {
                        var n = sn.toCamelCase(" " + e);
                        ["get", "set", "has"].forEach(function (r) {
                          Object.defineProperty(t, r + n, {
                            value: function (t, n, o) {
                              return this[r].call(this, e, t, n, o);
                            },
                            configurable: !0,
                          });
                        });
                      })(n, t),
                      (e[r] = !0));
                  }
                  return sn.isArray(t) ? t.forEach(r) : r(t), this;
                },
              },
            ],
          ),
          n
        );
      })();
      Cn.accessor([
        "Content-Type",
        "Content-Length",
        "Accept",
        "Accept-Encoding",
        "User-Agent",
        "Authorization",
      ]),
        sn.freezeMethods(Cn.prototype),
        sn.freezeMethods(Cn);
      var Dn = Cn;
      function Rn(t, e) {
        var n = this || Ln,
          r = e || n,
          o = Dn.from(r.headers),
          i = r.data;
        return (
          sn.forEach(t, function (t) {
            i = t.call(n, i, o.normalize(), e ? e.status : void 0);
          }),
          o.normalize(),
          i
        );
      }
      function Mn(t) {
        return !(!t || !t.__CANCEL__);
      }
      function Fn(t, e, n) {
        un.call(this, null == t ? "canceled" : t, un.ERR_CANCELED, e, n),
          (this.name = "CanceledError");
      }
      sn.inherits(Fn, un, { __CANCEL__: !0 });
      var Un = Sn.isStandardBrowserEnv
        ? {
            write: function (t, e, n, r, o, i) {
              var a = [];
              a.push(t + "=" + encodeURIComponent(e)),
                sn.isNumber(n) &&
                  a.push("expires=" + new Date(n).toGMTString()),
                sn.isString(r) && a.push("path=" + r),
                sn.isString(o) && a.push("domain=" + o),
                !0 === i && a.push("secure"),
                (document.cookie = a.join("; "));
            },
            read: function (t) {
              var e = document.cookie.match(
                new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"),
              );
              return e ? decodeURIComponent(e[3]) : null;
            },
            remove: function (t) {
              this.write(t, "", Date.now() - 864e5);
            },
          }
        : {
            write: function () {},
            read: function () {
              return null;
            },
            remove: function () {},
          };
      function Gn(t, e) {
        return t &&
          !(function (t) {
            return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
          })(e)
          ? (function (t, e) {
              return e
                ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "")
                : t;
            })(t, e)
          : e;
      }
      var Bn = Sn.isStandardBrowserEnv
        ? (function () {
            var t,
              e = /(msie|trident)/i.test(navigator.userAgent),
              n = document.createElement("a");
            function r(t) {
              var r = t;
              return (
                e && (n.setAttribute("href", r), (r = n.href)),
                n.setAttribute("href", r),
                {
                  href: n.href,
                  protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
                  host: n.host,
                  search: n.search ? n.search.replace(/^\?/, "") : "",
                  hash: n.hash ? n.hash.replace(/^#/, "") : "",
                  hostname: n.hostname,
                  port: n.port,
                  pathname:
                    "/" === n.pathname.charAt(0)
                      ? n.pathname
                      : "/" + n.pathname,
                }
              );
            }
            return (
              (t = r(window.location.href)),
              function (e) {
                var n = sn.isString(e) ? r(e) : e;
                return n.protocol === t.protocol && n.host === t.host;
              }
            );
          })()
        : function () {
            return !0;
          };
      function Hn(t, e) {
        var n = 0,
          r = (function (t, e) {
            t = t || 10;
            var n,
              r = new Array(t),
              o = new Array(t),
              i = 0,
              a = 0;
            return (
              (e = void 0 !== e ? e : 1e3),
              function (c) {
                var s = Date.now(),
                  u = o[a];
                n || (n = s), (r[i] = c), (o[i] = s);
                for (var l = a, f = 0; l !== i; ) (f += r[l++]), (l %= t);
                if (
                  ((i = (i + 1) % t) === a && (a = (a + 1) % t), !(s - n < e))
                ) {
                  var h = u && s - u;
                  return h ? Math.round((1e3 * f) / h) : void 0;
                }
              }
            );
          })(50, 250);
        return function (o) {
          var i = o.loaded,
            a = o.lengthComputable ? o.total : void 0,
            c = i - n,
            s = r(c);
          n = i;
          var u = {
            loaded: i,
            total: a,
            progress: a ? i / a : void 0,
            bytes: c,
            rate: s || void 0,
            estimated: s && a && i <= a ? (a - i) / s : void 0,
            event: o,
          };
          (u[e ? "download" : "upload"] = !0), t(u);
        };
      }
      var zn = {
        http: null,
        xhr:
          "undefined" != typeof XMLHttpRequest &&
          function (t) {
            return new Promise(function (e, n) {
              var r,
                o = t.data,
                i = Dn.from(t.headers).normalize(),
                a = t.responseType;
              function c() {
                t.cancelToken && t.cancelToken.unsubscribe(r),
                  t.signal && t.signal.removeEventListener("abort", r);
              }
              sn.isFormData(o) &&
                (Sn.isStandardBrowserEnv || Sn.isStandardBrowserWebWorkerEnv
                  ? i.setContentType(!1)
                  : i.setContentType("multipart/form-data;", !1));
              var s = new XMLHttpRequest();
              if (t.auth) {
                var u = t.auth.username || "",
                  l = t.auth.password
                    ? unescape(encodeURIComponent(t.auth.password))
                    : "";
                i.set("Authorization", "Basic " + btoa(u + ":" + l));
              }
              var f = Gn(t.baseURL, t.url);
              function h() {
                if (s) {
                  var r = Dn.from(
                    "getAllResponseHeaders" in s && s.getAllResponseHeaders(),
                  );
                  (function (t, e, n) {
                    var r = n.config.validateStatus;
                    n.status && r && !r(n.status)
                      ? e(
                          new un(
                            "Request failed with status code " + n.status,
                            [un.ERR_BAD_REQUEST, un.ERR_BAD_RESPONSE][
                              Math.floor(n.status / 100) - 4
                            ],
                            n.config,
                            n.request,
                            n,
                          ),
                        )
                      : t(n);
                  })(
                    function (t) {
                      e(t), c();
                    },
                    function (t) {
                      n(t), c();
                    },
                    {
                      data:
                        a && "text" !== a && "json" !== a
                          ? s.response
                          : s.responseText,
                      status: s.status,
                      statusText: s.statusText,
                      headers: r,
                      config: t,
                      request: s,
                    },
                  ),
                    (s = null);
                }
              }
              if (
                (s.open(
                  t.method.toUpperCase(),
                  _n(f, t.params, t.paramsSerializer),
                  !0,
                ),
                (s.timeout = t.timeout),
                "onloadend" in s
                  ? (s.onloadend = h)
                  : (s.onreadystatechange = function () {
                      !s ||
                        4 !== s.readyState ||
                        (0 === s.status &&
                          (!s.responseURL ||
                            0 !== s.responseURL.indexOf("file:"))) ||
                        setTimeout(h);
                    }),
                (s.onabort = function () {
                  s &&
                    (n(new un("Request aborted", un.ECONNABORTED, t, s)),
                    (s = null));
                }),
                (s.onerror = function () {
                  n(new un("Network Error", un.ERR_NETWORK, t, s)), (s = null);
                }),
                (s.ontimeout = function () {
                  var e = t.timeout
                      ? "timeout of " + t.timeout + "ms exceeded"
                      : "timeout exceeded",
                    r = t.transitional || En;
                  t.timeoutErrorMessage && (e = t.timeoutErrorMessage),
                    n(
                      new un(
                        e,
                        r.clarifyTimeoutError ? un.ETIMEDOUT : un.ECONNABORTED,
                        t,
                        s,
                      ),
                    ),
                    (s = null);
                }),
                Sn.isStandardBrowserEnv)
              ) {
                var d =
                  (t.withCredentials || Bn(f)) &&
                  t.xsrfCookieName &&
                  Un.read(t.xsrfCookieName);
                d && i.set(t.xsrfHeaderName, d);
              }
              void 0 === o && i.setContentType(null),
                "setRequestHeader" in s &&
                  sn.forEach(i.toJSON(), function (t, e) {
                    s.setRequestHeader(e, t);
                  }),
                sn.isUndefined(t.withCredentials) ||
                  (s.withCredentials = !!t.withCredentials),
                a && "json" !== a && (s.responseType = t.responseType),
                "function" == typeof t.onDownloadProgress &&
                  s.addEventListener("progress", Hn(t.onDownloadProgress, !0)),
                "function" == typeof t.onUploadProgress &&
                  s.upload &&
                  s.upload.addEventListener("progress", Hn(t.onUploadProgress)),
                (t.cancelToken || t.signal) &&
                  ((r = function (e) {
                    s &&
                      (n(!e || e.type ? new Fn(null, t, s) : e),
                      s.abort(),
                      (s = null));
                  }),
                  t.cancelToken && t.cancelToken.subscribe(r),
                  t.signal &&
                    (t.signal.aborted
                      ? r()
                      : t.signal.addEventListener("abort", r)));
              var p = (function (t) {
                var e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
                return (e && e[1]) || "";
              })(f);
              p && -1 === Sn.protocols.indexOf(p)
                ? n(
                    new un(
                      "Unsupported protocol " + p + ":",
                      un.ERR_BAD_REQUEST,
                      t,
                    ),
                  )
                : s.send(o || null);
            });
          },
      };
      sn.forEach(zn, function (t, e) {
        if (t) {
          try {
            Object.defineProperty(t, "name", { value: e });
          } catch (n) {}
          Object.defineProperty(t, "adapterName", { value: e });
        }
      });
      var Vn = {
        getAdapter: function (t) {
          for (
            var e, n, r = (t = sn.isArray(t) ? t : [t]).length, o = 0;
            o < r &&
            ((e = t[o]), !(n = sn.isString(e) ? zn[e.toLowerCase()] : e));
            o++
          );
          if (!n)
            throw !1 === n
              ? new un(
                  "Adapter ".concat(e, " is not supported by the environment"),
                  "ERR_NOT_SUPPORT",
                )
              : new Error(
                  sn.hasOwnProp(zn, e)
                    ? "Adapter '".concat(e, "' is not available in the build")
                    : "Unknown adapter '".concat(e, "'"),
                );
          if (!sn.isFunction(n))
            throw new TypeError("adapter is not a function");
          return n;
        },
        adapters: zn,
      };
      function Wn(t) {
        if (
          (t.cancelToken && t.cancelToken.throwIfRequested(),
          t.signal && t.signal.aborted)
        )
          throw new Fn(null, t);
      }
      function qn(t) {
        return (
          Wn(t),
          (t.headers = Dn.from(t.headers)),
          (t.data = Rn.call(t, t.transformRequest)),
          -1 !== ["post", "put", "patch"].indexOf(t.method) &&
            t.headers.setContentType("application/x-www-form-urlencoded", !1),
          Vn.getAdapter(t.adapter || Ln.adapter)(t).then(
            function (e) {
              return (
                Wn(t),
                (e.data = Rn.call(t, t.transformResponse, e)),
                (e.headers = Dn.from(e.headers)),
                e
              );
            },
            function (e) {
              return (
                Mn(e) ||
                  (Wn(t),
                  e &&
                    e.response &&
                    ((e.response.data = Rn.call(
                      t,
                      t.transformResponse,
                      e.response,
                    )),
                    (e.response.headers = Dn.from(e.response.headers)))),
                Promise.reject(e)
              );
            },
          )
        );
      }
      var Jn = function (t) {
        return t instanceof Dn ? t.toJSON() : t;
      };
      function Yn(t, e) {
        e = e || {};
        var n = {};
        function r(t, e, n) {
          return sn.isPlainObject(t) && sn.isPlainObject(e)
            ? sn.merge.call({ caseless: n }, t, e)
            : sn.isPlainObject(e)
              ? sn.merge({}, e)
              : sn.isArray(e)
                ? e.slice()
                : e;
        }
        function o(t, e, n) {
          return sn.isUndefined(e)
            ? sn.isUndefined(t)
              ? void 0
              : r(void 0, t, n)
            : r(t, e, n);
        }
        function i(t, e) {
          if (!sn.isUndefined(e)) return r(void 0, e);
        }
        function a(t, e) {
          return sn.isUndefined(e)
            ? sn.isUndefined(t)
              ? void 0
              : r(void 0, t)
            : r(void 0, e);
        }
        function c(n, o, i) {
          return i in e ? r(n, o) : i in t ? r(void 0, n) : void 0;
        }
        var s = {
          url: i,
          method: i,
          data: i,
          baseURL: a,
          transformRequest: a,
          transformResponse: a,
          paramsSerializer: a,
          timeout: a,
          timeoutMessage: a,
          withCredentials: a,
          adapter: a,
          responseType: a,
          xsrfCookieName: a,
          xsrfHeaderName: a,
          onUploadProgress: a,
          onDownloadProgress: a,
          decompress: a,
          maxContentLength: a,
          maxBodyLength: a,
          beforeRedirect: a,
          transport: a,
          httpAgent: a,
          httpsAgent: a,
          cancelToken: a,
          socketPath: a,
          responseEncoding: a,
          validateStatus: c,
          headers: function (t, e) {
            return o(Jn(t), Jn(e), !0);
          },
        };
        return (
          sn.forEach(Object.keys(Object.assign({}, t, e)), function (r) {
            var i = s[r] || o,
              a = i(t[r], e[r], r);
            (sn.isUndefined(a) && i !== c) || (n[r] = a);
          }),
          n
        );
      }
      var Kn = "1.4.0",
        $n = {};
      ["object", "boolean", "number", "function", "string", "symbol"].forEach(
        function (t, e) {
          $n[t] = function (n) {
            return ve(n) === t || "a" + (e < 1 ? "n " : " ") + t;
          };
        },
      );
      var Xn = {};
      $n.transitional = function (t, e, n) {
        function r(t, e) {
          return (
            "[Axios v" +
            Kn +
            "] Transitional option '" +
            t +
            "'" +
            e +
            (n ? ". " + n : "")
          );
        }
        return function (n, o, i) {
          if (!1 === t)
            throw new un(
              r(o, " has been removed" + (e ? " in " + e : "")),
              un.ERR_DEPRECATED,
            );
          return (
            e &&
              !Xn[o] &&
              ((Xn[o] = !0),
              console.warn(
                r(
                  o,
                  " has been deprecated since v" +
                    e +
                    " and will be removed in the near future",
                ),
              )),
            !t || t(n, o, i)
          );
        };
      };
      var Qn = {
          assertOptions: function (t, e, n) {
            if ("object" != ve(t))
              throw new un(
                "options must be an object",
                un.ERR_BAD_OPTION_VALUE,
              );
            for (var r = Object.keys(t), o = r.length; o-- > 0; ) {
              var i = r[o],
                a = e[i];
              if (a) {
                var c = t[i],
                  s = void 0 === c || a(c, i, t);
                if (!0 !== s)
                  throw new un(
                    "option " + i + " must be " + s,
                    un.ERR_BAD_OPTION_VALUE,
                  );
              } else if (!0 !== n)
                throw new un("Unknown option " + i, un.ERR_BAD_OPTION);
            }
          },
          validators: $n,
        },
        Zn = Qn.validators,
        tr = (function () {
          function t(e) {
            fe(this, t),
              (this.defaults = e),
              (this.interceptors = { request: new On(), response: new On() });
          }
          return (
            de(t, [
              {
                key: "request",
                value: function (t, e) {
                  "string" == typeof t
                    ? ((e = e || {}).url = t)
                    : (e = t || {});
                  var n,
                    r = (e = Yn(this.defaults, e)),
                    o = r.transitional,
                    i = r.paramsSerializer,
                    a = r.headers;
                  void 0 !== o &&
                    Qn.assertOptions(
                      o,
                      {
                        silentJSONParsing: Zn.transitional(Zn.boolean),
                        forcedJSONParsing: Zn.transitional(Zn.boolean),
                        clarifyTimeoutError: Zn.transitional(Zn.boolean),
                      },
                      !1,
                    ),
                    null != i &&
                      (sn.isFunction(i)
                        ? (e.paramsSerializer = { serialize: i })
                        : Qn.assertOptions(
                            i,
                            { encode: Zn.function, serialize: Zn.function },
                            !0,
                          )),
                    (e.method = (
                      e.method ||
                      this.defaults.method ||
                      "get"
                    ).toLowerCase()),
                    (n = a && sn.merge(a.common, a[e.method])) &&
                      sn.forEach(
                        [
                          "delete",
                          "get",
                          "head",
                          "post",
                          "put",
                          "patch",
                          "common",
                        ],
                        function (t) {
                          delete a[t];
                        },
                      ),
                    (e.headers = Dn.concat(n, a));
                  var c = [],
                    s = !0;
                  this.interceptors.request.forEach(function (t) {
                    ("function" == typeof t.runWhen && !1 === t.runWhen(e)) ||
                      ((s = s && t.synchronous),
                      c.unshift(t.fulfilled, t.rejected));
                  });
                  var u = [];
                  this.interceptors.response.forEach(function (t) {
                    u.push(t.fulfilled, t.rejected);
                  });
                  var l,
                    f,
                    h = 0;
                  if (!s) {
                    var d = [qn.bind(this), void 0];
                    for (
                      d.unshift.apply(d, c),
                        d.push.apply(d, u),
                        f = d.length,
                        l = Promise.resolve(e);
                      h < f;

                    )
                      l = l.then(d[h++], d[h++]);
                    return l;
                  }
                  f = c.length;
                  var p = e;
                  for (h = 0; h < f; ) {
                    var v = c[h++],
                      y = c[h++];
                    try {
                      p = v(p);
                    } catch (g) {
                      y.call(this, g);
                      break;
                    }
                  }
                  try {
                    l = qn.call(this, p);
                  } catch (d) {
                    return Promise.reject(d);
                  }
                  for (h = 0, f = u.length; h < f; ) l = l.then(u[h++], u[h++]);
                  return l;
                },
              },
              {
                key: "getUri",
                value: function (t) {
                  return _n(
                    Gn((t = Yn(this.defaults, t)).baseURL, t.url),
                    t.params,
                    t.paramsSerializer,
                  );
                },
              },
            ]),
            t
          );
        })();
      sn.forEach(["delete", "get", "head", "options"], function (t) {
        tr.prototype[t] = function (e, n) {
          return this.request(
            Yn(n || {}, { method: t, url: e, data: (n || {}).data }),
          );
        };
      }),
        sn.forEach(["post", "put", "patch"], function (t) {
          function e(e) {
            return function (n, r, o) {
              return this.request(
                Yn(o || {}, {
                  method: t,
                  headers: e ? { "Content-Type": "multipart/form-data" } : {},
                  url: n,
                  data: r,
                }),
              );
            };
          }
          (tr.prototype[t] = e()), (tr.prototype[t + "Form"] = e(!0));
        });
      var er = tr,
        nr = (function () {
          function t(e) {
            if ((fe(this, t), "function" != typeof e))
              throw new TypeError("executor must be a function.");
            var n;
            this.promise = new Promise(function (t) {
              n = t;
            });
            var r = this;
            this.promise.then(function (t) {
              if (r._listeners) {
                for (var e = r._listeners.length; e-- > 0; ) r._listeners[e](t);
                r._listeners = null;
              }
            }),
              (this.promise.then = function (t) {
                var e,
                  n = new Promise(function (t) {
                    r.subscribe(t), (e = t);
                  }).then(t);
                return (
                  (n.cancel = function () {
                    r.unsubscribe(e);
                  }),
                  n
                );
              }),
              e(function (t, e, o) {
                r.reason || ((r.reason = new Fn(t, e, o)), n(r.reason));
              });
          }
          return (
            de(
              t,
              [
                {
                  key: "throwIfRequested",
                  value: function () {
                    if (this.reason) throw this.reason;
                  },
                },
                {
                  key: "subscribe",
                  value: function (t) {
                    this.reason
                      ? t(this.reason)
                      : this._listeners
                        ? this._listeners.push(t)
                        : (this._listeners = [t]);
                  },
                },
                {
                  key: "unsubscribe",
                  value: function (t) {
                    if (this._listeners) {
                      var e = this._listeners.indexOf(t);
                      -1 !== e && this._listeners.splice(e, 1);
                    }
                  },
                },
              ],
              [
                {
                  key: "source",
                  value: function () {
                    var e;
                    return {
                      token: new t(function (t) {
                        e = t;
                      }),
                      cancel: e,
                    };
                  },
                },
              ],
            ),
            t
          );
        })();
      var rr = {
        Continue: 100,
        SwitchingProtocols: 101,
        Processing: 102,
        EarlyHints: 103,
        Ok: 200,
        Created: 201,
        Accepted: 202,
        NonAuthoritativeInformation: 203,
        NoContent: 204,
        ResetContent: 205,
        PartialContent: 206,
        MultiStatus: 207,
        AlreadyReported: 208,
        ImUsed: 226,
        MultipleChoices: 300,
        MovedPermanently: 301,
        Found: 302,
        SeeOther: 303,
        NotModified: 304,
        UseProxy: 305,
        Unused: 306,
        TemporaryRedirect: 307,
        PermanentRedirect: 308,
        BadRequest: 400,
        Unauthorized: 401,
        PaymentRequired: 402,
        Forbidden: 403,
        NotFound: 404,
        MethodNotAllowed: 405,
        NotAcceptable: 406,
        ProxyAuthenticationRequired: 407,
        RequestTimeout: 408,
        Conflict: 409,
        Gone: 410,
        LengthRequired: 411,
        PreconditionFailed: 412,
        PayloadTooLarge: 413,
        UriTooLong: 414,
        UnsupportedMediaType: 415,
        RangeNotSatisfiable: 416,
        ExpectationFailed: 417,
        ImATeapot: 418,
        MisdirectedRequest: 421,
        UnprocessableEntity: 422,
        Locked: 423,
        FailedDependency: 424,
        TooEarly: 425,
        UpgradeRequired: 426,
        PreconditionRequired: 428,
        TooManyRequests: 429,
        RequestHeaderFieldsTooLarge: 431,
        UnavailableForLegalReasons: 451,
        InternalServerError: 500,
        NotImplemented: 501,
        BadGateway: 502,
        ServiceUnavailable: 503,
        GatewayTimeout: 504,
        HttpVersionNotSupported: 505,
        VariantAlsoNegotiates: 506,
        InsufficientStorage: 507,
        LoopDetected: 508,
        NotExtended: 510,
        NetworkAuthenticationRequired: 511,
      };
      Object.entries(rr).forEach(function (t) {
        var e = le(t, 2),
          n = e[0],
          r = e[1];
        rr[r] = n;
      });
      var or = rr;
      var ir = (function t(e) {
        var n = new er(e),
          r = Le(er.prototype.request, n);
        return (
          sn.extend(r, er.prototype, n, { allOwnKeys: !0 }),
          sn.extend(r, n, null, { allOwnKeys: !0 }),
          (r.create = function (n) {
            return t(Yn(e, n));
          }),
          r
        );
      })(Ln);
      (ir.Axios = er),
        (ir.CanceledError = Fn),
        (ir.CancelToken = nr),
        (ir.isCancel = Mn),
        (ir.VERSION = Kn),
        (ir.toFormData = yn),
        (ir.AxiosError = un),
        (ir.Cancel = ir.CanceledError),
        (ir.all = function (t) {
          return Promise.all(t);
        }),
        (ir.spread = function (t) {
          return function (e) {
            return t.apply(null, e);
          };
        }),
        (ir.isAxiosError = function (t) {
          return sn.isObject(t) && !0 === t.isAxiosError;
        }),
        (ir.mergeConfig = Yn),
        (ir.AxiosHeaders = Dn),
        (ir.formToJSON = function (t) {
          return xn(sn.isHTMLForm(t) ? new FormData(t) : t);
        }),
        (ir.HttpStatusCode = or),
        (ir.default = ir);
      var ar = ir,
        cr = (function (t) {
          return (
            (t[(t.SUCCESS = 0)] = "SUCCESS"),
            (t[(t.USER_NOT_EXIST = 502)] = "USER_NOT_EXIST"),
            (t[(t.APP_ID_INVALID = 516)] = "APP_ID_INVALID"),
            (t[(t.GOOGLE_ERROR = 621)] = "GOOGLE_ERROR"),
            (t[(t.HTTP_ERROR = 9999)] = "HTTP_ERROR"),
            t
          );
        })(cr || {}),
        sr = ar.create({ baseURL: "", timeout: 6e4, withCredentials: !0 });
      function ur(t) {
        return "".concat(vr.getBaseUrl()).concat(t);
      }
      sr.interceptors.request.use(
        function (t) {
          return t;
        },
        function (t) {
          return Promise.reject(t);
        },
      ),
        sr.interceptors.response.use(
          function (t) {
            return t.data;
          },
          function (t) {
            return Promise.reject(t);
          },
        );
      var lr = "https://accounts.google.com/gsi/client",
        fr = [
          "zh_CN",
          "en_US",
          "zh_TW",
          "ja_JP",
          "ko_KR",
          "fr_FR",
          "de_DE",
          "es_ES",
          "it_IT",
        ],
        hr = {
          "zh-CN": "zh_CN",
          ko: "ko_KR",
          ja: "ja_JP",
          "zh-TW": "zh_TW",
          de: "de_DE",
          "de-CH": "de_DE",
          "de-AT": "de_DE",
          "de-DE": "de_DE",
          "de-LI": "de_DE",
          fr: "fr_FR",
          "fr-FR": "fr_FR",
          "fr-CA": "fr_FR",
          "fr-CH": "fr_FR",
          es: "es_ES",
          "es-AR": "es_ES",
          "es-CO": "es_ES",
          "es-CR": "es_ES",
          "es-HN": "es_ES",
          "es-419": "es_ES",
          "es-US": "es_ES",
          "es-PE": "es_ES",
          "es-MX": "es_ES",
          "es-VE": "es_ES",
          "es-UY": "es_ES",
          "es-ES": "es_ES",
          "es-CL": "es_ES",
          "it-CH": "it_IT",
          "it-IT": "it_IT",
          it: "it_IT",
          "en-IE": "en_US",
          "en-AU": "en_US",
          "en-CA": "en_US",
          "en-US": "en_US",
          "en-ZA": "en_US",
          "en-NZ": "en_US",
          "en-IN": "en_US",
          "en-GB-oxendict": "en_US",
          "en-GB": "en_US",
          en: "en_US",
        };
      function dr(t) {
        if (
          t &&
          fr.find(function (e) {
            return e === t;
          })
        )
          return t;
        var e = window.navigator.language,
          n = Object.keys(hr);
        return e && n.includes(e) ? hr[e] : "en_US";
      }
      function pr(t) {
        return t || window.location.href;
      }
      var vr = (function () {
        function t() {
          fe(this, t);
        }
        return (
          de(t, null, [
            {
              key: "getIfShowOneTab",
              value: function () {
                return "function" == typeof this.config.isShowOneTab
                  ? this.config.isShowOneTab()
                  : !!this.config.isShowOneTab;
              },
            },
            {
              key: "setConfig",
              value: function (t) {
                this.config = xe(xe({}, this.config), t);
              },
            },
            {
              key: "getCallback",
              value: function () {
                var e = this;
                return function (n) {
                  var r, o;
                  null == (o = (r = t.config).onGoogleOneTapClick) || o.call(r),
                    (function (t) {
                      return sr.post(
                        ur("/user/webrest/v2/validateGoogleCredential.do"),
                        t,
                        {
                          withCredentials: !0,
                          headers: { "AppId-Mc": t.appId },
                        },
                      );
                    })(xe(xe({}, n), t.getRequestParams()))
                      .then(function (t) {
                        var n;
                        if (t && t.code === cr.SUCCESS) {
                          if (
                            (function (t) {
                              return (
                                t &&
                                (function (t) {
                                  return !t.ticket;
                                })(t)
                              );
                            })(t.data)
                          )
                            return void (function (t) {
                              t && (window.location.href = t);
                            })(
                              null == (n = null == t ? void 0 : t.data)
                                ? void 0
                                : n.callbackUrl,
                            );
                          e.config.successCallback &&
                            e.config.successCallback(t);
                        } else
                          e.config.failCallback && e.config.failCallback(t);
                      })
                      .catch(function () {
                        e.config.failCallback &&
                          e.config.failCallback({
                            code: cr.HTTP_ERROR,
                            message: "",
                            data: {
                              callbackUrl: "",
                              email: "",
                              nickName: "",
                              ticket: "",
                            },
                          });
                      });
                };
              },
            },
            {
              key: "getClientId",
              value: function () {
                switch (this.config.env) {
                  case "prod":
                    return "223766966999-4bu3vjnrpm0n3944cib7lbpvmci0tmse.apps.googleusercontent.com";
                  case "stag":
                    return "852901822126-lohr4rbon3mkc4i0j1lm80rtrca9il17.apps.googleusercontent.com";
                  default:
                    return "852901822126-tn73k8rckugq4ueqtfr8a3oe8uiavsak.apps.googleusercontent.com";
                }
              },
            },
            {
              key: "getConfig",
              value: function () {
                return (function (t, e) {
                  return we(t, be(e));
                })(xe({}, this.config), {
                  client_id: this.getClientId(),
                  callback: this.getCallback(),
                });
              },
            },
            {
              key: "getRequestParams",
              value: function () {
                return {
                  appId: this.config.appId,
                  locale: dr(this.config.locale),
                  backUrl: pr(this.config.backUrl),
                };
              },
            },
            {
              key: "getBaseUrl",
              value: function () {
                switch (this.config.env) {
                  case "prod":
                    return "https://account.dji.com";
                  case "stag":
                    return "https://r-account.dbeta.me";
                  default:
                    return "https://account.dbeta.me";
                }
              },
            },
          ]),
          t
        );
      })();
      je(vr, "memberServerStatusPromise", null),
        je(vr, "scriptPromise", null),
        je(vr, "config", {
          env: "test",
          appId: "",
          cancel_on_tap_outside: !1,
          isShowOneTab: !0,
        });
      var yr = function (t) {
        return sr.get(ur("/user/webrest/v2/sdkInitData"), {
          headers: { "AppId-Mc": t.appId },
        });
      };
      function gr() {
        return ke(
          this,
          null,
          ue().mark(function t() {
            return ue().wrap(function (t) {
              for (;;)
                switch ((t.prev = t.next)) {
                  case 0:
                    return t.abrupt(
                      "return",
                      Promise.all([
                        (vr.scriptPromise ||
                          (vr.scriptPromise = new Promise(function (t, e) {
                            var n =
                                document.head ||
                                document.getElementsByTagName("head")[0],
                              r = document.createElement("script");
                            (r.async = !0),
                              (r.defer = !0),
                              r.setAttribute("src", lr);
                            var o = document.createElement("meta");
                            o.setAttribute("name", "google-site-verification"),
                              o.setAttribute(
                                "content",
                                "yEYuZNYCaZ_cY0WYi5IPNxZfPgdtdngUhK75PQGdS_c",
                              ),
                              n.appendChild(r),
                              (r.onload = function () {
                                return t();
                              }),
                              (r.onerror = function () {
                                return e();
                              });
                          })),
                        vr.scriptPromise),
                        (vr.memberServerStatusPromise ||
                          (vr.memberServerStatusPromise = yr({
                            appId: vr.getRequestParams().appId,
                          }).then(function (t) {
                            return t.code === cr.SUCCESS
                              ? Promise.resolve(t)
                              : Promise.reject();
                          })),
                        vr.memberServerStatusPromise).then(function (t) {
                          return t.data.googleOneTap.switchOn
                            ? t
                            : Promise.reject();
                        }),
                      ]),
                    );
                  case 1:
                  case "end":
                    return t.stop();
                }
            }, t);
          }),
        );
      }
      function mr() {
        return vr.getIfShowOneTab();
      }
      function wr(t) {
        var e, n;
        (function (t) {
          t && vr.setConfig(t);
        })(t),
          mr()
            ? gr()
                .then(function () {
                  var t, e;
                  (function () {
                    var t = vr.getConfig();
                    window.google.accounts.id.initialize(t);
                  })(),
                    mr()
                      ? window.google.accounts.id.prompt(function (t) {
                          var e, n, r, o, i, a;
                          t.isDisplayed()
                            ? null ==
                                (n = (e = vr.getConfig()).onGoogleOneTapShow) ||
                              n.call(e)
                            : t.isNotDisplayed()
                              ? null ==
                                  (o = (r = vr.getConfig())
                                    .onGoogleOneTapNotShow) ||
                                o.call(r, t.getNotDisplayedReason())
                              : t.isSkippedMoment() &&
                                (null ==
                                  (a = (i = vr.getConfig())
                                    .onGoogleOneTapNotShow) ||
                                  a.call(i, t.getSkippedReason()));
                        })
                      : null ==
                          (e = (t = vr.getConfig()).onGoogleOneTapNotShow) ||
                        e.call(t, "not_show_one_tap");
                })
                .catch(function () {
                  var t, e;
                  null == (e = (t = vr.getConfig()).onGoogleOneTapNotShow) ||
                    e.call(t, "init_fail");
                })
            : null == (n = (e = vr.getConfig()).onGoogleOneTapNotShow) ||
              n.call(e, "not_show_one_tap");
      }
      var br = n("ku9G"),
        _r = n("vtNx"),
        Or = function (t) {
          var e = t.region,
            n = t.ignoreUniversalTip,
            r = te.CCPA.isAcceptCookieTerm(),
            o = !ne.a.get("_logged"),
            i = "CN" !== e,
            a = !RegExp("^(/[a-z]{2})*(/mobile)*/(policy|terms)$").test(
              window.location.pathname,
            ),
            c =
              n ||
              !document.querySelector(".dji-mobile .universal-product-tip");
          return r && o && i && a && c;
        },
        Er = function (t, e, n) {
          window.ga && window.ga("send", "event", t, e, n);
          var r =
            "try" === e ? _r.a.GOOGLE_ONE_TAP_SHOW : _r.a.GOOGLE_ONE_TAP_CLICK;
          Object(br.a)(r, { category: t, action: e, label: n });
        };
      function Sr(t) {
        var e = t.region,
          n = t.language,
          r = t.subdomain,
          o = t.env;
        r ||
          "undefined" === typeof document ||
          ((window.showGoogleOneTap = function (t) {
            Er("google-one-tap", "try", "show");
            var r = (t || {}).ignoreUniversalTip;
            try {
              wr({
                env: o,
                appId: "dji_official_aws",
                backUrl: window.location.href,
                locale: Object(yt.F)(n),
                isShowOneTab: function () {
                  return Or({ region: e, ignoreUniversalTip: r });
                },
                onGoogleOneTapClick: function () {
                  Er("google-one-tap", "click", "login-button");
                },
                onGoogleOneTapShow: function () {
                  Er("google-one-tap", "show", "success"),
                    t &&
                      "function" === typeof t.onShowCallback &&
                      t.onShowCallback({ success: !0 });
                },
                onGoogleOneTapNotShow: function (e) {
                  Er("google-one-tap", "not-show", "fail-reason-".concat(e)),
                    t &&
                      "function" === typeof t.onShowCallback &&
                      t.onShowCallback({ success: !1, reason: e });
                },
                successCallback: function (t) {
                  console.log("successCallback", t.code, t.data, t.message),
                    Er("google-one-tap", "login", "success"),
                    t.data.callbackUrl &&
                      (window.location.href = t.data.callbackUrl);
                },
                failCallback: function (t) {
                  console.error("failCallback", t),
                    Er("google-one-tap", "login", "fail");
                },
              });
            } catch (Te) {
              console.error(Te);
            }
          }),
          (window.hideGoogleOneTap = function () {
            gr()
              .then(function () {
                window.google.accounts.id.cancel();
              })
              .catch(function () {
                console.log("calcel_error");
              });
          }));
      }
      var xr = h.a.createElement;
      function jr() {
        jr = function () {
          return e;
        };
        var t,
          e = {},
          n = Object.prototype,
          r = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function u(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          u({}, "");
        } catch (t) {
          u = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function l(t, e, n, r) {
          var i = e && e.prototype instanceof g ? e : g,
            a = Object.create(i.prototype),
            c = new A(r || []);
          return o(a, "_invoke", { value: j(t, n, c) }), a;
        }
        function f(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        e.wrap = l;
        var h = "suspendedStart",
          d = "suspendedYield",
          p = "executing",
          v = "completed",
          y = {};
        function g() {}
        function m() {}
        function w() {}
        var b = {};
        u(b, a, function () {
          return this;
        });
        var _ = Object.getPrototypeOf,
          O = _ && _(_(P([])));
        O && O !== n && r.call(O, a) && (b = O);
        var E = (w.prototype = g.prototype = Object.create(b));
        function S(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function x(t, e) {
          function n(o, i, a, c) {
            var s = f(t[o], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                l = u.value;
              return l && "object" == typeof l && r.call(l, "__await")
                ? e.resolve(l.__await).then(
                    function (t) {
                      n("next", t, a, c);
                    },
                    function (t) {
                      n("throw", t, a, c);
                    },
                  )
                : e.resolve(l).then(
                    function (t) {
                      (u.value = t), a(u);
                    },
                    function (t) {
                      return n("throw", t, a, c);
                    },
                  );
            }
            c(s.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (t, r) {
              function o() {
                return new e(function (e, o) {
                  n(t, r, e, o);
                });
              }
              return (i = i ? i.then(o, o) : o());
            },
          });
        }
        function j(e, n, r) {
          var o = h;
          return function (i, a) {
            if (o === p) throw new Error("Generator is already running");
            if (o === v) {
              if ("throw" === i) throw a;
              return { value: t, done: !0 };
            }
            for (r.method = i, r.arg = a; ; ) {
              var c = r.delegate;
              if (c) {
                var s = k(c, r);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if (o === h) throw ((o = v), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              o = p;
              var u = f(e, n, r);
              if ("normal" === u.type) {
                if (((o = r.done ? v : d), u.arg === y)) continue;
                return { value: u.arg, done: r.done };
              }
              "throw" === u.type &&
                ((o = v), (r.method = "throw"), (r.arg = u.arg));
            }
          };
        }
        function k(e, n) {
          var r = n.method,
            o = e.iterator[r];
          if (o === t)
            return (
              (n.delegate = null),
              ("throw" === r &&
                e.iterator.return &&
                ((n.method = "return"),
                (n.arg = t),
                k(e, n),
                "throw" === n.method)) ||
                ("return" !== r &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + r + "' method",
                  )))),
              y
            );
          var i = f(o, e.iterator, n.arg);
          if ("throw" === i.type)
            return (
              (n.method = "throw"), (n.arg = i.arg), (n.delegate = null), y
            );
          var a = i.arg;
          return a
            ? a.done
              ? ((n[e.resultName] = a.value),
                (n.next = e.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = t)),
                (n.delegate = null),
                y)
              : a
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function L(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function T(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function A(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(L, this),
            this.reset(!0);
        }
        function P(e) {
          if (e || "" === e) {
            var n = e[a];
            if (n) return n.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (i.next = i);
            }
          }
          throw new TypeError(typeof e + " is not iterable");
        }
        return (
          (m.prototype = w),
          o(E, "constructor", { value: w, configurable: !0 }),
          o(w, "constructor", { value: m, configurable: !0 }),
          (m.displayName = u(w, s, "GeneratorFunction")),
          (e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === m || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (e.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, w)
                : ((t.__proto__ = w), u(t, s, "GeneratorFunction")),
              (t.prototype = Object.create(E)),
              t
            );
          }),
          (e.awrap = function (t) {
            return { __await: t };
          }),
          S(x.prototype),
          u(x.prototype, c, function () {
            return this;
          }),
          (e.AsyncIterator = x),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new x(l(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          S(E),
          u(E, s, "Generator"),
          u(E, a, function () {
            return this;
          }),
          u(E, "toString", function () {
            return "[object Generator]";
          }),
          (e.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (e.values = P),
          (A.prototype = {
            constructor: A,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = t),
                this.tryEntries.forEach(T),
                !e)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = "throw"),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, "catchLoc"),
                    u = r.call(a, "finallyLoc");
                  if (s && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), y)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                y
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), T(n), y;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    T(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: P(e), resultName: n, nextLoc: r }),
                "next" === this.method && (this.arg = t),
                y
              );
            },
          }),
          e
        );
      }
      function kr(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e &&
            (r = r.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function Lr(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? kr(Object(n), !0).forEach(function (e) {
                Object(l.a)(t, e, n[e]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
              : kr(Object(n)).forEach(function (e) {
                  Object.defineProperty(
                    t,
                    e,
                    Object.getOwnPropertyDescriptor(n, e),
                  );
                });
        }
        return t;
      }
      function Tr(t, e, n) {
        return (
          (e = Object(c.a)(e)),
          Object(a.a)(
            t,
            (function () {
              try {
                var t = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (t) {}
              return (function () {
                return !!t;
              })();
            })()
              ? Reflect.construct(e, n || [], Object(c.a)(t).constructor)
              : e.apply(t, n),
          )
        );
      }
      var Ar = ".dji.com",
        Pr = (function (t) {
          function e(t) {
            var n;
            Object(o.default)(this, e),
              (n = Tr(this, e)),
              Object(l.a)(Object(s.a)(n), "setPerformanceMetric", function () {
                null !== n._LCP && re.a.set({ metric1: n._LCP });
              }),
              Object(l.a)(
                Object(s.a)(n),
                "initProphetClientOnLoad",
                function () {
                  (window.ProphetClient = Zt),
                    "undefined" !== typeof Zt &&
                      /([\w-]*www[\w-]*\.(dji\.com|dbeta\.me)|localhost)/.test(
                        window.location.hostname,
                      ) &&
                      ("complete" !== document.readyState
                        ? window.addEventListener("load", function () {
                            e.initProphet();
                          })
                        : e.initProphet());
                },
              ),
              Object(l.a)(
                Object(s.a)(n),
                "initPerformanceObserver",
                function () {
                  try {
                    new PerformanceObserver(function (t) {
                      var e = t.getEntries(),
                        r = e[e.length - 1];
                      if ("largest-contentful-paint" === r.entryType) {
                        var o = r.renderTime || r.loadTime;
                        (n._LCP = parseInt(o, 10)), n.setPerformanceMetric();
                      }
                    }).observe({ entryTypes: ["largest-contentful-paint"] });
                  } catch (Te) {}
                },
              ),
              Object(l.a)(Object(s.a)(n), "handleGetLoadTtfbTime", function () {
                window.addEventListener("load", function () {
                  var t = 0,
                    e = 0;
                  window.performance &&
                    (window.performance.getEntriesByType("navigation")[0]
                      ? ((t = Math.round(
                          window.performance.getEntriesByType("navigation")[0]
                            .loadEventStart,
                        )),
                        (e = Math.round(
                          window.performance.getEntriesByType("navigation")[0]
                            .responseStart -
                            window.performance.getEntriesByType("navigation")[0]
                              .requestStart,
                        )))
                      : window.performance.timing &&
                        ((t = Math.round(
                          window.performance.timing.loadEventStart -
                            window.performance.timing.navigationStart,
                        )),
                        (e = Math.round(
                          window.performance.timing.responseStart -
                            window.performance.timing.requestStart,
                        )))),
                    t &&
                      e &&
                      (re.a.set({ metric2: t }),
                      re.a.set({ metric3: e }),
                      re.a.event({
                        category:
                          window.location.pathname + window.location.search,
                        action: "load",
                        label: "time",
                        nonInteraction: !0,
                      }));
                });
              }),
              Object(l.a)(
                Object(s.a)(n),
                "handleSetUtmParamsCookie",
                function () {
                  var t = !1,
                    e = [
                      { key: "utm_source", value: "" },
                      { key: "utm_medium", value: "" },
                      { key: "utm_term", value: "" },
                      { key: "utm_content", value: "" },
                      { key: "utm_campaign", value: "" },
                    ];
                  e.forEach(function (e) {
                    (e.value = ""),
                      Object(yt.L)(e.key) &&
                        "" !== Object(yt.L)(e.key) &&
                        ((e.value = Object(yt.L)(e.key)), (t = !0));
                  }),
                    t &&
                      e.forEach(function (t) {
                        t.value && "" !== t.value
                          ? ne.a.set("form_".concat(t.key), t.value, {
                              path: "/",
                              domain: Ar,
                              expires: 15,
                            })
                          : ne.a.remove("form_".concat(t.key), {
                              path: "/",
                              domain: Ar,
                            });
                      });
                },
              );
            var r = ut.a.parse(window.document.cookie),
              i = t.env,
              a = t.region,
              c = t.language,
              u = t.subdomain,
              f = t.optimize;
            n._LCP = null;
            var h = f || {},
              d = h.expId,
              p = h.varId,
              v = (i || {}).ga_id,
              y = r.ga_uid ? r.ga_uid : null;
            return v && n.initGA(v, y, r, a, c, d, p, u), n;
          }
          return (
            Object(u.a)(e, t),
            Object(i.default)(
              e,
              [
                {
                  key: "initGA",
                  value: function (t, e, n, r, o, i, a, c) {
                    this.initPerformanceObserver(),
                      re.a.initialize(t, {
                        gaOptions: { userId: e, siteSpeedSampleRate: 100 },
                      }),
                      re.a.set({
                        dimension2: e,
                        dimension3: n._ga ? n._ga.substr(6) : null,
                        dimension4: r,
                      }),
                      (function (t, e, n, r) {
                        se.apply(this, arguments);
                      })(e, "prod", r, o),
                      i &&
                        a &&
                        "function" === typeof ga &&
                        ga("set", "dimension24", "".concat(i, ".").concat(a));
                    var s = window.ABTest || {},
                      u = s.expIds,
                      l = s.varIds;
                    if (Array.isArray(u) && Array.isArray(l)) {
                      var f = u
                        .filter(function (t, e) {
                          return t && l[e] && "string" === typeof l[e];
                        })
                        .map(function (t, e) {
                          return "".concat(t, "=").concat(l[e]);
                        })
                        .join("|");
                      ga("set", "dimension24", f);
                    }
                    if (
                      (window.__abData__ &&
                        window.__abData__.s &&
                        ga("set", "dimension23", window.__abData__.s),
                      re.a.pageview(
                        window.location.pathname + window.location.search,
                      ),
                      re.a.ga("require", "displayfeatures"),
                      this.handleGetLoadTtfbTime(),
                      (function (t) {
                        document
                          .querySelector("body")
                          .addEventListener("click", function (e) {
                            for (
                              var n = e || window.event,
                                r = n.target || n.srcElement;
                              r &&
                              r.hasAttribute &&
                              !r.hasAttribute("data-ga-action") &&
                              "BODY" !== r.tagName;

                            )
                              r = r.parentNode;
                            if (
                              r &&
                              r.hasAttribute &&
                              r.hasAttribute("data-ga-action")
                            ) {
                              var o = r.getAttribute("data-ga-action")
                                  ? r.getAttribute("data-ga-action")
                                  : "click",
                                i = r.getAttribute("data-ga-category")
                                  ? r.getAttribute("data-ga-category")
                                  : "",
                                a = r.getAttribute("data-ga-label")
                                  ? r.getAttribute("data-ga-label")
                                  : "",
                                c = r.getAttribute("data-bd-track")
                                  ? r.getAttribute("data-bd-track")
                                  : "";
                              i && t && o && t("send", "event", i, o, a),
                                c &&
                                  "click" === e.type &&
                                  window._agl &&
                                  (console.log("here", c),
                                  window._agl.push([
                                    "track",
                                    ["success", { t: c }],
                                  ]));
                            }
                          });
                      })(re.a.ga),
                      "CN" === r)
                    ) {
                      re.a.ga("set", "allowAdFeatures", !1);
                      var h = window._mvq || [];
                      (window._mvq = h),
                        h.push(["$setAccount", "m-28941-0"]),
                        h.push(["$logConversion"]);
                    } else
                      Sr({ region: r, language: o, subdomain: c, env: "prod" });
                  },
                },
                {
                  key: "componentDidMount",
                  value: function () {
                    var t = this.props,
                      e = t.pageTitle,
                      n = t.pageDesc,
                      o = t.pageImg,
                      i = t.region,
                      a = t.language,
                      c = t.subdomain;
                    this.initAOS(),
                      this.handleSetUtmParamsCookie(),
                      te.CCPA.pageAfterLoadHandler(),
                      te.CCPA.resetCCPALocaleCooke({ domain: Ar }),
                      this.initProphetClientOnLoad(),
                      (function (t, e, n) {
                        var o = navigator && navigator.userAgent;
                        if (/micromessenger/i.test(o)) {
                          var i = document.createElement("script");
                          (i.src =
                            "https://res.wx.qq.com/open/js/jweixin-1.6.0.js"),
                            (i.onload = (function () {
                              var o = Object(r.default)(
                                vt().mark(function o() {
                                  var i, a, c, s, u;
                                  return vt().wrap(function (o) {
                                    for (;;)
                                      switch ((o.prev = o.next)) {
                                        case 0:
                                          (i = 1),
                                            (a = Math.floor(
                                              new Date().getTime() / 1e3,
                                            )),
                                            (c = dt()()),
                                            (s =
                                              window.location.href.split(
                                                "#",
                                              )[0]),
                                            (u = (function () {
                                              var t = Object(r.default)(
                                                vt().mark(function t(e) {
                                                  var n, r;
                                                  return vt().wrap(
                                                    function (t) {
                                                      for (;;)
                                                        switch (
                                                          (t.prev = t.next)
                                                        ) {
                                                          case 0:
                                                            return (
                                                              (t.prev = 0),
                                                              (t.next = 3),
                                                              pt.default.request(
                                                                {
                                                                  name: "getWechatSignature",
                                                                  method: "GET",
                                                                  query: {
                                                                    nocache: e,
                                                                    nonceStr: c,
                                                                    timestamp:
                                                                      a,
                                                                    url: s,
                                                                  },
                                                                },
                                                                {},
                                                              )
                                                            );
                                                          case 3:
                                                            return (
                                                              (n = t.sent),
                                                              (t.next = 6),
                                                              n.json()
                                                            );
                                                          case 6:
                                                            200 ===
                                                              (r = t.sent)
                                                                .status &&
                                                              window.wx.config({
                                                                debug: !1,
                                                                appId:
                                                                  r.data.appId,
                                                                timestamp: a,
                                                                nonceStr: c,
                                                                signature:
                                                                  r.data
                                                                    .signature,
                                                                jsApiList: [
                                                                  "updateAppMessageShareData",
                                                                  "updateTimelineShareData",
                                                                ],
                                                              }),
                                                              (t.next = 14);
                                                            break;
                                                          case 10:
                                                            throw (
                                                              ((t.prev = 10),
                                                              (t.t0 =
                                                                t.catch(0)),
                                                              console.log(t.t0),
                                                              t.t0)
                                                            );
                                                          case 14:
                                                          case "end":
                                                            return t.stop();
                                                        }
                                                    },
                                                    t,
                                                    null,
                                                    [[0, 10]],
                                                  );
                                                }),
                                              );
                                              return function (e) {
                                                return t.apply(this, arguments);
                                              };
                                            })())(),
                                            window.wx.ready(function () {
                                              window.wx.updateAppMessageShareData(
                                                {
                                                  title: t,
                                                  desc: e,
                                                  link: s,
                                                  imgUrl: n,
                                                  success: function () {},
                                                },
                                              ),
                                                window.wx.updateTimelineShareData(
                                                  {
                                                    title: t,
                                                    link: s,
                                                    imgUrl: n,
                                                    success: function () {},
                                                  },
                                                );
                                            }),
                                            window.wx.error(function (t) {
                                              var e;
                                              (null === t || void 0 === t
                                                ? void 0
                                                : null === (e = t.errMsg) ||
                                                    void 0 === e
                                                  ? void 0
                                                  : e.indexOf(
                                                      "invalid signature",
                                                    )) > -1 &&
                                                i > 0 &&
                                                ((i -= 1), u(!0)),
                                                console.log("wx error", t);
                                            });
                                        case 8:
                                        case "end":
                                          return o.stop();
                                      }
                                  }, o);
                                }),
                              );
                              return function () {
                                return o.apply(this, arguments);
                              };
                            })()),
                            document.body.appendChild(i);
                        }
                      })(e, n, o),
                      window &&
                        !window.DUI &&
                        (window.DUI = {
                          I18n: { locale: a },
                          Localize: {
                            getCountryUrlPrefix: function () {
                              return ft.a.getUrlPrefix(i, a, c);
                            },
                          },
                          region: i,
                        });
                  },
                },
                {
                  key: "initAOS",
                  value: function () {
                    window &&
                      (["loaded", "complete", "interactive"].includes(
                        document.readyState,
                      )
                        ? $t({
                            delay: 0,
                            duration: 600,
                            easing: "ease-in-out",
                            startEvent: "DOMContentLoaded",
                            once: !0,
                          })
                        : window.addEventListener("load", function () {
                            $t({
                              delay: 0,
                              duration: 600,
                              easing: "ease-in-out",
                              startEvent: "DOMContentLoaded",
                              once: !0,
                            });
                          }));
                  },
                },
                {
                  key: "render",
                  value: function () {
                    var t = this.props,
                      e = t.Component,
                      n = t.pageProps,
                      r = t.store,
                      o = t.accessData,
                      i = r.getState(),
                      a = i.page,
                      c = i.translation,
                      s = i.localization,
                      u = i.context.mobileMode,
                      l = a.data.meta_title,
                      f = ft.a.t(
                        { i18n: c.data, localization: s },
                        "meta.default.title",
                      ),
                      h =
                        -1 !==
                        window.navigator.userAgent
                          .toLocaleLowerCase()
                          .indexOf("msie"),
                      p = !!o && "preview" === o.accessType;
                    return xr(
                      "div",
                      null,
                      xr(
                        ct.a,
                        null,
                        xr("title", null, l || f),
                        xr("meta", {
                          name: "viewport",
                          content: u
                            ? "width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"
                            : "width=device-width,initial-scale=0.5,minimum-scale=0.5",
                        }),
                      ),
                      xr(
                        d.a,
                        { store: r },
                        p && xr(Lt, o),
                        h && xr(Ot, null),
                        xr(e, n),
                      ),
                    );
                  },
                },
              ],
              [
                {
                  key: "getInitialProps",
                  value: (function () {
                    var t = Object(r.default)(
                      jr().mark(function t(e) {
                        var n, r, o, i, a, c, s, u, l;
                        return jr().wrap(function (t) {
                          for (;;)
                            switch ((t.prev = t.next)) {
                              case 0:
                                return (
                                  (n = e.Component),
                                  (r = e.ctx),
                                  t.abrupt("return", {})
                                );
                              case 3:
                                return (
                                  function () {
                                    r.state = r.req.state;
                                    var t,
                                      e = r.store,
                                      n = r.state;
                                    e.dispatch(
                                      ((t = n),
                                      { type: M.a.SET_CONTEXT, data: t }),
                                    ),
                                      delete r.req.state;
                                  },
                                  (o = r.store),
                                  (i = r.state),
                                  (a = i.header),
                                  (c = i.footer),
                                  (s = i.pageData),
                                  (u = void 0 === s ? {} : s),
                                  (l = i.social_image),
                                  (t.next = 9),
                                  o.dispatch(lt.c(r.state.pageData))
                                );
                              case 9:
                                return (t.next = 11), o.dispatch(lt.b(a, c));
                              case 11:
                                return (
                                  (t.next = 13),
                                  o.dispatch(
                                    ((f = r.state.translation),
                                    { type: M.a.INIT_TRANSLATION, text: f }),
                                  )
                                );
                              case 13:
                                if (
                                  ((t.t0 = Lr), (t.t1 = {}), !n.getInitialProps)
                                ) {
                                  t.next = 21;
                                  break;
                                }
                                return (t.next = 18), n.getInitialProps(r);
                              case 18:
                                (t.t2 = t.sent), (t.next = 22);
                                break;
                              case 21:
                                t.t2 = {};
                              case 22:
                                return (
                                  (t.t3 = t.t2),
                                  (t.t4 = (0, t.t0)(t.t1, t.t3)),
                                  (t.t5 = r.state.env || {}),
                                  (t.t6 = r.state.country),
                                  (t.t7 = r.state.language),
                                  (t.t8 = r.state.subdomain),
                                  (t.t9 = u.meta_title),
                                  (t.t10 = u.meta_description),
                                  (t.t11 = r.state.optimize || {}),
                                  (t.t12 =
                                    l ||
                                    "https://www1.djicdn.com/dps/de46652dd99c67d4f8d17607e3bf0dce.jpg"),
                                  (t.t13 = r.state.accessData),
                                  t.abrupt("return", {
                                    pageProps: t.t4,
                                    env: t.t5,
                                    region: t.t6,
                                    language: t.t7,
                                    subdomain: t.t8,
                                    pageTitle: t.t9,
                                    pageDesc: t.t10,
                                    optimize: t.t11,
                                    pageImg: t.t12,
                                    accessData: t.t13,
                                  })
                                );
                              case 34:
                              case "end":
                                return t.stop();
                            }
                          var f;
                        }, t);
                      }),
                    );
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  })(),
                },
                {
                  key: "initProphet",
                  value: function () {
                    var t = JSON.parse(
                      '{"maxPrefetchOnLoadLimit":1,"maxPrefetchOnVisibleLimit":3,"hoverDelay":300,"maxHoverPrefetchLimit":3,"maxTouchStartOrMouseDownPrefetchLimit":3,"prefetchDocumentWhitelistReg":"REGEXP_MATCH_WHITE_LIST_IS_DISABLED","maxPrefetchMainDocumentCount":3,"debug":false,"APIURL":"https://www-api.dji.com/api/prophet","enable":true,"prefetchMainDocumentOnTouchStartOrMouseDown":false,"minLoadEnableThreshold":800,"maxLoadEnableThreshold":5000}',
                    );
                    t.prefetchDocumentWhitelistReg &&
                      "string" === typeof t.prefetchDocumentWhitelistReg &&
                      (t.prefetchDocumentWhitelistReg = new RegExp(
                        t.prefetchDocumentWhitelistReg,
                      )),
                      "function" === typeof requestIdleCallback
                        ? requestIdleCallback(function () {
                            Zt.getInstance(t);
                          })
                        : setTimeout(function () {
                            Zt.getInstance(t);
                          });
                  },
                },
              ],
            ),
            e
          );
        })(v.a);
      e.default = (function (t, e) {
        e = g({}, _, e);
        var n = "undefined" === typeof window,
          r = function (r) {
            var o = r.initialState,
              i = r.ctx,
              a = e.storeKey,
              c = function () {
                return t(e.deserializeState(o), g({}, i, e, { isServer: n }));
              };
            return n
              ? c()
              : (window.hasOwnProperty(a) || (window[a] = c()), window[a]);
          };
        return function (t) {
          var o;
          return (
            ((o = (function (n) {
              function o(t, o) {
                var i = n.call(this, t, o) || this,
                  a = t.initialState;
                return (
                  e.debug &&
                    console.log(
                      "4. WrappedApp.render created new store with initialState",
                      a,
                    ),
                  (i.store = r({ initialState: a })),
                  i
                );
              }
              return (
                y(o, n),
                (o.prototype.render = function () {
                  var e = this.props,
                    n = e.initialProps,
                    r =
                      (e.initialState, b(e, ["initialProps", "initialState"]));
                  return h.a.createElement(
                    t,
                    g({}, r, n, { store: this.store }),
                  );
                }),
                o
              );
            })(f.Component)).displayName =
              "withRedux(" + (t.displayName || t.name || "App") + ")"),
            (o.getInitialProps = function (o) {
              return m(void 0, void 0, void 0, function () {
                var i, a;
                return w(this, function (c) {
                  switch (c.label) {
                    case 0:
                      if (!o) throw new Error("No app context");
                      if (!o.ctx) throw new Error("No page context");
                      return (
                        (i = r({ ctx: o.ctx })),
                        e.debug &&
                          console.log(
                            "1. WrappedApp.getInitialProps wrapper got the store with state",
                            i.getState(),
                          ),
                        (o.ctx.store = i),
                        (o.ctx.isServer = n),
                        (a = {}),
                        "getInitialProps" in t
                          ? [4, t.getInitialProps.call(t, o)]
                          : [3, 2]
                      );
                    case 1:
                      (a = c.sent()), (c.label = 2);
                    case 2:
                      return (
                        e.debug &&
                          console.log(
                            "3. WrappedApp.getInitialProps has store state",
                            i.getState(),
                          ),
                        [
                          2,
                          {
                            isServer: n,
                            initialState: e.serializeState(i.getState()),
                            initialProps: a,
                          },
                        ]
                      );
                  }
                });
              });
            }),
            o
          );
        };
      })(
        function (t) {
          return it(nt, t, ot);
        },
        { debug: !1 },
      )(Pr);
    },
    "2oH+": function (t, e, n) {
      (function (t, n) {
        var r = 200,
          o = "__lodash_hash_undefined__",
          i = 800,
          a = 16,
          c = 9007199254740991,
          s = "[object Arguments]",
          u = "[object AsyncFunction]",
          l = "[object Function]",
          f = "[object GeneratorFunction]",
          h = "[object Null]",
          d = "[object Object]",
          p = "[object Proxy]",
          v = "[object Undefined]",
          y = /^\[object .+?Constructor\]$/,
          g = /^(?:0|[1-9]\d*)$/,
          m = {};
        (m["[object Float32Array]"] =
          m["[object Float64Array]"] =
          m["[object Int8Array]"] =
          m["[object Int16Array]"] =
          m["[object Int32Array]"] =
          m["[object Uint8Array]"] =
          m["[object Uint8ClampedArray]"] =
          m["[object Uint16Array]"] =
          m["[object Uint32Array]"] =
            !0),
          (m[s] =
            m["[object Array]"] =
            m["[object ArrayBuffer]"] =
            m["[object Boolean]"] =
            m["[object DataView]"] =
            m["[object Date]"] =
            m["[object Error]"] =
            m[l] =
            m["[object Map]"] =
            m["[object Number]"] =
            m[d] =
            m["[object RegExp]"] =
            m["[object Set]"] =
            m["[object String]"] =
            m["[object WeakMap]"] =
              !1);
        var w = "object" == typeof t && t && t.Object === Object && t,
          b = "object" == typeof self && self && self.Object === Object && self,
          _ = w || b || Function("return this")(),
          O = e && !e.nodeType && e,
          E = O && "object" == typeof n && n && !n.nodeType && n,
          S = E && E.exports === O,
          x = S && w.process,
          j = (function () {
            try {
              var t = E && E.require && E.require("util").types;
              return t || (x && x.binding && x.binding("util"));
            } catch (e) {}
          })(),
          k = j && j.isTypedArray;
        function L(t, e, n) {
          switch (n.length) {
            case 0:
              return t.call(e);
            case 1:
              return t.call(e, n[0]);
            case 2:
              return t.call(e, n[0], n[1]);
            case 3:
              return t.call(e, n[0], n[1], n[2]);
          }
          return t.apply(e, n);
        }
        var T,
          A,
          P = Array.prototype,
          I = Function.prototype,
          N = Object.prototype,
          C = _["__core-js_shared__"],
          D = I.toString,
          R = N.hasOwnProperty,
          M = (function () {
            var t = /[^.]+$/.exec((C && C.keys && C.keys.IE_PROTO) || "");
            return t ? "Symbol(src)_1." + t : "";
          })(),
          F = N.toString,
          U = D.call(Object),
          G = RegExp(
            "^" +
              D.call(R)
                .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
                .replace(
                  /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                  "$1.*?",
                ) +
              "$",
          ),
          B = S ? _.Buffer : void 0,
          H = _.Symbol,
          z = _.Uint8Array,
          V = B ? B.allocUnsafe : void 0,
          W =
            ((T = Object.getPrototypeOf),
            (A = Object),
            function (t) {
              return T(A(t));
            }),
          q = Object.create,
          J = N.propertyIsEnumerable,
          Y = P.splice,
          K = H ? H.toStringTag : void 0,
          $ = (function () {
            try {
              var t = _t(Object, "defineProperty");
              return t({}, "", {}), t;
            } catch (e) {}
          })(),
          X = B ? B.isBuffer : void 0,
          Q = Math.max,
          Z = Date.now,
          tt = _t(_, "Map"),
          et = _t(Object, "create"),
          nt = (function () {
            function t() {}
            return function (e) {
              if (!Nt(e)) return {};
              if (q) return q(e);
              t.prototype = e;
              var n = new t();
              return (t.prototype = void 0), n;
            };
          })();
        function rt(t) {
          var e = -1,
            n = null == t ? 0 : t.length;
          for (this.clear(); ++e < n; ) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }
        function ot(t) {
          var e = -1,
            n = null == t ? 0 : t.length;
          for (this.clear(); ++e < n; ) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }
        function it(t) {
          var e = -1,
            n = null == t ? 0 : t.length;
          for (this.clear(); ++e < n; ) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }
        function at(t) {
          var e = (this.__data__ = new ot(t));
          this.size = e.size;
        }
        function ct(t, e) {
          var n = Lt(t),
            r = !n && kt(t),
            o = !n && !r && At(t),
            i = !n && !r && !o && Dt(t),
            a = n || r || o || i,
            c = a
              ? (function (t, e) {
                  for (var n = -1, r = Array(t); ++n < t; ) r[n] = e(n);
                  return r;
                })(t.length, String)
              : [],
            s = c.length;
          for (var u in t)
            (!e && !R.call(t, u)) ||
              (a &&
                ("length" == u ||
                  (o && ("offset" == u || "parent" == u)) ||
                  (i &&
                    ("buffer" == u ||
                      "byteLength" == u ||
                      "byteOffset" == u)) ||
                  Ot(u, s))) ||
              c.push(u);
          return c;
        }
        function st(t, e, n) {
          ((void 0 === n || jt(t[e], n)) && (void 0 !== n || e in t)) ||
            ft(t, e, n);
        }
        function ut(t, e, n) {
          var r = t[e];
          (R.call(t, e) && jt(r, n) && (void 0 !== n || e in t)) || ft(t, e, n);
        }
        function lt(t, e) {
          for (var n = t.length; n--; ) if (jt(t[n][0], e)) return n;
          return -1;
        }
        function ft(t, e, n) {
          "__proto__" == e && $
            ? $(t, e, {
                configurable: !0,
                enumerable: !0,
                value: n,
                writable: !0,
              })
            : (t[e] = n);
        }
        (rt.prototype.clear = function () {
          (this.__data__ = et ? et(null) : {}), (this.size = 0);
        }),
          (rt.prototype.delete = function (t) {
            var e = this.has(t) && delete this.__data__[t];
            return (this.size -= e ? 1 : 0), e;
          }),
          (rt.prototype.get = function (t) {
            var e = this.__data__;
            if (et) {
              var n = e[t];
              return n === o ? void 0 : n;
            }
            return R.call(e, t) ? e[t] : void 0;
          }),
          (rt.prototype.has = function (t) {
            var e = this.__data__;
            return et ? void 0 !== e[t] : R.call(e, t);
          }),
          (rt.prototype.set = function (t, e) {
            var n = this.__data__;
            return (
              (this.size += this.has(t) ? 0 : 1),
              (n[t] = et && void 0 === e ? o : e),
              this
            );
          }),
          (ot.prototype.clear = function () {
            (this.__data__ = []), (this.size = 0);
          }),
          (ot.prototype.delete = function (t) {
            var e = this.__data__,
              n = lt(e, t);
            return (
              !(n < 0) &&
              (n == e.length - 1 ? e.pop() : Y.call(e, n, 1), --this.size, !0)
            );
          }),
          (ot.prototype.get = function (t) {
            var e = this.__data__,
              n = lt(e, t);
            return n < 0 ? void 0 : e[n][1];
          }),
          (ot.prototype.has = function (t) {
            return lt(this.__data__, t) > -1;
          }),
          (ot.prototype.set = function (t, e) {
            var n = this.__data__,
              r = lt(n, t);
            return r < 0 ? (++this.size, n.push([t, e])) : (n[r][1] = e), this;
          }),
          (it.prototype.clear = function () {
            (this.size = 0),
              (this.__data__ = {
                hash: new rt(),
                map: new (tt || ot)(),
                string: new rt(),
              });
          }),
          (it.prototype.delete = function (t) {
            var e = bt(this, t).delete(t);
            return (this.size -= e ? 1 : 0), e;
          }),
          (it.prototype.get = function (t) {
            return bt(this, t).get(t);
          }),
          (it.prototype.has = function (t) {
            return bt(this, t).has(t);
          }),
          (it.prototype.set = function (t, e) {
            var n = bt(this, t),
              r = n.size;
            return n.set(t, e), (this.size += n.size == r ? 0 : 1), this;
          }),
          (at.prototype.clear = function () {
            (this.__data__ = new ot()), (this.size = 0);
          }),
          (at.prototype.delete = function (t) {
            var e = this.__data__,
              n = e.delete(t);
            return (this.size = e.size), n;
          }),
          (at.prototype.get = function (t) {
            return this.__data__.get(t);
          }),
          (at.prototype.has = function (t) {
            return this.__data__.has(t);
          }),
          (at.prototype.set = function (t, e) {
            var n = this.__data__;
            if (n instanceof ot) {
              var o = n.__data__;
              if (!tt || o.length < r - 1)
                return o.push([t, e]), (this.size = ++n.size), this;
              n = this.__data__ = new it(o);
            }
            return n.set(t, e), (this.size = n.size), this;
          });
        var ht,
          dt = function (t, e, n) {
            for (var r = -1, o = Object(t), i = n(t), a = i.length; a--; ) {
              var c = i[ht ? a : ++r];
              if (!1 === e(o[c], c, o)) break;
            }
            return t;
          };
        function pt(t) {
          return null == t
            ? void 0 === t
              ? v
              : h
            : K && K in Object(t)
              ? (function (t) {
                  var e = R.call(t, K),
                    n = t[K];
                  try {
                    t[K] = void 0;
                    var r = !0;
                  } catch (i) {}
                  var o = F.call(t);
                  r && (e ? (t[K] = n) : delete t[K]);
                  return o;
                })(t)
              : (function (t) {
                  return F.call(t);
                })(t);
        }
        function vt(t) {
          return Ct(t) && pt(t) == s;
        }
        function yt(t) {
          return (
            !(
              !Nt(t) ||
              (function (t) {
                return !!M && M in t;
              })(t)
            ) &&
            (Pt(t) ? G : y).test(
              (function (t) {
                if (null != t) {
                  try {
                    return D.call(t);
                  } catch (e) {}
                  try {
                    return t + "";
                  } catch (e) {}
                }
                return "";
              })(t),
            )
          );
        }
        function gt(t) {
          if (!Nt(t))
            return (function (t) {
              var e = [];
              if (null != t) for (var n in Object(t)) e.push(n);
              return e;
            })(t);
          var e = Et(t),
            n = [];
          for (var r in t)
            ("constructor" != r || (!e && R.call(t, r))) && n.push(r);
          return n;
        }
        function mt(t, e, n, r, o) {
          t !== e &&
            dt(
              e,
              function (i, a) {
                if ((o || (o = new at()), Nt(i)))
                  !(function (t, e, n, r, o, i, a) {
                    var c = St(t, n),
                      s = St(e, n),
                      u = a.get(s);
                    if (u) return void st(t, n, u);
                    var l = i ? i(c, s, n + "", t, e, a) : void 0,
                      f = void 0 === l;
                    if (f) {
                      var h = Lt(s),
                        p = !h && At(s),
                        v = !h && !p && Dt(s);
                      (l = s),
                        h || p || v
                          ? Lt(c)
                            ? (l = c)
                            : Ct((y = c)) && Tt(y)
                              ? (l = (function (t, e) {
                                  var n = -1,
                                    r = t.length;
                                  e || (e = Array(r));
                                  for (; ++n < r; ) e[n] = t[n];
                                  return e;
                                })(c))
                              : p
                                ? ((f = !1),
                                  (l = (function (t, e) {
                                    if (e) return t.slice();
                                    var n = t.length,
                                      r = V ? V(n) : new t.constructor(n);
                                    return t.copy(r), r;
                                  })(s, !0)))
                                : v
                                  ? ((f = !1),
                                    (l = (function (t, e) {
                                      var n = e
                                        ? (function (t) {
                                            var e = new t.constructor(
                                              t.byteLength,
                                            );
                                            return new z(e).set(new z(t)), e;
                                          })(t.buffer)
                                        : t.buffer;
                                      return new t.constructor(
                                        n,
                                        t.byteOffset,
                                        t.length,
                                      );
                                    })(s, !0)))
                                  : (l = [])
                          : (function (t) {
                                if (!Ct(t) || pt(t) != d) return !1;
                                var e = W(t);
                                if (null === e) return !0;
                                var n =
                                  R.call(e, "constructor") && e.constructor;
                                return (
                                  "function" == typeof n &&
                                  n instanceof n &&
                                  D.call(n) == U
                                );
                              })(s) || kt(s)
                            ? ((l = c),
                              kt(c)
                                ? (l = (function (t) {
                                    return (function (t, e, n, r) {
                                      var o = !n;
                                      n || (n = {});
                                      var i = -1,
                                        a = e.length;
                                      for (; ++i < a; ) {
                                        var c = e[i],
                                          s = r
                                            ? r(n[c], t[c], c, n, t)
                                            : void 0;
                                        void 0 === s && (s = t[c]),
                                          o ? ft(n, c, s) : ut(n, c, s);
                                      }
                                      return n;
                                    })(t, Rt(t));
                                  })(c))
                                : (Nt(c) && !Pt(c)) ||
                                  (l = (function (t) {
                                    return "function" != typeof t.constructor ||
                                      Et(t)
                                      ? {}
                                      : nt(W(t));
                                  })(s)))
                            : (f = !1);
                    }
                    var y;
                    f && (a.set(s, l), o(l, s, r, i, a), a.delete(s));
                    st(t, n, l);
                  })(t, e, a, n, mt, r, o);
                else {
                  var c = r ? r(St(t, a), i, a + "", t, e, o) : void 0;
                  void 0 === c && (c = i), st(t, a, c);
                }
              },
              Rt,
            );
        }
        function wt(t, e) {
          return xt(
            (function (t, e, n) {
              return (
                (e = Q(void 0 === e ? t.length - 1 : e, 0)),
                function () {
                  for (
                    var r = arguments,
                      o = -1,
                      i = Q(r.length - e, 0),
                      a = Array(i);
                    ++o < i;

                  )
                    a[o] = r[e + o];
                  o = -1;
                  for (var c = Array(e + 1); ++o < e; ) c[o] = r[o];
                  return (c[e] = n(a)), L(t, this, c);
                }
              );
            })(t, e, Ut),
            t + "",
          );
        }
        function bt(t, e) {
          var n = t.__data__;
          return (function (t) {
            var e = typeof t;
            return "string" == e ||
              "number" == e ||
              "symbol" == e ||
              "boolean" == e
              ? "__proto__" !== t
              : null === t;
          })(e)
            ? n["string" == typeof e ? "string" : "hash"]
            : n.map;
        }
        function _t(t, e) {
          var n = (function (t, e) {
            return null == t ? void 0 : t[e];
          })(t, e);
          return yt(n) ? n : void 0;
        }
        function Ot(t, e) {
          var n = typeof t;
          return (
            !!(e = null == e ? c : e) &&
            ("number" == n || ("symbol" != n && g.test(t))) &&
            t > -1 &&
            t % 1 == 0 &&
            t < e
          );
        }
        function Et(t) {
          var e = t && t.constructor;
          return t === (("function" == typeof e && e.prototype) || N);
        }
        function St(t, e) {
          if (
            ("constructor" !== e || "function" !== typeof t[e]) &&
            "__proto__" != e
          )
            return t[e];
        }
        var xt = (function (t) {
          var e = 0,
            n = 0;
          return function () {
            var r = Z(),
              o = a - (r - n);
            if (((n = r), o > 0)) {
              if (++e >= i) return arguments[0];
            } else e = 0;
            return t.apply(void 0, arguments);
          };
        })(
          $
            ? function (t, e) {
                return $(t, "toString", {
                  configurable: !0,
                  enumerable: !1,
                  value:
                    ((n = e),
                    function () {
                      return n;
                    }),
                  writable: !0,
                });
                var n;
              }
            : Ut,
        );
        function jt(t, e) {
          return t === e || (t !== t && e !== e);
        }
        var kt = vt(
            (function () {
              return arguments;
            })(),
          )
            ? vt
            : function (t) {
                return Ct(t) && R.call(t, "callee") && !J.call(t, "callee");
              },
          Lt = Array.isArray;
        function Tt(t) {
          return null != t && It(t.length) && !Pt(t);
        }
        var At =
          X ||
          function () {
            return !1;
          };
        function Pt(t) {
          if (!Nt(t)) return !1;
          var e = pt(t);
          return e == l || e == f || e == u || e == p;
        }
        function It(t) {
          return "number" == typeof t && t > -1 && t % 1 == 0 && t <= c;
        }
        function Nt(t) {
          var e = typeof t;
          return null != t && ("object" == e || "function" == e);
        }
        function Ct(t) {
          return null != t && "object" == typeof t;
        }
        var Dt = k
          ? (function (t) {
              return function (e) {
                return t(e);
              };
            })(k)
          : function (t) {
              return Ct(t) && It(t.length) && !!m[pt(t)];
            };
        function Rt(t) {
          return Tt(t) ? ct(t, !0) : gt(t);
        }
        var Mt,
          Ft =
            ((Mt = function (t, e, n) {
              mt(t, e, n);
            }),
            wt(function (t, e) {
              var n = -1,
                r = e.length,
                o = r > 1 ? e[r - 1] : void 0,
                i = r > 2 ? e[2] : void 0;
              for (
                o = Mt.length > 3 && "function" == typeof o ? (r--, o) : void 0,
                  i &&
                    (function (t, e, n) {
                      if (!Nt(n)) return !1;
                      var r = typeof e;
                      return (
                        !!("number" == r
                          ? Tt(n) && Ot(e, n.length)
                          : "string" == r && (e in n)) && jt(n[e], t)
                      );
                    })(e[0], e[1], i) &&
                    ((o = r < 3 ? void 0 : o), (r = 1)),
                  t = Object(t);
                ++n < r;

              ) {
                var a = e[n];
                a && Mt(t, a, n, o);
              }
              return t;
            }));
        function Ut(t) {
          return t;
        }
        n.exports = Ft;
      }).call(this, n("yLpj"), n("YuTi")(t));
    },
    4: function (t, e, n) {
      n("GcxT"), (t.exports = n("nOHt"));
    },
    "9/5/": function (t, e, n) {
      (function (e) {
        var n = "Expected a function",
          r = NaN,
          o = "[object Symbol]",
          i = /^\s+|\s+$/g,
          a = /^[-+]0x[0-9a-f]+$/i,
          c = /^0b[01]+$/i,
          s = /^0o[0-7]+$/i,
          u = parseInt,
          l = "object" == typeof e && e && e.Object === Object && e,
          f = "object" == typeof self && self && self.Object === Object && self,
          h = l || f || Function("return this")(),
          d = Object.prototype.toString,
          p = Math.max,
          v = Math.min,
          y = function () {
            return h.Date.now();
          };
        function g(t) {
          var e = typeof t;
          return !!t && ("object" == e || "function" == e);
        }
        function m(t) {
          if ("number" == typeof t) return t;
          if (
            (function (t) {
              return (
                "symbol" == typeof t ||
                ((function (t) {
                  return !!t && "object" == typeof t;
                })(t) &&
                  d.call(t) == o)
              );
            })(t)
          )
            return r;
          if (g(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = g(e) ? e + "" : e;
          }
          if ("string" != typeof t) return 0 === t ? t : +t;
          t = t.replace(i, "");
          var n = c.test(t);
          return n || s.test(t) ? u(t.slice(2), n ? 2 : 8) : a.test(t) ? r : +t;
        }
        t.exports = function (t, e, r) {
          var o,
            i,
            a,
            c,
            s,
            u,
            l = 0,
            f = !1,
            h = !1,
            d = !0;
          if ("function" != typeof t) throw new TypeError(n);
          function w(e) {
            var n = o,
              r = i;
            return (o = i = void 0), (l = e), (c = t.apply(r, n));
          }
          function b(t) {
            var n = t - u;
            return void 0 === u || n >= e || n < 0 || (h && t - l >= a);
          }
          function _() {
            var t = y();
            if (b(t)) return O(t);
            s = setTimeout(
              _,
              (function (t) {
                var n = e - (t - u);
                return h ? v(n, a - (t - l)) : n;
              })(t),
            );
          }
          function O(t) {
            return (s = void 0), d && o ? w(t) : ((o = i = void 0), c);
          }
          function E() {
            var t = y(),
              n = b(t);
            if (((o = arguments), (i = this), (u = t), n)) {
              if (void 0 === s)
                return (function (t) {
                  return (l = t), (s = setTimeout(_, e)), f ? w(t) : c;
                })(u);
              if (h) return (s = setTimeout(_, e)), w(u);
            }
            return void 0 === s && (s = setTimeout(_, e)), c;
          }
          return (
            (e = m(e) || 0),
            g(r) &&
              ((f = !!r.leading),
              (a = (h = "maxWait" in r) ? p(m(r.maxWait) || 0, e) : a),
              (d = "trailing" in r ? !!r.trailing : d)),
            (E.cancel = function () {
              void 0 !== s && clearTimeout(s),
                (l = 0),
                (o = u = i = s = void 0);
            }),
            (E.flush = function () {
              return void 0 === s ? c : O(y());
            }),
            E
          );
        };
      }).call(this, n("yLpj"));
    },
    Agtg: function (t, e, n) {
      "use strict";
      n.d(e, "a", function () {
        return l;
      }),
        n.d(e, "b", function () {
          return f;
        });
      var r = n("1OyB"),
        o = n("vuIU"),
        i = n("rePB"),
        a = n("gn4A"),
        c = n.n(a),
        s = n("hKI/"),
        u = n.n(s),
        l = (function (t) {
          return (t.UP = "up"), (t.DOWN = "down"), (t.NONE = "none"), t;
        })({}),
        f = (function () {
          function t() {
            Object(r.default)(this, t),
              Object(i.a)(this, "dimensionInfo", void 0),
              Object(i.a)(this, "fastScrollThreshold", 0),
              Object(i.a)(this, "isFastScroll", !1),
              Object(i.a)(this, "isAnchorScroll", !1),
              Object(i.a)(this, "scrollDirection", l.NONE),
              Object(i.a)(this, "scrollingTimeout", void 0),
              Object(i.a)(this, "anchor", ""),
              Object(i.a)(this, "listeners", new Map()),
              (this.dimensionInfo = {
                pageOffsetY: window.scrollY,
                pageOffsetX: window.scrollX,
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
                scrollDelta: 0,
                isOffsetValid: !0,
                isSizeValid: !0,
              }),
              (this.anchor = window.location.hash),
              (this.fastScrollThreshold = c.a.isMobile() ? 600 : 1e3),
              this.addListener();
          }
          return (
            Object(o.default)(t, [
              {
                key: "addDimensionListener",
                value: function (t, e) {
                  t && this.listeners.set(t, e);
                },
              },
              {
                key: "removeDimensionListener",
                value: function (t) {
                  this.listeners.delete(t);
                },
              },
              {
                key: "scrollDelta",
                get: function () {
                  return (
                    this.dimensionInfo.isOffsetValid || this.calcScrollOffset(),
                    this.dimensionInfo.scrollDelta
                  );
                },
              },
              {
                key: "isSizeValid",
                get: function () {
                  return this.dimensionInfo.isSizeValid;
                },
              },
              {
                key: "isOffsetValid",
                get: function () {
                  return this.dimensionInfo.isOffsetValid;
                },
              },
              {
                key: "pageOffsetX",
                get: function () {
                  return (
                    this.dimensionInfo.isOffsetValid ||
                      ((this.dimensionInfo.pageOffsetX = window.scrollX),
                      (this.dimensionInfo.isOffsetValid = !0)),
                    this.dimensionInfo.pageOffsetX
                  );
                },
              },
              {
                key: "pageOffsetY",
                get: function () {
                  return (
                    this.dimensionInfo.isOffsetValid || this.calcScrollOffset(),
                    this.dimensionInfo.pageOffsetY
                  );
                },
              },
              {
                key: "innerWidth",
                get: function () {
                  return (
                    this.dimensionInfo.isSizeValid ||
                      ((this.dimensionInfo.isSizeValid = !0),
                      (this.dimensionInfo.innerWidth = window.innerWidth)),
                    this.dimensionInfo.innerWidth
                  );
                },
                set: function (t) {
                  (this.dimensionInfo.isSizeValid = !0),
                    (this.dimensionInfo.innerWidth = t);
                },
              },
              {
                key: "innerHeight",
                get: function () {
                  return (
                    this.dimensionInfo.isSizeValid ||
                      ((this.dimensionInfo.isSizeValid = !0),
                      (this.dimensionInfo.innerHeight = window.innerHeight)),
                    this.dimensionInfo.innerHeight
                  );
                },
                set: function (t) {
                  (this.dimensionInfo.isSizeValid = !0),
                    (this.dimensionInfo.innerHeight = t);
                },
              },
              {
                key: "getDirection",
                value: function () {
                  return this.calcScrollOffset(), this.scrollDirection;
                },
              },
              {
                key: "updateOffset",
                value: function () {
                  (this.dimensionInfo.pageOffsetY = window.scrollY),
                    (this.dimensionInfo.pageOffsetX = window.scrollX),
                    (this.dimensionInfo.isOffsetValid = !0);
                },
              },
              {
                key: "calcScrollOffset",
                value: function () {
                  var t = window.scrollY,
                    e = t - this.dimensionInfo.pageOffsetY;
                  e > 0
                    ? (this.scrollDirection = l.DOWN)
                    : e < 0 && (this.scrollDirection = l.UP),
                    (this.dimensionInfo.scrollDelta = Math.abs(e)),
                    (this.dimensionInfo.pageOffsetY = t),
                    (this.dimensionInfo.isOffsetValid = !0),
                    this.dimensionInfo.scrollDelta > this.fastScrollThreshold
                      ? (this.isFastScroll = !0)
                      : (this.isFastScroll = !1);
                },
              },
              {
                key: "addListener",
                value: function () {
                  window.addEventListener(
                    "resize",
                    u()(this.onResize.bind(this), 300),
                    { passive: !0 },
                  ),
                    window.addEventListener(
                      "scroll",
                      this.onScroll.bind(this),
                      { passive: !0 },
                    ),
                    window.addEventListener(
                      "orientationchange",
                      this.onRotate.bind(this),
                      { passive: !0 },
                    ),
                    window.addEventListener(
                      "popstate",
                      this.onPageRestore.bind(this),
                      !1,
                    ),
                    window.addEventListener(
                      "pageshow",
                      this.onPageRestore.bind(this),
                    );
                },
              },
              {
                key: "onPageRestore",
                value: function () {
                  var t = this;
                  setTimeout(function () {
                    t.onScroll();
                  }, 1e3);
                },
              },
              {
                key: "onResize",
                value: function () {
                  (this.dimensionInfo.isSizeValid = !1),
                    requestAnimationFrame(this.handleResize.bind(this));
                },
              },
              {
                key: "onScroll",
                value: function () {
                  requestAnimationFrame(this.handleScroll.bind(this));
                },
              },
              {
                key: "onRotate",
                value: function () {
                  requestAnimationFrame(this.handleRotate.bind(this));
                },
              },
              {
                key: "handleScroll",
                value: function () {
                  var t = this;
                  this.dimensionInfo.isOffsetValid &&
                    (window.location.hash !== this.anchor &&
                      (this.isAnchorScroll = !0),
                    (this.dimensionInfo.isOffsetValid = !1),
                    this.listeners.forEach(function (e) {
                      var n;
                      null === (n = e.onScrollStart) ||
                        void 0 === n ||
                        n.call(e, t);
                    }));
                  this.listeners.forEach(function (e) {
                    var n;
                    null === (n = e.onScroll) || void 0 === n || n.call(e, t);
                  }),
                    clearTimeout(this.scrollingTimeout),
                    (this.scrollingTimeout = setTimeout(function () {
                      (t.isFastScroll = !1),
                        (t.dimensionInfo.isOffsetValid = !0),
                        (t.dimensionInfo.scrollDelta = 0),
                        (t.scrollDirection = l.NONE),
                        t.listeners.forEach(function (e) {
                          var n;
                          null === (n = e.onScrollEnd) ||
                            void 0 === n ||
                            n.call(e, t);
                        }),
                        (t.isAnchorScroll = !1),
                        (t.anchor = window.location.hash);
                    }, 1e3));
                },
              },
              {
                key: "handleResize",
                value: function () {
                  var t = this;
                  (this.dimensionInfo.isOffsetValid = !1),
                    this.listeners.forEach(function (e) {
                      var n;
                      null === (n = e.onResize) || void 0 === n || n.call(e, t);
                    });
                },
              },
              {
                key: "handleRotate",
                value: function () {
                  var t = this;
                  (this.dimensionInfo.isOffsetValid = !1),
                    this.listeners.forEach(function (e) {
                      var n;
                      null === (n = e.onRotate) || void 0 === n || n.call(e, t);
                    });
                },
              },
            ]),
            t
          );
        })();
    },
    EP0T: function (t, e, n) {
      "use strict";
      var r = n("1OyB"),
        o = n("vuIU"),
        i = n("md7G"),
        a = n("foSv"),
        c = n("Ji7U"),
        s = n("q1tI"),
        u = n.n(s),
        l = u.a.createElement;
      function f(t, e, n) {
        return (
          (e = Object(a.a)(e)),
          Object(i.a)(
            t,
            (function () {
              try {
                var t = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (t) {}
              return (function () {
                return !!t;
              })();
            })()
              ? Reflect.construct(e, n || [], Object(a.a)(t).constructor)
              : e.apply(t, n),
          )
        );
      }
      var h = (function (t) {
        function e(t) {
          var n;
          return (
            Object(r.default)(this, e),
            ((n = f(this, e, [t])).state = { hasError: !1 }),
            n
          );
        }
        return (
          Object(c.a)(e, t),
          Object(o.default)(
            e,
            [
              {
                key: "componentDidCatch",
                value: function (t, e) {
                  console.log({ error: t, errorInfo: e });
                },
              },
              {
                key: "render",
                value: function () {
                  return this.state.hasError
                    ? l(u.a.Fragment, null)
                    : this.props.children;
                },
              },
            ],
            [
              {
                key: "getDerivedStateFromError",
                value: function () {
                  return { hasError: !0 };
                },
              },
            ],
          ),
          e
        );
      })(u.a.Component);
      e.a = h;
    },
    Fe7O: function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = void 0);
      var r = {
        attributeNames: { styleName: "className" },
        generateScopedName: "[path]___[name]__[local]___[hash:base64:5]",
        handleMissingStyleName: "throw",
      };
      e.default = r;
    },
    GcxT: function (t, e, n) {
      (window.__NEXT_P = window.__NEXT_P || []).push([
        "/_app",
        function () {
          return n("1TCz");
        },
      ]);
    },
    LpSC: function (t, e, n) {
      n("K64n"), (t.exports = self.fetch.bind(self));
    },
    Ntax: function (t, e, n) {
      "use strict";
      n.d(e, "b", function () {
        return a;
      }),
        n.d(e, "c", function () {
          return c;
        });
      var r = n("wCCn"),
        o = n.n(r),
        i = "https://www1.djicdn.com";
      function a(t) {
        return "".concat(i, "/dps/").concat(t);
      }
      function c(t) {
        return { backgroundImage: "url('".concat(a(t), "')") };
      }
      e.a = function () {
        return new o.a({
          cdn: "www1.djicdn.com",
          path: "dps",
          lazyLoad: !0,
          combo: [
            { name: "default_" },
            { name: "default_webp" },
            { name: "default_1x" },
            { name: "default_1x_webp" },
            { name: "origin" },
          ],
        });
      };
    },
    RpOT: function (t, e, n) {},
    S5C5: function (t, e, n) {
      "use strict";
      n.d(e, "d", function () {
        return h;
      }),
        n.d(e, "e", function () {
          return d;
        }),
        n.d(e, "a", function () {
          return p;
        }),
        n.d(e, "l", function () {
          return v;
        }),
        n.d(e, "j", function () {
          return y;
        }),
        n.d(e, "i", function () {
          return g;
        }),
        n.d(e, "m", function () {
          return m;
        }),
        n.d(e, "k", function () {
          return w;
        }),
        n.d(e, "f", function () {
          return b;
        }),
        n.d(e, "b", function () {
          return _;
        }),
        n.d(e, "h", function () {
          return O;
        }),
        n.d(e, "c", function () {
          return E;
        }),
        n.d(e, "g", function () {
          return S;
        });
      var r = n("ODXe"),
        o = n("yWgo"),
        i = n("ZO6J"),
        a = "https://terminator.djiits.com",
        c = "https://dji-official-fe.djicdn.com",
        s = "true",
        u = "https://www1.djicdn.com",
        l = JSON.parse(
          '{"official_api":{"test":{"host":"//test-www-api.dbeta.me"},"dev":{"host":"//test-www-api.dbeta.me"},"stag":{"host":"//test-www-api.dbeta.me"},"production":{"host":"//www-api.dji.com"},"master":{"host":"//www-api.dji.com"},"host":"//www-api.dji.com"},"official":{"host":"https://www.dji.com"},"product_center":{"dev":{"host":"https://product.dbeta.me"},"test":{"host":"https://product.dbeta.me"},"stag":{"host":"https://r-product.dbeta.me"},"prod":{"host":"https://product.dji.com"},"host":"https://product.dji.com"},"store-mobile":{"dev":{"host":"m.dbeta.me"},"test":{"host":"m.dbeta.me"},"stag":{"host":"r-m.dbeta.me"},"prod":{"host":"m.dji.com"},"host":"m.dji.com"},"store-pc":{"dev":{"host":"store.dbeta.me"},"test":{"host":"store.dbeta.me"},"stag":{"host":"r-store.dbeta.me"},"prod":{"host":"store.dji.com"},"host":"store.dji.com"},"account-mobile":{"dev":{"host":"m.dbeta.me"},"test":{"host":"m.dbeta.me"},"stag":{"host":"r-m.dbeta.me"},"prod":{"host":"m.dji.com"},"host":"m.dji.com"},"account-pc":{"dev":{"host":"accounts.dbeta.me"},"test":{"host":"accounts.dbeta.me"},"stag":{"host":"r-accounts.dbeta.me"},"prod":{"host":"accounts.dji.com"},"host":"accounts.dji.com"},"repair":{"dev":{"host":"repair.dbeta.me"},"test":{"host":"repair.dbeta.me"},"stag":{"host":"support.dji.com"},"prod":{"host":"support.dji.com"},"host":"support.dji.com"},"stormsend":{"dev":{"host":"https://stormsend.dbeta.me"},"test":{"host":"https://stormsend.dbeta.me","host_bak":"https://stormsend.dbeta.me"},"stag":{"host":"https://stag-stormsend-api.dbeta.me"},"prod":{"host":"https://stormsend-api.djiits.com"},"host":"https://stormsend-api.djiits.com"}}',
        ),
        f = !1;
      if (!a) throw new Error("apiHost undefined!");
      function h(t, e, n, r) {
        return -1 !== i.a.indexOf(e)
          ? n(
              "nav" === r
                ? "v4.common.button.wheretobuy_text.nav"
                : "v4.common.button.wheretobuy_text",
            )
          : t;
      }
      function d(t, e, n) {
        return -1 !== i.a.indexOf(n) ? t : e;
      }
      function p(t) {
        return "".concat(a).concat(t);
      }
      function v(t) {
        var e = ""
          .concat(window.location.protocol, "//")
          .concat(window.location.host);
        return "".concat(e).concat(t);
      }
      function y(t) {
        return f
          ? /^(https?:)?\/\/(store|m|stag-store|r-store|stag-m|test-store|test-m)\.((dbeta\.me)|(dji\.com))/.test(
              t,
            )
          : /^(https?:)?\/\/(store|m)\.(dji\.com)/.test(t);
      }
      function g(t) {
        arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (((t = t.trim()), /^(https?:)?\/\//.test(t)))
          return t.replace(/^https?:/, "");
        var e =
          "https://www.dji.com" +
          (/some_hard_condition/.test(t) ? "" : "/") +
          t;
        return (
          /\b\/\/+/.test(e) && (e = e.replace(/\b\/\/+/g, "/")),
          "/" !== e && /\/$/g.test(e) && (e = e.substring(0, e.length - 1)),
          e
        );
      }
      function m(t) {
        if (/(s3\.amazonaws|djicdn\.com)/gi.test(t)) return t;
        var e = u || "";
        return s && c && (e = c), "".concat(e, "/").concat(t);
      }
      function w(t) {
        var e = t.domain,
          n = t.url,
          r = t.country,
          a = void 0 === r ? "" : r,
          c = t.locale,
          s = void 0 === c ? "" : c,
          u = t.mobileMode,
          f = void 0 !== u && u,
          h = "",
          d = n,
          p = f ? "/mobile" : "";
        if (!!/^(https?:)?\/\//.test(n)) return n;
        e &&
          (h = (function (t) {
            var e = t.domain,
              n = t.mobileMode;
            "store" === e && n && (e = "m");
            var r = l.official;
            return ((r.production && r.production.host) || r.host).replace(
              /w{3,}/,
              e,
            );
          })(t));
        var v = "";
        /^[A-Za-z]/.test(d) && (d = "/".concat(d)),
          "store" === e
            ? ((v = o.db.getLangUrlPrefix(s)),
              (p = ""),
              "ru" === s && "/shopping-flow" === d
                ? ((h = ""), (d = v + d.replace("/ru", "")))
                : "it" === s && "it" === a.toLowerCase()
                  ? (v = "")
                  : -1 !== i.a.indexOf(a) &&
                    ((h = ""),
                    (v = o.db.getCountryUrlPrefix({ country: a, locale: s })),
                    (p = f ? "/mobile" : ""),
                    (d = "/where-to-buy")))
            : (v = e
                ? o.db.getLangUrlPrefix(s)
                : o.db.getCountryUrlPrefix({ country: a, locale: s }));
        var y = "".concat(h).concat(v).concat(p).concat(d);
        return (
          "/" !== y && /\/$/g.test(y) && (y = y.substring(0, y.length - 1)), y
        );
      }
      function b(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : "image",
          n = {};
        if (!t || /\.svg$/.test(t))
          return "bg" === e ? "url(".concat(t, ")") : ((n.src = t), n);
        var o = /(http|https):\/\/([^/]+)\/(.+)\/(.+)\.(.+)$/.exec(t),
          i = Object(r.a)(o, 6),
          a = i[1],
          c = i[2],
          s = i[3],
          u = i[4],
          l = i[5],
          f = ""
            .concat(a, "://")
            .concat(c, "/")
            .concat(s, "/")
            .concat(u, "@1x.")
            .concat(l);
        return "bg" === e
          ? "\n    background-image: url("
              .concat(f, "); \n    background-image:-webkit-image-set( url(")
              .concat(f, ") 1x, url(")
              .concat(t, ") 2x); \n    background-image: image-set( url(")
              .concat(f, ") 1x, url(")
              .concat(t, ") 2x)")
          : ((n.src = f),
            (n.srcSet = "".concat(f, " 1x, ").concat(t, " 2x")),
            n);
      }
      function _(t) {
        if (!t) return !1;
        if (
          !(
            !t.match(/^http/gi) &&
            !t.match(/www/gi) &&
            !t.match(/\.com/gi) &&
            !t.match(/^\/\//)
          )
        ) {
          var e = new URL(t).host,
            n = new RegExp(e, "gi"),
            r = new RegExp(window.location.host, "gi");
          if (!(n.test(t) && r.test(t))) return !0;
        }
        return !1;
      }
      function O(t) {
        return _(t) ? "_blank" : "_self";
      }
      function E(t, e) {
        var n = (t = (t = t.replace(/\/$/, "")).replace(
          /(&|\?)?from=buy_now/g,
          "",
        )).split("#")[1];
        return (
          (t = t.split("#")[0]).indexOf("?") > -1 ? (t += "&") : (t += "?"),
          (t += "site=brandsite").indexOf("from=") < 0 &&
            e &&
            (t = "".concat(t, "&from=").concat(e)),
          n && (t = "".concat(t, "#").concat(n)),
          t
        );
      }
      function S(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = /(.+)(\..+)$/,
          o = "";
        if (
          t &&
          "" !== t &&
          n.exec(t) &&
          n.exec(t).length &&
          3 === n.exec(t).length
        ) {
          var i = n.exec(t),
            a = Object(r.a)(i, 3),
            c = a[1],
            s = a[2];
          o = "".concat(c).concat(e).concat(s);
        }
        return o;
      }
    },
    WlAH: function (t, e, n) {
      "use strict";
      n.d(e, "a", function () {
        return r;
      }),
        n.d(e, "b", function () {
          return o;
        });
      var r = {
          INITIAL: "initial",
          LOADING: "loading",
          SUCCESS: "success",
          FAILURE: "failure",
        },
        o = "_uc_id";
    },
    YuTi: function (t, e) {
      t.exports = function (t) {
        return (
          t.webpackPolyfill ||
            ((t.deprecate = function () {}),
            (t.paths = []),
            t.children || (t.children = []),
            Object.defineProperty(t, "loaded", {
              enumerable: !0,
              get: function () {
                return t.l;
              },
            }),
            Object.defineProperty(t, "id", {
              enumerable: !0,
              get: function () {
                return t.i;
              },
            }),
            (t.webpackPolyfill = 1)),
          t
        );
      };
    },
    ZO6J: function (t, e, n) {
      "use strict";
      n.d(e, "a", function () {
        return r;
      });
      var r = ["RU", "MX", "AE", "BR", "ID", "OR"];
    },
    gn4A: function (t, e, n) {
      var r = n("yXPU"),
        o = n("lwsE"),
        i = n("W8MJ");
      function a() {
        "use strict";
        a = function () {
          return e;
        };
        var t,
          e = {},
          n = Object.prototype,
          r = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          c = i.iterator || "@@iterator",
          s = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";
        function l(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          l({}, "");
        } catch (t) {
          l = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function f(t, e, n, r) {
          var i = e && e.prototype instanceof m ? e : m,
            a = Object.create(i.prototype),
            c = new P(r || []);
          return o(a, "_invoke", { value: k(t, n, c) }), a;
        }
        function h(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        e.wrap = f;
        var d = "suspendedStart",
          p = "suspendedYield",
          v = "executing",
          y = "completed",
          g = {};
        function m() {}
        function w() {}
        function b() {}
        var _ = {};
        l(_, c, function () {
          return this;
        });
        var O = Object.getPrototypeOf,
          E = O && O(O(I([])));
        E && E !== n && r.call(E, c) && (_ = E);
        var S = (b.prototype = m.prototype = Object.create(_));
        function x(t) {
          ["next", "throw", "return"].forEach(function (e) {
            l(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function j(t, e) {
          function n(o, i, a, c) {
            var s = h(t[o], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                l = u.value;
              return l && "object" == typeof l && r.call(l, "__await")
                ? e.resolve(l.__await).then(
                    function (t) {
                      n("next", t, a, c);
                    },
                    function (t) {
                      n("throw", t, a, c);
                    },
                  )
                : e.resolve(l).then(
                    function (t) {
                      (u.value = t), a(u);
                    },
                    function (t) {
                      return n("throw", t, a, c);
                    },
                  );
            }
            c(s.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (t, r) {
              function o() {
                return new e(function (e, o) {
                  n(t, r, e, o);
                });
              }
              return (i = i ? i.then(o, o) : o());
            },
          });
        }
        function k(e, n, r) {
          var o = d;
          return function (i, a) {
            if (o === v) throw new Error("Generator is already running");
            if (o === y) {
              if ("throw" === i) throw a;
              return { value: t, done: !0 };
            }
            for (r.method = i, r.arg = a; ; ) {
              var c = r.delegate;
              if (c) {
                var s = L(c, r);
                if (s) {
                  if (s === g) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if (o === d) throw ((o = y), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              o = v;
              var u = h(e, n, r);
              if ("normal" === u.type) {
                if (((o = r.done ? y : p), u.arg === g)) continue;
                return { value: u.arg, done: r.done };
              }
              "throw" === u.type &&
                ((o = y), (r.method = "throw"), (r.arg = u.arg));
            }
          };
        }
        function L(e, n) {
          var r = n.method,
            o = e.iterator[r];
          if (o === t)
            return (
              (n.delegate = null),
              ("throw" === r &&
                e.iterator.return &&
                ((n.method = "return"),
                (n.arg = t),
                L(e, n),
                "throw" === n.method)) ||
                ("return" !== r &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + r + "' method",
                  )))),
              g
            );
          var i = h(o, e.iterator, n.arg);
          if ("throw" === i.type)
            return (
              (n.method = "throw"), (n.arg = i.arg), (n.delegate = null), g
            );
          var a = i.arg;
          return a
            ? a.done
              ? ((n[e.resultName] = a.value),
                (n.next = e.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = t)),
                (n.delegate = null),
                g)
              : a
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              g);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function A(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function P(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(T, this),
            this.reset(!0);
        }
        function I(e) {
          if (e || "" === e) {
            var n = e[c];
            if (n) return n.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (i.next = i);
            }
          }
          throw new TypeError(typeof e + " is not iterable");
        }
        return (
          (w.prototype = b),
          o(S, "constructor", { value: b, configurable: !0 }),
          o(b, "constructor", { value: w, configurable: !0 }),
          (w.displayName = l(b, u, "GeneratorFunction")),
          (e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === w || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (e.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, b)
                : ((t.__proto__ = b), l(t, u, "GeneratorFunction")),
              (t.prototype = Object.create(S)),
              t
            );
          }),
          (e.awrap = function (t) {
            return { __await: t };
          }),
          x(j.prototype),
          l(j.prototype, s, function () {
            return this;
          }),
          (e.AsyncIterator = j),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new j(f(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          x(S),
          l(S, u, "Generator"),
          l(S, c, function () {
            return this;
          }),
          l(S, "toString", function () {
            return "[object Generator]";
          }),
          (e.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (e.values = I),
          (P.prototype = {
            constructor: P,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = t),
                this.tryEntries.forEach(A),
                !e)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = "throw"),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, "catchLoc"),
                    u = r.call(a, "finallyLoc");
                  if (s && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), g)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                g
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), A(n), g;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    A(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: I(e), resultName: n, nextLoc: r }),
                "next" === this.method && (this.arg = t),
                g
              );
            },
          }),
          e
        );
      }
      var c = (function () {
        "use strict";
        function t() {
          o(this, t);
        }
        return (
          i(t, null, [
            {
              key: "deepMapReplace",
              value: function (t, e, n) {
                return (function t(r) {
                  return (
                    r && "object" === typeof r
                      ? Array.isArray(r)
                        ? (r = r.map(function (e) {
                            return t(e);
                          }))
                        : Object.keys(r).forEach(function (e) {
                            r[e] = t(r[e]);
                          })
                      : "string" === typeof r && (r = r.replace(e, n)),
                    r
                  );
                })(t);
              },
            },
            {
              key: "getOffset",
              value: function (t) {
                var e = t,
                  n = e.offsetParent,
                  r = 0;
                if (n && "body" === n.nodeName.toLowerCase()) r += e.offsetTop;
                else for (; n; ) (r += n.offsetTop), (n = n.offsetParent);
                return r;
              },
            },
            {
              key: "showWholeElm",
              value: function (t) {
                if (!t) return !1;
                for (
                  var e = window.scrollY || window.pageYOffset,
                    n = e + window.innerHeight,
                    r = t.offsetTop,
                    o = t.offsetHeight,
                    i = t;
                  i.offsetParent;

                )
                  r += (i = i.offsetParent).offsetTop;
                return (o += r), (r >= e && n >= o) || (r <= e && n <= o);
              },
            },
            {
              key: "throttle",
              value: function (t, e) {
                for (
                  var n = this,
                    r = arguments.length,
                    o = new Array(r > 2 ? r - 2 : 0),
                    i = 2;
                  i < r;
                  i++
                )
                  o[i - 2] = arguments[i];
                var a = !1;
                return function () {
                  var r = n;
                  return (
                    !a &&
                    (t.apply(r, o),
                    (a = !0),
                    setTimeout(function () {
                      return (a = !1);
                    }, e))
                  );
                };
              },
            },
            {
              key: "checkIsIphone678",
              value: function () {
                var t = window.navigator.userAgent,
                  e = window.screen,
                  n = e.width,
                  r = e.height;
                return (
                  !!t.match(/iPhone/i) &&
                  ((375 === n && 667 === r) ||
                    (414 === n && 736 === r) ||
                    (320 === n && 568 === r))
                );
              },
            },
            {
              key: "checkIsIphoneMini",
              value: function () {
                var t = window.navigator.userAgent,
                  e = window.screen,
                  n = e.width,
                  r = e.height;
                return (
                  !!t.match(/iPhone/i) &&
                  ((360 === n && 780 === r) || (375 === n && 812 === r))
                );
              },
            },
            {
              key: "checkIsIphone14",
              value: function () {
                var t = window.navigator.userAgent,
                  e = window.screen,
                  n = e.width,
                  r = e.height;
                return (
                  !!t.match(/iPhone/i) &&
                  ((393 === n && 852 === r) || (430 === n && 932 === r))
                );
              },
            },
            {
              key: "isWhitelistMobileDevice",
              value: function () {
                return t.checkIsIphone14();
              },
            },
            {
              key: "isObsoleteMobileDevice",
              value: function () {
                return t.checkIsIphone678();
              },
            },
            {
              key: "isDJIWebview",
              value: function (t) {
                var e = t.isDJIFlyAPP,
                  n = t.isDJIGoAPP;
                return e || n;
              },
            },
            {
              key: "shouldDowngrade",
              value: function (e) {
                var n = e.isAndroid,
                  r = e.isIOS,
                  o = e.isFirefox,
                  i = e.isChrome,
                  a = e.isUC,
                  c = e.isQQBrowser,
                  s = e.isWeixin,
                  u = e.isDJIFlyAPP,
                  l = e.isDJIGoAPP,
                  f = e.isStoreAPP,
                  h = e.isDJIMimo;
                return (
                  (n && !o && !i) ||
                  t.isDJIWebview({ isDJIFlyAPP: u, isDJIGoAPP: l }) ||
                  (r &&
                    t.shouldIOSdowngrade({
                      isUC: a,
                      isQQBrowser: c,
                      isStoreAPP: f,
                      isDJIMimo: h,
                      isWeixin: s,
                    })) ||
                  t.isHuaweiBrowser()
                );
              },
            },
            {
              key: "shouldIOSdowngrade",
              value: function (t) {
                var e = t.isUC,
                  n = t.isQQBrowser,
                  r = t.isStoreAPP,
                  o = t.isDJIMimo,
                  i = t.isWeixin;
                return e || n || r || o || i;
              },
            },
            {
              key: "isDowngrade",
              value: function () {
                var e = window.navigator.userAgent,
                  n = window.navigator.appVersion,
                  r = !!e.match(/MicroMessenger/gi),
                  o = !!e.match(/iPad/i) || !!e.match(/iPhone/i),
                  i = !!e.match(/UCBrowser/gi),
                  a = !!e.match(/android/gi),
                  c = !!e.match(/\bm?qqbrowser\/([0-9.]+)/gi),
                  s = this.isStoreApp(),
                  u =
                    !!e.match(/DJI-App-pilot-go/gi) ||
                    !!e.match(/DJI-App-pilot/gi),
                  l = !!e.match(/djifly_ios/gi),
                  f =
                    !!e.match(/DJI-app-mimo-android/gi) ||
                    !!e.match(/DJI-app-mimo-ios/gi),
                  h = !!e.match(/\bfirefox\/([0-9.ab]+)/gi),
                  d =
                    window.navigator &&
                    window.navigator.permissions &&
                    -1 !== n.indexOf("(KHTML, like Gecko) Chrome");
                return t.shouldDowngrade({
                  isAndroid: a,
                  isIOS: o,
                  isFirefox: h,
                  isChrome: d,
                  isUC: i,
                  isQQBrowser: c,
                  isWeixin: r,
                  isDJIFlyAPP: l,
                  isDJIGoAPP: u,
                  isStoreAPP: s,
                  isDJIMimo: f,
                });
              },
            },
            {
              key: "isUCVersionBefore",
              value: function (t) {
                var e = window.navigator.userAgent.match(/UCBrowser\/(\d+)./i);
                return Boolean(e) && +e[1] < t;
              },
            },
            {
              key: "isQQBrowser",
              value: function () {
                var t = window.navigator.userAgent;
                return /\bm?qqbrowser\/([0-9.]+)/gi.test(t);
              },
            },
            {
              key: "isAndroid",
              value: function () {
                var t = !!window.navigator.userAgent.match(/android/gi);
                return t;
              },
            },
            {
              key: "isSamsungBrowser",
              value: function () {
                return window.navigator.userAgent.match(/samsungbrowser/gi);
              },
            },
            {
              key: "isUC",
              value: function () {
                return !!window.navigator.userAgent.match(/UCBrowser/gi);
              },
            },
            {
              key: "isAPP",
              value: function () {
                var t = window.navigator.userAgent,
                  e = this.isStoreApp(),
                  n =
                    !!t.match(/DJI-App-pilot-go/gi) ||
                    !!t.match(/DJI-App-pilot/gi),
                  r = !!t.match(/djifly_ios/gi),
                  o =
                    !!t.match(/DJI-app-mimo-android/gi) ||
                    !!t.match(/DJI-app-mimo-ios/gi);
                return r || n || e || o;
              },
            },
            {
              key: "isWx",
              value: function () {
                return !!window.navigator.userAgent.match(/MicroMessenger/gi);
              },
            },
            {
              key: "isIpad",
              value: function () {
                return !!window.navigator.userAgent.match(/iPad/i);
              },
            },
            {
              key: "isiPadOriPadPro",
              value: function () {
                var t = !!window.navigator.userAgent.match(/iPad/i),
                  e =
                    "MacIntel" === navigator.platform &&
                    navigator.maxTouchPoints > 1;
                return t || e;
              },
            },
            {
              key: "isIOS15",
              value: function () {
                return !!window.navigator.userAgent.match(/iPhone OS 15/i);
              },
            },
            {
              key: "videoWithControl",
              value: function (t) {
                var e = window.navigator.userAgent;
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                  e,
                ) &&
                  (t.removeAttribute("autoplay"),
                  t.setAttribute("muted", !0),
                  t.setAttribute("playsinline", !0),
                  t.setAttribute("x5-playsinline", !0),
                  t.setAttribute("webkit-playsinline", !0),
                  t.setAttribute("controls", !0),
                  setTimeout(function () {
                    t.removeAttribute("controls");
                  }, 0));
              },
            },
            {
              key: "isMobile",
              value: function () {
                var t = window.navigator.userAgent;
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                  t,
                );
              },
            },
            {
              key: "getFileExtendingName",
              value: function (t) {
                var e = /[^\.]\w*$/.exec(t);
                return e ? e[0] : "";
              },
            },
            {
              key: "getIOSversion",
              value: function () {
                var t, e;
                return (
                  /iP(hone|od|ad)/.test(navigator.platform)
                    ? ((e = navigator.appVersion.match(
                        /OS (\d+)_(\d+)_?(\d+)?/,
                      )),
                      (t = {
                        status: !0,
                        version: parseInt(e[1], 10),
                        info: ""
                          .concat(parseInt(e[1], 10), ".")
                          .concat(parseInt(e[2], 10), ".")
                          .concat(parseInt(e[3] || 0, 10)),
                      }))
                    : (t = { status: !1, version: !1, info: "" }),
                  t
                );
              },
            },
            {
              key: "isStoreApp",
              value: function () {
                return !(!this.isStoreAppIos() && !this.isStoreAppAndroid());
              },
            },
            {
              key: "isStoreAppIos",
              value: function () {
                return !!window.navigator.userAgent.match(/DJI-App-Ios/gi);
              },
            },
            {
              key: "isStoreAppAndroid",
              value: function () {
                return !!window.navigator.userAgent.match(/DJI-App-Android/gi);
              },
            },
            {
              key: "isAuthed",
              value: function (t) {
                var e = t.request.header["x-publish-token"];
                return t.API.Terminator.verifyToken(e);
              },
            },
            {
              key: "isHuawei",
              value: function () {
                var t = !!window.navigator.userAgent.match(/HUAWEI/gi);
                return t;
              },
            },
            {
              key: "isHuaweiBrowser",
              value: function () {
                var t = !!window.navigator.userAgent.match(/HuaweiBrowser/gi);
                return t;
              },
            },
            {
              key: "removeURLParameter",
              value: function (t, e) {
                var n = t.split("?");
                if (n.length >= 2) {
                  for (
                    var r = "".concat(encodeURIComponent(e), "="),
                      o = n[1].split(/[&;]/g),
                      i = o.length - 1;
                    i >= 0;
                    i--
                  )
                    -1 !== o[i].lastIndexOf(r, 0) && o.splice(i, 1);
                  return n[0] + (o.length > 0 ? "?".concat(o.join("&")) : "");
                }
                return t;
              },
            },
            {
              key: "getMessageFromError",
              value: (function () {
                var t = r(
                  a().mark(function t(e) {
                    var n, r;
                    return a().wrap(function (t) {
                      for (;;)
                        switch ((t.prev = t.next)) {
                          case 0:
                            if (((n = { text: "" }), !e)) {
                              t.next = 10;
                              break;
                            }
                            if (
                              (e.text && (n.text = e.text),
                              !n.text && e.message && (n.text = e.message),
                              !e || "function" !== typeof e.json)
                            ) {
                              t.next = 10;
                              break;
                            }
                            return (t.next = 7), e.json();
                          case 7:
                            (r = t.sent) && r.code && (n.code = r.code),
                              (n.text = r.message);
                          case 10:
                            return t.abrupt("return", n);
                          case 11:
                          case "end":
                            return t.stop();
                        }
                    }, t);
                  }),
                );
                return function (e) {
                  return t.apply(this, arguments);
                };
              })(),
            },
            {
              key: "isWindowsFirefox",
              value: function () {
                var t = window.navigator.userAgent;
                return !!(
                  t &&
                  (t.indexOf("win32") >= 0 ||
                    t.indexOf("wow32") >= 0 ||
                    t.indexOf("win64") >= 0 ||
                    t.indexOf("wow64") >= 0) &&
                  t.indexOf("firefox") > 0
                );
              },
            },
          ]),
          t
        );
      })();
      t.exports = c;
    },
    "hKI/": function (t, e, n) {
      (function (e) {
        var n = "Expected a function",
          r = NaN,
          o = "[object Symbol]",
          i = /^\s+|\s+$/g,
          a = /^[-+]0x[0-9a-f]+$/i,
          c = /^0b[01]+$/i,
          s = /^0o[0-7]+$/i,
          u = parseInt,
          l = "object" == typeof e && e && e.Object === Object && e,
          f = "object" == typeof self && self && self.Object === Object && self,
          h = l || f || Function("return this")(),
          d = Object.prototype.toString,
          p = Math.max,
          v = Math.min,
          y = function () {
            return h.Date.now();
          };
        function g(t, e, r) {
          var o,
            i,
            a,
            c,
            s,
            u,
            l = 0,
            f = !1,
            h = !1,
            d = !0;
          if ("function" != typeof t) throw new TypeError(n);
          function g(e) {
            var n = o,
              r = i;
            return (o = i = void 0), (l = e), (c = t.apply(r, n));
          }
          function b(t) {
            var n = t - u;
            return void 0 === u || n >= e || n < 0 || (h && t - l >= a);
          }
          function _() {
            var t = y();
            if (b(t)) return O(t);
            s = setTimeout(
              _,
              (function (t) {
                var n = e - (t - u);
                return h ? v(n, a - (t - l)) : n;
              })(t),
            );
          }
          function O(t) {
            return (s = void 0), d && o ? g(t) : ((o = i = void 0), c);
          }
          function E() {
            var t = y(),
              n = b(t);
            if (((o = arguments), (i = this), (u = t), n)) {
              if (void 0 === s)
                return (function (t) {
                  return (l = t), (s = setTimeout(_, e)), f ? g(t) : c;
                })(u);
              if (h) return (s = setTimeout(_, e)), g(u);
            }
            return void 0 === s && (s = setTimeout(_, e)), c;
          }
          return (
            (e = w(e) || 0),
            m(r) &&
              ((f = !!r.leading),
              (a = (h = "maxWait" in r) ? p(w(r.maxWait) || 0, e) : a),
              (d = "trailing" in r ? !!r.trailing : d)),
            (E.cancel = function () {
              void 0 !== s && clearTimeout(s),
                (l = 0),
                (o = u = i = s = void 0);
            }),
            (E.flush = function () {
              return void 0 === s ? c : O(y());
            }),
            E
          );
        }
        function m(t) {
          var e = typeof t;
          return !!t && ("object" == e || "function" == e);
        }
        function w(t) {
          if ("number" == typeof t) return t;
          if (
            (function (t) {
              return (
                "symbol" == typeof t ||
                ((function (t) {
                  return !!t && "object" == typeof t;
                })(t) &&
                  d.call(t) == o)
              );
            })(t)
          )
            return r;
          if (m(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = m(e) ? e + "" : e;
          }
          if ("string" != typeof t) return 0 === t ? t : +t;
          t = t.replace(i, "");
          var n = c.test(t);
          return n || s.test(t) ? u(t.slice(2), n ? 2 : 8) : a.test(t) ? r : +t;
        }
        t.exports = function (t, e, r) {
          var o = !0,
            i = !0;
          if ("function" != typeof t) throw new TypeError(n);
          return (
            m(r) &&
              ((o = "leading" in r ? !!r.leading : o),
              (i = "trailing" in r ? !!r.trailing : i)),
            g(t, e, { leading: o, maxWait: e, trailing: i })
          );
        };
      }).call(this, n("yLpj"));
    },
    iKuz: function (t, e, n) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 }),
        (e.default = void 0);
      var r,
        o = (r = n("Fe7O")) && r.__esModule ? r : { default: r };
      var i = function (t, e) {
        if ("throw" === e) throw new Error(t);
        return "warn" === e && console.warn(t), null;
      };
      e.default = function (t, e, n) {
        var r = Object.keys(e),
          a = n || {},
          c = a.handleMissingStyleName,
          s = void 0 === c ? o.default.handleMissingStyleName : c,
          u = a.autoResolveMultipleImports,
          l = void 0 === u ? o.default.autoResolveMultipleImports : u;
        return t
          ? t
              .split(" ")
              .filter(function (t) {
                return t;
              })
              .map(function (t) {
                if (
                  (function (t) {
                    return -1 !== t.indexOf(".");
                  })(t)
                )
                  return (function (t, e, n) {
                    var r = t.split("."),
                      a = r[0],
                      c = r[1],
                      s = n || o.default.handleMissingStyleName;
                    return c
                      ? e[a]
                        ? e[a][c]
                          ? e[a][c]
                          : i("CSS module does not exist: " + c, s)
                        : i("CSS module import does not exist: " + a, s)
                      : i("Invalid style name: " + t, s);
                  })(t, e, s);
                if (0 === r.length)
                  throw new Error(
                    "Cannot use styleName attribute for style name '" +
                      t +
                      "' without importing at least one stylesheet.",
                  );
                if (r.length > 1) {
                  if (!l)
                    throw new Error(
                      "Cannot use anonymous style name '" +
                        t +
                        "' with more than one stylesheet import without setting 'autoResolveMultipleImports' to true.",
                    );
                  return (function (t, e, n) {
                    var r = n || o.default.handleMissingStyleName,
                      a = Object.keys(e)
                        .map(function (n) {
                          return e[n][t] && n;
                        })
                        .filter(function (t) {
                          return t;
                        });
                    if (a.length > 1)
                      throw new Error(
                        'Cannot resolve styleName "' +
                          t +
                          '" because it is present in multiple imports:\n\n\t' +
                          a.join("\n\t") +
                          '\n\nYou can resolve this by using a named import, e.g:\n\n\timport foo from "' +
                          a[0] +
                          '";\n\t<div styleName="foo.' +
                          t +
                          '" />\n\n',
                      );
                    return 0 === a.length
                      ? i("Could not resolve the styleName '" + t + "'.", r)
                      : e[a[0]][t];
                  })(t, e, s);
                }
                var n = e[r[0]];
                return n[t]
                  ? n[t]
                  : i("Could not resolve the styleName '" + t + "'.", s);
              })
              .filter(function (t) {
                return t;
              })
              .join(" ")
          : "";
      };
    },
    "iVi/": function (t, e, n) {
      "use strict";
      (e.parse = function (t, e) {
        if ("string" !== typeof t)
          throw new TypeError("argument str must be a string");
        var n = {},
          r = (e || {}).decode || i,
          o = 0;
        for (; o < t.length; ) {
          var a = t.indexOf("=", o);
          if (-1 === a) break;
          var s = t.indexOf(";", o);
          if (-1 === s) s = t.length;
          else if (s < a) {
            o = t.lastIndexOf(";", a - 1) + 1;
            continue;
          }
          var u = t.slice(o, a).trim();
          if (void 0 === n[u]) {
            var l = t.slice(a + 1, s).trim();
            34 === l.charCodeAt(0) && (l = l.slice(1, -1)), (n[u] = c(l, r));
          }
          o = s + 1;
        }
        return n;
      }),
        (e.serialize = function (t, e, n) {
          var i = n || {},
            c = i.encode || a;
          if ("function" !== typeof c)
            throw new TypeError("option encode is invalid");
          if (!o.test(t)) throw new TypeError("argument name is invalid");
          var s = c(e);
          if (s && !o.test(s)) throw new TypeError("argument val is invalid");
          var u = t + "=" + s;
          if (null != i.maxAge) {
            var l = i.maxAge - 0;
            if (isNaN(l) || !isFinite(l))
              throw new TypeError("option maxAge is invalid");
            u += "; Max-Age=" + Math.floor(l);
          }
          if (i.domain) {
            if (!o.test(i.domain))
              throw new TypeError("option domain is invalid");
            u += "; Domain=" + i.domain;
          }
          if (i.path) {
            if (!o.test(i.path)) throw new TypeError("option path is invalid");
            u += "; Path=" + i.path;
          }
          if (i.expires) {
            var f = i.expires;
            if (
              !(function (t) {
                return "[object Date]" === r.call(t) || t instanceof Date;
              })(f) ||
              isNaN(f.valueOf())
            )
              throw new TypeError("option expires is invalid");
            u += "; Expires=" + f.toUTCString();
          }
          i.httpOnly && (u += "; HttpOnly");
          i.secure && (u += "; Secure");
          if (i.priority) {
            switch (
              "string" === typeof i.priority
                ? i.priority.toLowerCase()
                : i.priority
            ) {
              case "low":
                u += "; Priority=Low";
                break;
              case "medium":
                u += "; Priority=Medium";
                break;
              case "high":
                u += "; Priority=High";
                break;
              default:
                throw new TypeError("option priority is invalid");
            }
          }
          if (i.sameSite) {
            switch (
              "string" === typeof i.sameSite
                ? i.sameSite.toLowerCase()
                : i.sameSite
            ) {
              case !0:
                u += "; SameSite=Strict";
                break;
              case "lax":
                u += "; SameSite=Lax";
                break;
              case "strict":
                u += "; SameSite=Strict";
                break;
              case "none":
                u += "; SameSite=None";
                break;
              default:
                throw new TypeError("option sameSite is invalid");
            }
          }
          return u;
        });
      var r = Object.prototype.toString,
        o = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
      function i(t) {
        return -1 !== t.indexOf("%") ? decodeURIComponent(t) : t;
      }
      function a(t) {
        return encodeURIComponent(t);
      }
      function c(t, e) {
        try {
          return e(t);
        } catch (n) {
          return t;
        }
      }
    },
    ku9G: function (t, e, n) {
      "use strict";
      n.d(e, "a", function () {
        return o;
      });
      var r = n("vtNx"),
        o = function (t, e) {
          t &&
            -1 !== Object.values(r.a).indexOf(t) &&
            window.sensors &&
            window.sensors.track(
              t,
              Object.assign(e, {
                app_ucid: window.app_ucid,
                platform_type: "web",
              }),
            );
        };
    },
    lrw0: function (t, e, n) {
      t.exports = {
        active: "index__active___GPAYV",
        ie7: "index__ie7___3ozDz",
        ie6: "index__ie6___1zE-e",
        clickable: "index__clickable___zULFn",
        clearfix: "index__clearfix___3NOy8",
        "grid-container": "index__grid-container___1hw-V",
        "grid-container-fluid": "index__grid-container-fluid___xU3DW",
        grid: "index__grid___VR397",
        top: "index__top___2JvZt",
        middle: "index__middle___2_8i0",
        bottom: "index__bottom___2nxEw",
        stretch: "index__stretch___3Psys",
        baseline: "index__baseline___1-_ZA",
        left: "index__left___1Chlf",
        center: "index__center___1iSrG",
        right: "index__right___3uSj6",
        between: "index__between___23sqT",
        around: "index__around___NdH-v",
        cell: "index__cell___3WVO8",
        is: "index__is___1ntA_",
        "is-fifth": "index__is-fifth___3Uul4",
        "is-1": "index__is-1___pK-SX",
        "is-2": "index__is-2___1K_-0",
        "is-3": "index__is-3___9Nm_8",
        "is-4": "index__is-4___3BEyb",
        "is-5": "index__is-5___2BG8x",
        "is-6": "index__is-6___S8AbL",
        "is-7": "index__is-7___1Dd-x",
        "is-8": "index__is-8___1gPwC",
        "is-9": "index__is-9___3aEJb",
        "is-10": "index__is-10___1uALE",
        "is-11": "index__is-11___2Heae",
        "is-12": "index__is-12___1ssvb",
        "is-offset-0": "index__is-offset-0___3PM2F",
        "is-offset-1": "index__is-offset-1___Kuz3r",
        "is-offset-2": "index__is-offset-2___OQSH2",
        "is-offset-3": "index__is-offset-3___1e-GP",
        "is-offset-4": "index__is-offset-4___2mmAf",
        "is-offset-5": "index__is-offset-5___p8mXo",
        "is-offset-6": "index__is-offset-6___1xdp2",
        "is-offset-7": "index__is-offset-7___2zGeD",
        "is-offset-8": "index__is-offset-8___MRL1L",
        "is-offset-9": "index__is-offset-9___3yfiq",
        "is-offset-10": "index__is-offset-10___1d8FP",
        "is-offset-11": "index__is-offset-11___pi6zn",
        "dui-form": "index__dui-form___-W6TV",
        "row-submit": "index__row-submit___1kawY",
        "form-group": "index__form-group___s-4Lo",
        "col-submit": "index__col-submit___3xG2G",
        "fa-caret-down": "index__fa-caret-down___2pBvG",
        "fa-spinner": "index__fa-spinner___1kTl9",
        error: "index__error___2w8rV",
        "checkbox-container": "index__checkbox-container___226eq",
        fa: "index__fa___3-pNY",
        "dui-btn": "index__dui-btn___3Xvyl",
        "dui-btn-sm": "index__dui-btn-sm___18XKi",
        "dui-btn-primary": "index__dui-btn-primary___21WsD",
        "dui-btn-normal": "index__dui-btn-normal___2Khw6",
        "dui-btn-buy": "index__dui-btn-buy___2cPPF",
        "dui-learn-more": "index__dui-learn-more___3A4OO",
        "fa-angle-right": "index__fa-angle-right___1cNUw",
        spinner: "index__spinner___28vWx",
        "sk-bouncedelay": "index__sk-bouncedelay___3_rtG",
        bounce1: "index__bounce1___3w1d0",
        bounce2: "index__bounce2___lAAJ_",
      };
    },
    m40j: function (t, e, n) {},
    mp3y: function (t, e, n) {
      t.exports = {
        "workspace-container": "style__workspace-container___UjlRD",
        "workspace-hide": "style__workspace-hide___a1mMf",
        info: "style__info___2oN47",
        hide: "style__hide___1FUw2",
        close: "style__close___2G0r8",
      };
    },
    nSXv: function (t, e, n) {
      t.exports = {
        "browserIncompatible-content":
          "style__browserIncompatible-content___1c1_p",
        "browser-modal": "style__browser-modal___FH6Pe",
        "brower-box": "style__brower-box___2zTyx",
        "browser-content": "style__browser-content___1bEYn",
        "browser-dji-logo": "style__browser-dji-logo___1dy2f",
        "browser-text-title": "style__browser-text-title___Bj-Yi",
        "browser-text-desc": "style__browser-text-desc___v7EoX",
        "browser-list": "style__browser-list___U3Mhg",
        "browser-item": "style__browser-item___1XFaD",
        name: "style__name___3jE11",
        "browser-chrome": "style__browser-chrome___12_0k",
        "browser-fiefox": "style__browser-fiefox___2Ieax",
        "browser-safair": "style__browser-safair___3RZmj",
        "browser-edge": "style__browser-edge___1ZY3b",
      };
    },
    t3Un: function (t, e, n) {
      "use strict";
      var r = n("rePB"),
        o = n("LpSC"),
        i = n.n(o),
        a = n("cr+I"),
        c = n.n(a);
      function s(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e &&
            (r = r.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function u(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2
            ? s(Object(n), !0).forEach(function (e) {
                Object(r.a)(t, e, n[e]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
              : s(Object(n)).forEach(function (e) {
                  Object.defineProperty(
                    t,
                    e,
                    Object.getOwnPropertyDescriptor(n, e),
                  );
                });
        }
        return t;
      }
      var l = function (t) {
        return t.indexOf("?") < 0 ? "?" : "&";
      };
      e.a = function (t, e) {
        var n = t.method,
          r = t.url,
          o = t.query,
          a = t.data,
          s = t.formData,
          f = u(
            u(
              { method: n || "GET" },
              s
                ? {}
                : {
                    headers: {
                      "Content-Type": "application/json; charset=utf-8",
                    },
                  },
            ),
            {},
            { credentials: "include", query: o, body: null },
          );
        if ((/terminator/.test(r) && delete f.credentials, a))
          f.body = JSON.stringify(a);
        else if ("object" === typeof s) {
          var h = new FormData();
          Object.keys(s).forEach(function (t) {
            return h.append(t, s[t]);
          }),
            (f.body = h);
        } else delete f.body;
        var d = c.a.stringify(o),
          p = e.language,
          v = e.country,
          y = r;
        return (
          (y += d ? "".concat(l(y)).concat(d) : ""),
          (y += void 0 !== p ? "".concat(l(y), "language=").concat(p) : ""),
          void 0 === c.a.parse(c.a.extract(y)).country &&
            (y += v ? "".concat(l(y), "country=").concat(v) : ""),
          i()(y, f)
        );
      };
    },
    u11H: function (t, e, n) {
      "use strict";
      n.r(e),
        n.d(e, "default", function () {
          return l;
        });
      var r = n("HaE+"),
        o = n("1OyB"),
        i = n("vuIU"),
        a = n("rePB"),
        c = n("t3Un"),
        s = n("yWgo");
      function u() {
        u = function () {
          return e;
        };
        var t,
          e = {},
          n = Object.prototype,
          r = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function l(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          l({}, "");
        } catch (t) {
          l = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function f(t, e, n, r) {
          var i = e && e.prototype instanceof m ? e : m,
            a = Object.create(i.prototype),
            c = new P(r || []);
          return o(a, "_invoke", { value: k(t, n, c) }), a;
        }
        function h(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        e.wrap = f;
        var d = "suspendedStart",
          p = "suspendedYield",
          v = "executing",
          y = "completed",
          g = {};
        function m() {}
        function w() {}
        function b() {}
        var _ = {};
        l(_, a, function () {
          return this;
        });
        var O = Object.getPrototypeOf,
          E = O && O(O(I([])));
        E && E !== n && r.call(E, a) && (_ = E);
        var S = (b.prototype = m.prototype = Object.create(_));
        function x(t) {
          ["next", "throw", "return"].forEach(function (e) {
            l(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function j(t, e) {
          function n(o, i, a, c) {
            var s = h(t[o], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                l = u.value;
              return l && "object" == typeof l && r.call(l, "__await")
                ? e.resolve(l.__await).then(
                    function (t) {
                      n("next", t, a, c);
                    },
                    function (t) {
                      n("throw", t, a, c);
                    },
                  )
                : e.resolve(l).then(
                    function (t) {
                      (u.value = t), a(u);
                    },
                    function (t) {
                      return n("throw", t, a, c);
                    },
                  );
            }
            c(s.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (t, r) {
              function o() {
                return new e(function (e, o) {
                  n(t, r, e, o);
                });
              }
              return (i = i ? i.then(o, o) : o());
            },
          });
        }
        function k(e, n, r) {
          var o = d;
          return function (i, a) {
            if (o === v) throw new Error("Generator is already running");
            if (o === y) {
              if ("throw" === i) throw a;
              return { value: t, done: !0 };
            }
            for (r.method = i, r.arg = a; ; ) {
              var c = r.delegate;
              if (c) {
                var s = L(c, r);
                if (s) {
                  if (s === g) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if (o === d) throw ((o = y), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              o = v;
              var u = h(e, n, r);
              if ("normal" === u.type) {
                if (((o = r.done ? y : p), u.arg === g)) continue;
                return { value: u.arg, done: r.done };
              }
              "throw" === u.type &&
                ((o = y), (r.method = "throw"), (r.arg = u.arg));
            }
          };
        }
        function L(e, n) {
          var r = n.method,
            o = e.iterator[r];
          if (o === t)
            return (
              (n.delegate = null),
              ("throw" === r &&
                e.iterator.return &&
                ((n.method = "return"),
                (n.arg = t),
                L(e, n),
                "throw" === n.method)) ||
                ("return" !== r &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + r + "' method",
                  )))),
              g
            );
          var i = h(o, e.iterator, n.arg);
          if ("throw" === i.type)
            return (
              (n.method = "throw"), (n.arg = i.arg), (n.delegate = null), g
            );
          var a = i.arg;
          return a
            ? a.done
              ? ((n[e.resultName] = a.value),
                (n.next = e.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = t)),
                (n.delegate = null),
                g)
              : a
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              g);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function A(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function P(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(T, this),
            this.reset(!0);
        }
        function I(e) {
          if (e || "" === e) {
            var n = e[a];
            if (n) return n.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (i.next = i);
            }
          }
          throw new TypeError(typeof e + " is not iterable");
        }
        return (
          (w.prototype = b),
          o(S, "constructor", { value: b, configurable: !0 }),
          o(b, "constructor", { value: w, configurable: !0 }),
          (w.displayName = l(b, s, "GeneratorFunction")),
          (e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === w || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (e.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, b)
                : ((t.__proto__ = b), l(t, s, "GeneratorFunction")),
              (t.prototype = Object.create(S)),
              t
            );
          }),
          (e.awrap = function (t) {
            return { __await: t };
          }),
          x(j.prototype),
          l(j.prototype, c, function () {
            return this;
          }),
          (e.AsyncIterator = j),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new j(f(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          x(S),
          l(S, s, "Generator"),
          l(S, a, function () {
            return this;
          }),
          l(S, "toString", function () {
            return "[object Generator]";
          }),
          (e.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (e.values = I),
          (P.prototype = {
            constructor: P,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = t),
                this.tryEntries.forEach(A),
                !e)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = "throw"),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, "catchLoc"),
                    u = r.call(a, "finallyLoc");
                  if (s && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), g)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                g
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), A(n), g;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    A(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: I(e), resultName: n, nextLoc: r }),
                "next" === this.method && (this.arg = t),
                g
              );
            },
          }),
          e
        );
      }
      var l = (function () {
        function t() {
          Object(o.default)(this, t);
        }
        return (
          Object(i.default)(t, null, [
            {
              key: "renderAPI",
              value: function (e) {
                if ("string" !== typeof e) return e;
                var n = "";
                return (
                  t.apiHostList.official_api.prod &&
                    (n = t.apiHostList.official_api.prod.host),
                  n + e
                );
              },
            },
            {
              key: "request",
              value: (function () {
                var e = Object(r.default)(
                  u().mark(function e(n, r) {
                    var o, i, a, l, f, h;
                    return u().wrap(function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            if (
                              ((i = (o = n).name),
                              (a = o.method),
                              (l = ""),
                              (f = ""),
                              t.apiList[i] && (f = t.apiList[i]),
                              t.apiHostList.official_api.prod &&
                                (l = t.apiHostList.official_api.prod.host),
                              (h = ""),
                              r &&
                                (h = s.db.getCountryUrlPrefix({
                                  country: r.country,
                                  locale: r.language,
                                })),
                              f &&
                                (n = Object.assign(n, {
                                  url: "".concat(l).concat(h).concat(f),
                                })),
                              "POST" !== a)
                            ) {
                              e.next = 11;
                              break;
                            }
                            return (
                              (e.next = 11),
                              t.getCsrf({ host: l, localization: r, opt: n })
                            );
                          case 11:
                            return e.abrupt("return", Object(c.a)(n, r));
                          case 12:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  }),
                );
                return function (t, n) {
                  return e.apply(this, arguments);
                };
              })(),
            },
            {
              key: "getCsrf",
              value: (function () {
                var e = Object(r.default)(
                  u().mark(function e(n) {
                    var r, o, i, a, s, l;
                    return u().wrap(function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (
                              (r = n.host),
                              (o = n.localization),
                              (i = n.opt),
                              (e.next = 3),
                              Object(c.a)(
                                { url: "".concat(r).concat(t.apiList.csrf) },
                                o,
                              )
                            );
                          case 3:
                            return (a = e.sent), (e.next = 6), a.json();
                          case 6:
                            (s = e.sent),
                              (l = s._csrf),
                              i.data
                                ? (i.data = Object.assign(i.data, { _csrf: l }))
                                : i.formData &&
                                  (i.formData = Object.assign(i.formData, {
                                    _csrf: l,
                                  }));
                          case 9:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  }),
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })(),
            },
          ]),
          t
        );
      })();
      Object(a.a)(l, "apiHostList", {
        official_api: {
          test: { host: "//test-www-api.dbeta.me" },
          dev: { host: "//test-www-api.dbeta.me" },
          stag: { host: "//stag-www-api.dbeta.me" },
          prod: { host: "//www-api.dji.com" },
          master: { host: "//www-api.dji.com" },
          host: "//www-api.dji.com",
        },
      }),
        Object(a.a)(l, "apiList", {
          arsDealer: "/api/ars-dealers",
          cart: "/api/user/cart",
          currentTime: "/api/util/current_time",
          csrf: "/api/csrf",
          createActivity: "/api/activity/create",
          chinaCities: "/api/dealers/china_cities/",
          citiesInChina: "/api/dealers/cities_in_china",
          captchaValidate: "/api/util/captcha/validate",
          dealerContinent: "/api/dealers/continents",
          dealerCountry: "/api/dealers/countries/",
          dealerState: "/api/dealers/states/",
          dealerStore: "/api/dealers/store/",
          dealerStores: "/api/dealers/stores/",
          dealerSubmit: "/api/dealers/submit?www=v2",
          dealerWarranties: "/api/dealers/warranties/",
          dealerZipcode: "/api/dealers/zipcode/",
          enterpriseSubIndustry: "/api/enterprise/subIndustry",
          flySafeIntroduction: "/api/flysafe/introduction",
          geoAreas: "/api/geo/areas",
          geoCountry: "/api/geo/country/",
          geoPointInfo: "/api/geo/point-info",
          geoSupportList: "/api/geo/support-list",
          geoSystemCheckUserVerify: "/api/geo-system/check-user-verify",
          geoSystemSubmitUnlockTerm: "/api/geo-system/submit-unlock-terms",
          geoSystemAdvanceUnlock: "/api/geo-system/advance-unlock?www=v2",
          geoSystemCustomUnlock:
            "/api/geo-system/custom-unlock?www=v2&www-cache=official",
          geoSystemFileUpload:
            "/api/geo-system/file-upload?www=v2&www-cache=official",
          localeIpLocation: "/api/locale/ip-location",
          noFlyCountry: "/api/no-fly/country/",
          officialGetUserInfo: "/api/official/get_user_info/",
          officialGetCurrentCountry: "/api/official/get_current_country",
          productCenterMg: "/api/product_center/mg-1/cn",
          productGroupAllSeries: "/api/products/groups/all-series",
          productListAllNav: "/api/products/list/all-nav",
          productListAllSeries: "/api/products/list/all-series",
          productPrice: "/api/product/price",
          productGetPrice: "/api/product/get_price",
          productGetMiniDetails: "/api/product/get_mini_details",
          productDealersMg1: "/api/product_dealers/mg-1",
          productCenterMg1: "/api/product_center/mg-1",
          reserveAvailable: "/api/reserve/available/",
          reserveTypelistWingedAppointment:
            "/api/reserve/typelist/winged_appointment",
          reserveVerify: "/api/reserve/verify?www=v2",
          searchHotWord: "/api/search/hot-word",
          searchFind: "/api/search/find",
          skypixelLogin: "/oauth2/auth?www=v2",
          showCaseSubmitVideo: "/api/showcase/submit/video?www=v2",
          subscribe: "/api/subscribe?www=v2",
          serviceCenter: "/api/service/center",
          userInformation: "/api/user/information",
          userInfoEmail: "/api/user/info/email",
          whereToBuyAgriMap: "/api/where-to-buy/agriculture-dealer-maps",
          whereToBuyDeliveryMap: "/api/where-to-buy/delivery-dealer-maps",
          whereToBuyDealerMap: "/api/where-to-buy/dealer-maps",
          whereToBuyProDealer: "/api/where-to-buy/professional-dealers/",
          whereToBuySearch: "/api/where-to-buy/search/",
          flySafeIpLocation: "/api/flysafe/ip-location",
          flySafeSelfUnlockVerify: "/api/flysafe/self-unlock/verify?www=v2",
          flySafeSelfUnlockSendVerifycationCode:
            "/api/flysafe/self-unlock/send-verification-code?www=v2",
          flySafeLink: "/api/flysafe/link",
          flySafeCountryChunkMap: "/api/flysafe/country-chunk-map",
          captchaNeeded: "/api/util/captcha_needed",
          formSubmit: "/api/activity/v3_create?www=v2",
          formSubmitByLogin: "/api/activity/create_by_login_user?www=v2",
          ecosystemFormSubmit:
            "/api/activity/ecosystem_form_create?www=v2&www-cache=official",
          supportMailFormSubmit:
            "/api/support/problem?lang=en&www=v2&www-cache=official",
          agCaseStudiesTagList: "/api/get-case-studies-tag-list",
          agCaseStudiesQueryNews: "/api/get-case-studies-news",
          getNewsMediaData: "/api/get_ag_news",
          getCurrentTime: "/api/util/current_time",
          getEcologyDetailData: "/api/get-enterprise-ecology-list",
          getWechatSignature: "/api/get-wechat-signature",
          getSubscribeCompaign: "/api/subscribe-compaign",
        });
    },
    vtNx: function (t, e, n) {
      "use strict";
      n.d(e, "a", function () {
        return r;
      });
      var r = (function (t) {
        return (
          (t.UNIVERSUAL_PRODUCT_TIPS_SHOW = "universual_product_tips_show"),
          (t.UNIVERSUAL_PRODUCT_TIP_CLICK = "universual_product_tips_click"),
          (t.GOOGLE_ONE_TAP_SHOW = "google_one_tap_show"),
          (t.GOOGLE_ONE_TAP_CLICK = "google_one_tap_click"),
          (t.SUBSCRIBE_MODAL_SHOW = "subscribe_modal_show"),
          (t.SUBSCRIBE_MODAL_CLICK = "subscribe_modal_click"),
          (t.WEBPUSH_CONSENT_SHOW = "webpush_consent_show"),
          (t.WEBPUSH_CONSENT_CLICK = "webpush_consent_click"),
          t
        );
      })({});
    },
    yLpj: function (t, e) {
      var n;
      n = (function () {
        return this;
      })();
      try {
        n = n || new Function("return this")();
      } catch (r) {
        "object" === typeof window && (n = window);
      }
      t.exports = n;
    },
    yWgo: function (t, e, n) {
      "use strict";
      n.d(e, "Gb", function () {
        return f;
      }),
        n.d(e, "Fb", function () {
          return h;
        }),
        n.d(e, "J", function () {
          return d;
        }),
        n.d(e, "y", function () {
          return p;
        }),
        n.d(e, "x", function () {
          return v;
        }),
        n.d(e, "Q", function () {
          return g;
        }),
        n.d(e, "o", function () {
          return w;
        }),
        n.d(e, "h", function () {
          return b;
        }),
        n.d(e, "f", function () {
          return _;
        }),
        n.d(e, "p", function () {
          return O;
        }),
        n.d(e, "k", function () {
          return E;
        }),
        n.d(e, "i", function () {
          return S;
        }),
        n.d(e, "m", function () {
          return x;
        }),
        n.d(e, "l", function () {
          return j;
        }),
        n.d(e, "r", function () {
          return k;
        }),
        n.d(e, "q", function () {
          return L;
        }),
        n.d(e, "s", function () {
          return T;
        }),
        n.d(e, "n", function () {
          return A;
        }),
        n.d(e, "j", function () {
          return P;
        }),
        n.d(e, "H", function () {
          return I;
        }),
        n.d(e, "N", function () {
          return N;
        }),
        n.d(e, "db", function () {
          return y;
        }),
        n.d(e, "zb", function () {
          return C;
        }),
        n.d(e, "yb", function () {
          return D;
        }),
        n.d(e, "nb", function () {
          return R;
        }),
        n.d(e, "u", function () {
          return M;
        }),
        n.d(e, "M", function () {
          return U;
        }),
        n.d(e, "ub", function () {
          return G;
        }),
        n.d(e, "z", function () {
          return B;
        }),
        n.d(e, "xb", function () {
          return V;
        }),
        n.d(e, "ob", function () {
          return W;
        }),
        n.d(e, "vb", function () {
          return q;
        }),
        n.d(e, "D", function () {
          return J;
        }),
        n.d(e, "wb", function () {
          return Y;
        }),
        n.d(e, "E", function () {
          return K;
        }),
        n.d(e, "lb", function () {
          return $;
        }),
        n.d(e, "pb", function () {
          return X;
        }),
        n.d(e, "ib", function () {
          return Q;
        }),
        n.d(e, "Z", function () {
          return Z;
        }),
        n.d(e, "Ab", function () {
          return tt;
        }),
        n.d(e, "gb", function () {
          return et;
        }),
        n.d(e, "A", function () {
          return nt;
        }),
        n.d(e, "c", function () {
          return rt;
        }),
        n.d(e, "tb", function () {
          return ot;
        }),
        n.d(e, "Eb", function () {
          return it;
        }),
        n.d(e, "B", function () {
          return at;
        }),
        n.d(e, "O", function () {
          return ct;
        }),
        n.d(e, "L", function () {
          return st;
        }),
        n.d(e, "g", function () {
          return ut;
        }),
        n.d(e, "U", function () {
          return lt;
        }),
        n.d(e, "R", function () {
          return ft;
        }),
        n.d(e, "hb", function () {
          return ht;
        }),
        n.d(e, "Hb", function () {
          return dt;
        }),
        n.d(e, "t", function () {
          return pt;
        }),
        n.d(e, "qb", function () {
          return vt;
        }),
        n.d(e, "rb", function () {
          return yt;
        }),
        n.d(e, "sb", function () {
          return gt;
        }),
        n.d(e, "b", function () {
          return mt;
        }),
        n.d(e, "C", function () {
          return wt;
        }),
        n.d(e, "Bb", function () {
          return bt;
        }),
        n.d(e, "T", function () {
          return _t;
        }),
        n.d(e, "G", function () {
          return Ot;
        }),
        n.d(e, "V", function () {
          return Et;
        }),
        n.d(e, "Cb", function () {
          return St;
        }),
        n.d(e, "S", function () {
          return xt;
        }),
        n.d(e, "Db", function () {
          return jt;
        }),
        n.d(e, "P", function () {
          return kt;
        }),
        n.d(e, "fb", function () {
          return Lt;
        }),
        n.d(e, "a", function () {
          return Tt;
        }),
        n.d(e, "kb", function () {
          return At;
        }),
        n.d(e, "bb", function () {
          return Pt;
        }),
        n.d(e, "K", function () {
          return It;
        }),
        n.d(e, "F", function () {
          return Ct;
        }),
        n.d(e, "w", function () {
          return Dt;
        }),
        n.d(e, "Y", function () {
          return Rt;
        }),
        n.d(e, "ab", function () {
          return Mt;
        }),
        n.d(e, "W", function () {
          return Ft;
        }),
        n.d(e, "v", function () {
          return Ut;
        }),
        n.d(e, "X", function () {
          return Gt;
        }),
        n.d(e, "eb", function () {
          return Bt;
        }),
        n.d(e, "jb", function () {
          return Ht;
        }),
        n.d(e, "I", function () {
          return zt;
        }),
        n.d(e, "mb", function () {
          return Vt;
        }),
        n.d(e, "cb", function () {
          return Wt;
        }),
        n.d(e, "d", function () {
          return qt;
        }),
        n.d(e, "e", function () {
          return Jt;
        });
      var r = n("KQm4"),
        o = n("ODXe"),
        i = n("HaE+"),
        a = n("p46w"),
        c = n.n(a),
        s = n("dhHj"),
        u = n("ZO6J");
      function l() {
        l = function () {
          return e;
        };
        var t,
          e = {},
          n = Object.prototype,
          r = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (t, e, n) {
              t[e] = n.value;
            },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";
        function u(t, e, n) {
          return (
            Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            t[e]
          );
        }
        try {
          u({}, "");
        } catch (t) {
          u = function (t, e, n) {
            return (t[e] = n);
          };
        }
        function f(t, e, n, r) {
          var i = e && e.prototype instanceof m ? e : m,
            a = Object.create(i.prototype),
            c = new P(r || []);
          return o(a, "_invoke", { value: k(t, n, c) }), a;
        }
        function h(t, e, n) {
          try {
            return { type: "normal", arg: t.call(e, n) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }
        e.wrap = f;
        var d = "suspendedStart",
          p = "suspendedYield",
          v = "executing",
          y = "completed",
          g = {};
        function m() {}
        function w() {}
        function b() {}
        var _ = {};
        u(_, a, function () {
          return this;
        });
        var O = Object.getPrototypeOf,
          E = O && O(O(I([])));
        E && E !== n && r.call(E, a) && (_ = E);
        var S = (b.prototype = m.prototype = Object.create(_));
        function x(t) {
          ["next", "throw", "return"].forEach(function (e) {
            u(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function j(t, e) {
          function n(o, i, a, c) {
            var s = h(t[o], t, i);
            if ("throw" !== s.type) {
              var u = s.arg,
                l = u.value;
              return l && "object" == typeof l && r.call(l, "__await")
                ? e.resolve(l.__await).then(
                    function (t) {
                      n("next", t, a, c);
                    },
                    function (t) {
                      n("throw", t, a, c);
                    },
                  )
                : e.resolve(l).then(
                    function (t) {
                      (u.value = t), a(u);
                    },
                    function (t) {
                      return n("throw", t, a, c);
                    },
                  );
            }
            c(s.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (t, r) {
              function o() {
                return new e(function (e, o) {
                  n(t, r, e, o);
                });
              }
              return (i = i ? i.then(o, o) : o());
            },
          });
        }
        function k(e, n, r) {
          var o = d;
          return function (i, a) {
            if (o === v) throw new Error("Generator is already running");
            if (o === y) {
              if ("throw" === i) throw a;
              return { value: t, done: !0 };
            }
            for (r.method = i, r.arg = a; ; ) {
              var c = r.delegate;
              if (c) {
                var s = L(c, r);
                if (s) {
                  if (s === g) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;
              else if ("throw" === r.method) {
                if (o === d) throw ((o = y), r.arg);
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              o = v;
              var u = h(e, n, r);
              if ("normal" === u.type) {
                if (((o = r.done ? y : p), u.arg === g)) continue;
                return { value: u.arg, done: r.done };
              }
              "throw" === u.type &&
                ((o = y), (r.method = "throw"), (r.arg = u.arg));
            }
          };
        }
        function L(e, n) {
          var r = n.method,
            o = e.iterator[r];
          if (o === t)
            return (
              (n.delegate = null),
              ("throw" === r &&
                e.iterator.return &&
                ((n.method = "return"),
                (n.arg = t),
                L(e, n),
                "throw" === n.method)) ||
                ("return" !== r &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + r + "' method",
                  )))),
              g
            );
          var i = h(o, e.iterator, n.arg);
          if ("throw" === i.type)
            return (
              (n.method = "throw"), (n.arg = i.arg), (n.delegate = null), g
            );
          var a = i.arg;
          return a
            ? a.done
              ? ((n[e.resultName] = a.value),
                (n.next = e.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = t)),
                (n.delegate = null),
                g)
              : a
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              g);
        }
        function T(t) {
          var e = { tryLoc: t[0] };
          1 in t && (e.catchLoc = t[1]),
            2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
            this.tryEntries.push(e);
        }
        function A(t) {
          var e = t.completion || {};
          (e.type = "normal"), delete e.arg, (t.completion = e);
        }
        function P(t) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            t.forEach(T, this),
            this.reset(!0);
        }
        function I(e) {
          if (e || "" === e) {
            var n = e[a];
            if (n) return n.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (i.next = i);
            }
          }
          throw new TypeError(typeof e + " is not iterable");
        }
        return (
          (w.prototype = b),
          o(S, "constructor", { value: b, configurable: !0 }),
          o(b, "constructor", { value: w, configurable: !0 }),
          (w.displayName = u(b, s, "GeneratorFunction")),
          (e.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return (
              !!e &&
              (e === w || "GeneratorFunction" === (e.displayName || e.name))
            );
          }),
          (e.mark = function (t) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(t, b)
                : ((t.__proto__ = b), u(t, s, "GeneratorFunction")),
              (t.prototype = Object.create(S)),
              t
            );
          }),
          (e.awrap = function (t) {
            return { __await: t };
          }),
          x(j.prototype),
          u(j.prototype, c, function () {
            return this;
          }),
          (e.AsyncIterator = j),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new j(f(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (t) {
                  return t.done ? t.value : a.next();
                });
          }),
          x(S),
          u(S, s, "Generator"),
          u(S, a, function () {
            return this;
          }),
          u(S, "toString", function () {
            return "[object Generator]";
          }),
          (e.keys = function (t) {
            var e = Object(t),
              n = [];
            for (var r in e) n.push(r);
            return (
              n.reverse(),
              function t() {
                for (; n.length; ) {
                  var r = n.pop();
                  if (r in e) return (t.value = r), (t.done = !1), t;
                }
                return (t.done = !0), t;
              }
            );
          }),
          (e.values = I),
          (P.prototype = {
            constructor: P,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = t),
                this.tryEntries.forEach(A),
                !e)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    r.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = "throw"),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = "next"), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, "catchLoc"),
                    u = r.call(a, "finallyLoc");
                  if (s && u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!u)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (
                  o.tryLoc <= this.prev &&
                  r.call(o, "finallyLoc") &&
                  this.prev < o.finallyLoc
                ) {
                  var i = o;
                  break;
                }
              }
              i &&
                ("break" === t || "continue" === t) &&
                i.tryLoc <= e &&
                e <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = t),
                (a.arg = e),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), g)
                  : this.complete(a)
              );
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return (
                "break" === t.type || "continue" === t.type
                  ? (this.next = t.arg)
                  : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                g
              );
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t)
                  return this.complete(n.completion, n.afterLoc), A(n), g;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.tryLoc === t) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var o = r.arg;
                    A(n);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: I(e), resultName: n, nextLoc: r }),
                "next" === this.method && (this.arg = t),
                g
              );
            },
          }),
          e
        );
      }
      function f(t) {
        return /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*\.){1,63}[a-z0-9]+$/.test(
          t,
        );
      }
      function h(t, e) {
        return ("zh-CN" === e ? /^1[3-9](\d{9})$/ : /^[0-9\-]+$/).test(t);
      }
      function d(t) {
        return "zh-CN" === t ? /^1[3-9](\d{9})$/ : /^[0-9\-]+$/;
      }
      function p(t, e, n) {
        return t ? e : n;
      }
      function v(t) {
        var e = c.a.get("lang"),
          n = "";
        if (t && "" !== t) {
          var r = t.split(" ")[0],
            o = r.split("-")[0],
            i = r.split("-")[1].startsWith("0")
              ? r.split("-")[1][1]
              : r.split("-")[1],
            a = r.split("-")[2].startsWith("0")
              ? r.split("-")[2][1]
              : r.split("-")[2];
          n =
            "zh-CN" === e
              ? ""
                  .concat(o, " \u5e74 ")
                  .concat(i, " \u6708 ")
                  .concat(a, " \u65e5")
              : ""
                  .concat(
                    [
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ][parseInt(i, 10) - 1],
                    " ",
                  )
                  .concat(a, ", ")
                  .concat(o);
        }
        return n;
      }
      var y = new s.Localize({ domain: ".dji.com" });
      var g = !0,
        m = "undefined" !== typeof document;
      function w() {
        if (g)
          return !!window.navigator.userAgent.match(
            /\bm?qqbrowser\/([0-9.]+)/gi,
          );
      }
      function b() {
        if (g) {
          var t = !1,
            e = window.navigator.userAgent,
            n = e.indexOf("MSIE "),
            r = e.indexOf("Trident/"),
            o = e.indexOf("Edge/");
          return (n > 0 || r > 0 || o > 0) && (t = !0), t;
        }
      }
      function _() {
        if (g) {
          var t = window.navigator.userAgent;
          return /firefox/i.test(t);
        }
      }
      function O() {
        if (g) {
          var t = window.navigator.userAgent;
          return /Safari/i.test(t) && !/Chrome/i.test(t);
        }
      }
      function E() {
        if (g) {
          var t = window.navigator.userAgent,
            e = "MacIntel" === window.navigator.platform || /Intel/i.test(t);
          return /Safari/i.test(t) && !/Chrome/i.test(t) && e;
        }
      }
      function S() {
        if (g) {
          var t = window.navigator.userAgent;
          return !!t.match(/iPad/i) || !!t.match(/iPhone/i);
        }
      }
      function x() {
        if (g) {
          var t = window.navigator.platform;
          return (
            -1 !== ["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(t)
          );
        }
      }
      function j() {
        if (g) {
          var t = window.navigator.userAgent.toLowerCase(),
            e = !!t.match(/iPad/i) || !!t.match(/iPhone/i),
            n =
              -1 !== t.indexOf("safari") &&
              -1 === t.indexOf("crios") &&
              -1 === t.indexOf("browser") &&
              -1 === t.indexOf("fxios");
          return e && n;
        }
      }
      function k() {
        if (g) {
          var t = window.navigator.userAgent;
          if (!!t.match(/android/gi)) return !1;
          var e = /MicroMessenger/i.test(t),
            n = /Safari/i.test(t),
            r = /Chrome/i.test(t);
          return !((!n && !r) || e);
        }
      }
      function L() {
        if (g) return !!!window.navigator.userAgent.match(/UCBrowser/gi);
      }
      function T() {
        if (g) {
          var t = window.navigator.userAgent;
          return /MicroMessenger/i.test(t);
        }
      }
      function A() {
        if (g) {
          var t = window.location.hostname;
          return !(/stag/i.test(t) || /test/i.test(t));
        }
      }
      function P() {
        if (g) {
          var t = navigator.userAgent,
            e = -1 !== t.indexOf("Safari") && -1 !== t.indexOf("Version"),
            n = -1 !== t.indexOf("iPhone") && -1 !== t.indexOf("Version");
          return e && !n && "ontouchend" in document;
        }
      }
      function I() {
        return P()
          ? Math.max(window.screen.height, window.innerHeight)
          : window.innerHeight;
      }
      function N(t) {
        for (
          var e = window.location.search.substring(1).split("&"),
            n = 0,
            r = e.length;
          n < r;
          n++
        ) {
          var o = e[n].split("=");
          if (o[0] === t) return o[1];
        }
        return !1;
      }
      function C() {
        var t = window.navigator.userAgent,
          e = !!t.match(/MicroMessenger/gi),
          n = !!t.match(/iPad/i) || !!t.match(/iPhone/i),
          r = !!t.match(/UCBrowser/gi),
          o = !!t.match(/android/gi),
          i = !!t.match(/\bm?qqbrowser\/([0-9.]+)/gi),
          a = !!t.match(/DJI-App-Ios/gi),
          c = !!t.match(/DJI-App-pilot-go/gi),
          s = !!t.match(/djifly_ios/gi),
          u = !!t.match(/DJI-app-mimo/gi);
        return o || s || c || (n && (r || i || e || a || u));
      }
      function D(t, e) {
        t && (t.style.willChange = e);
      }
      function R(t) {
        t && (t.style.willChange = "auto");
      }
      function M(t) {
        return F.apply(this, arguments);
      }
      function F() {
        return (F = Object(i.default)(
          l().mark(function t(e) {
            var n, o, i, a, c, s, u;
            return l().wrap(function (t) {
              for (;;)
                switch ((t.prev = t.next)) {
                  case 0:
                    if (
                      ((n = e.XLSX),
                      (o = e.fileName),
                      (i = e.sheetName),
                      (a = e.header),
                      (c = e.body),
                      n)
                    ) {
                      t.next = 4;
                      break;
                    }
                    return (
                      console.error("\u7f3a\u5c11 XLSX \u63d2\u4ef6"),
                      t.abrupt("return")
                    );
                  case 4:
                    (s = n.utils.book_new()),
                      (u = n.utils.aoa_to_sheet([a].concat(Object(r.a)(c)))),
                      n.utils.book_append_sheet(s, u, i),
                      n.writeFile(s, o, {
                        bookType: "xlsx",
                        bookSST: !0,
                        type: "binary",
                      });
                  case 8:
                  case "end":
                    return t.stop();
                }
            }, t);
          }),
        )).apply(this, arguments);
      }
      function U() {
        var t = new Date(),
          e = "".concat(t.getMonth() + 1),
          n = "".concat(t.getDate());
        return (
          e.length < 2 && (e = "0".concat(e)),
          n.length < 2 && (n = "0".concat(n)),
          [e, n].join("")
        );
      }
      function G(t, e, n) {
        var r = new Date();
        r.setTime(r.getTime() + 24 * n * 60 * 60 * 1e3),
          (document.cookie = ""
            .concat(t, "=")
            .concat(e, "; expires=")
            .concat(r.toGMTString(), "; path=/"));
      }
      function B(t) {
        for (
          var e = "".concat(t, "="), n = document.cookie.split(";"), r = 0;
          r < n.length;
          r++
        ) {
          var o = n[r].trim();
          if (0 === o.indexOf(e)) return o.substring(e.length, o.length);
        }
        return "";
      }
      var H = "_ab_exp";
      function z(t) {
        document.cookie = ""
          .concat(H, "=")
          .concat(t, "; path=/; domain=")
          .concat(
            (function () {
              if (!g) return "";
              var t = window.location.hostname.split(".").reverse(),
                e = Object(o.a)(t, 2),
                n = e[0],
                r = e[1];
              return ".".concat(r, ".").concat(n);
            })(),
            "; max-age=",
          )
          .concat(7776e3);
      }
      function V() {
        var t = B(H),
          e = "";
        return (
          t
            ? ((e = t
                .replace("~pop-footer-subscribe-courtesy.A", "")
                .replace("~pop-footer-subscribe-courtesy.B", "")
                .replace("pop-footer-subscribe-courtesy.A", "")
                .replace("pop-footer-subscribe-courtesy.B", "")),
              (e += "~pop-footer-subscribe-courtesy.B"))
            : (e = "pop-footer-subscribe-courtesy.B"),
          z(e),
          t
        );
      }
      function W(t) {
        t && z(t);
      }
      function q(t, e) {
        try {
          window.localStorage.setItem(t, e);
        } catch (n) {}
      }
      function J(t) {
        try {
          return window.localStorage.getItem(t);
        } catch (e) {
          return "";
        }
      }
      function Y(t, e) {
        try {
          q(t, JSON.stringify(e));
        } catch (n) {
          console.error(n);
        }
      }
      function K(t) {
        try {
          var e = J(t);
          return JSON.parse(e);
        } catch (n) {
          return console.error(n), "";
        }
      }
      var $ = function (t) {
          t = t || 32;
          for (
            var e = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
              n = e.length,
              r = "",
              o = 0;
            o < t;
            o++
          )
            r += e.charAt(Math.floor(Math.random() * n));
          return r;
        },
        X = function (t) {
          "undefined" !== typeof document &&
            "function" === typeof t &&
            ("complete" !== document.readyState
              ? window.addEventListener("load", t)
              : t());
        },
        Q = function (t) {
          return t >= 1 ? 1 : t <= 0 ? 0 : t;
        },
        Z = function (t) {
          return "number" === typeof t && !Number.isNaN(t);
        },
        tt = function (t, e) {
          var n = Math.pow(10, e || 2);
          return Math.round(t * n) / n;
        },
        et = function (t) {
          return t >= 1 ? 1 : t <= 0 ? 0 : tt(t, 3);
        },
        nt = function (t) {
          var e,
            n = t.windowWidth,
            r = t.windowHeight,
            o = t.videoWhRatio;
          if (!o) return 1;
          n / r < (o = +o) ? (e = r / (n / o)) : (e = n / (r * o));
          return e;
        },
        rt = function () {
          if ("undefined" !== typeof document) {
            var t = document.createElement("canvas");
            return (
              !(!t.getContext || !t.getContext("2d")) &&
              0 === t.toDataURL("image/webp").indexOf("data:image/webp")
            );
          }
        },
        ot = function () {
          "undefined" !== typeof document &&
            document.body &&
            (document.body.style.backgroundColor = "black");
        },
        it = function (t, e, n, r) {
          if (t && e && n && r) {
            var o = e.getContext("2d");
            o.clearRect(0, 0, n, r), o.drawImage(t, 0, 0, n, r);
          }
        },
        at = function (t, e, n, r) {
          var o = rt();
          return {
            _address: o && r && "" !== n ? n : t,
            _format: o && r && "" !== n ? "webp" : e,
          };
        },
        ct = function (t, e) {
          if (!Number.isNaN(t))
            return t % 1 === 0 ? t : parseFloat(t.toFixed(e));
        },
        st = function (t, e) {
          if (g && !e) {
            var n = new RegExp("(^|&)".concat(t, "=([^&]*)(&|$)"), "i"),
              r = window.location.search.substr(1).match(n),
              o = "";
            return null != r && (o = r[2]), o;
          }
        };
      function ut(t) {
        return Number(t) === t && t % 1 !== 0;
      }
      var lt = g && window.location.pathname.includes("/edit/"),
        ft = function (t, e) {
          "function" === typeof e &&
            g &&
            ((window.ABTest = window.ABTest || {}),
            (window.ABTest[t] = window.ABTest[t] || {}),
            (window.ABTest[t].waitingList = window.ABTest[t].waitingList || []),
            (window.ABTest[t].exec =
              window.ABTest[t].exec ||
              function () {
                for (
                  var e = window.ABTest[t].waitingList, n = 0;
                  n < e.length;
                  n++
                )
                  "function" === typeof e[n] && e[n]();
              }),
            window.ABTest[t].startFlag
              ? e()
              : window.ABTest[t].waitingList.push(e));
        },
        ht = function (t) {
          return "string" === typeof t
            ? t
            : ("object" === typeof t && t && t.path) || "";
        },
        dt = function (t) {
          return "string" !== typeof t
            ? ""
            : /(s3\.amazonaws|djicdn\.com)/gi.test(t)
              ? t
              : "https://dji-official-fe.djicdn.com/".concat(t);
        },
        pt = function (t) {
          return /vimeo.com\/(\d+)/.test(t)
            ? "//player.vimeo.com/video/".concat(RegExp.$1)
            : /\.youku\.com\/player\.php\/sid\/(.+)\/v\.swf/.test(t)
              ? "https://player.youku.com/embed/".concat(RegExp.$1)
              : /\.youtube\.com\/watch\?v=(.+)/.test(t)
                ? "//www.youtube.com/embed/".concat(RegExp.$1)
                : /^https?:\/\//.test(t)
                  ? t.replace(/^https?:/, "")
                  : t;
        },
        vt = function (t, e) {
          e = +e;
          var n = document.querySelector(".page-wrapper .sections-wrapper");
          if (n) {
            var r = n.clientWidth,
              o = (document.querySelectorAll(".".concat(t, " ._28KUW")) || [])[
                e
              ],
              i = document.querySelector(
                ".".concat(t, " .quark-tab-default-tab-bar"),
              ),
              a = document.querySelector(
                ".".concat(t, " .quark-tab-default-tab-container"),
              );
            if (o) {
              var c = -(o.offsetLeft - (r - o.offsetWidth) / 2),
                s = i.clientWidth;
              if (-c < 0 || 0 === e)
                return void a.scroll({ left: 0, behavior: "smooth" });
              if (c < r - s)
                return void a.scroll({
                  left: -(r - s - 48),
                  behavior: "smooth",
                });
              a.scroll({ left: -c, behavior: "smooth" });
            }
          }
        },
        yt = function (t, e) {
          e = +e;
          var n = (document.querySelectorAll(".".concat(t, " ._28KUW")) || [])[
              e
            ],
            r = document.querySelector(
              ".".concat(t, " .quark-tab-default-tab-container"),
            );
          if (n && r) {
            var o = r.clientWidth / 2 - n.offsetLeft - n.clientWidth / 2;
            r.scroll({ left: -o, behavior: "smooth" });
          }
        },
        gt = function (t, e, n) {
          if (e && t) {
            var r = t.clientWidth / 2 - e.offsetLeft - e.clientWidth / 2;
            t.scroll({ left: -r, behavior: n || "smooth" });
          }
        },
        mt = function (t, e) {
          var n,
            r = e - t,
            o = r > 0 ? r : -r;
          return (
            o < 8e-4
              ? (n = e)
              : ((r *= 0.2),
                (n = t),
                o >= 0.03
                  ? (r = r > 0 ? 0.015 : -0.015)
                  : o < 0.03 && o >= 0.002
                    ? (r = r > 0 ? 0.002 : -0.002)
                    : o < 8e-4 && (r = r > 0 ? 8e-4 : -8e-4),
                (n += r)),
            n > 1 ? (n = 1) : n < 0 && (n = 0),
            n
          );
        },
        wt = function (t) {
          var e = +(t || "").replace("px", "");
          return e && !Number.isNaN(e)
            ? e >= 18
              ? "-0.03em"
              : "-0.02em"
            : void 0;
        },
        bt = function () {
          if (g)
            try {
              window.dispatchEvent(new CustomEvent("scroll"));
            } catch (t) {}
        },
        _t = function (t) {
          return t.match(/^floatButton$|^supportFloating$|^setScript$/);
        },
        Ot = function t(e) {
          var n = [];
          return (
            Object.keys(e).forEach(function (o) {
              if (e[o].type && "number" === e[o].type) n.push(o);
              else if (e[o].props) {
                var i = t(e[o].props);
                n.push.apply(n, Object(r.a)(i));
              }
            }),
            n
          );
        },
        Et = function () {
          return !!window.navigator.userAgent.match(/iPhone OS 16/i);
        };
      function St(t) {
        var e =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6;
        return Math.floor(t * Math.pow(10, e)) / Math.pow(10, e);
      }
      function xt(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (t > e) return [];
        for (
          var r = [], o = [], i = 0, a = e - t + 1, c = Math.floor(a / 2);
          c >= 1;

        ) {
          for (var s = 0, u = t; u <= e; u += c)
            r.includes(u) || (r.push(u), (s += 1));
          var l = r.slice(i, r.length);
          o.push(l), (i += s), (c = Math.floor(c / 2));
        }
        return n ? o : r;
      }
      var jt = function (t) {
        return Array.isArray(t) ? Array.from(new Set(t)) : [];
      };
      function kt(t) {
        return !u.a.includes(t);
      }
      var Lt = function (t, e) {
          return t || e;
        },
        Tt = function (t, e) {
          return t && e;
        },
        At = function (t, e, n) {
          return t ? e : n;
        },
        Pt = function (t, e) {
          return e(t) === "key::".concat(t);
        },
        It = function (t, e) {
          return Pt(t, e) ? "" : e(t);
        },
        Nt = {
          en: "en_US",
          "zh-CN": "zh_CN",
          "zh-TW": "zh_TW",
          ja: "ja_JP",
          ko: "ko_KR",
          fr: "fr_FR",
          de: "DE_DE",
          es: "es_ES",
          it: "it_IT",
        },
        Ct = function (t) {
          return Nt[t];
        },
        Dt = function (t) {
          if (t) return t.replace(/(<([^>]+)>)/gi, "");
        },
        Rt = function (t) {
          if (!t) return !1;
          return ["infoCardVertical"].some(function (e) {
            return -1 !== t.indexOf(e);
          });
        },
        Mt = function () {
          return (
            window.location.pathname.includes("/trailer") ||
            window.location.pathname.includes("/teaser")
          );
        },
        Ft = function () {
          return window.location.pathname.includes("/live/");
        },
        Ut = function (t) {
          var e = {};
          return (
            Object.keys(t || {}).forEach(function (n) {
              var r = t[n];
              r && (e[n] = r);
            }),
            e
          );
        },
        Gt = function () {
          return window.location.href.includes("/mobile");
        },
        Bt = function (t) {
          m &&
            "function" === typeof t &&
            ("complete" === document.readyState
              ? t()
              : document.addEventListener("readystatechange", function () {
                  "complete" === document.readyState && t();
                }));
        },
        Ht = function (t) {
          t.isPlaying && t.pause();
        },
        zt = function (t) {
          for (
            var e =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 1,
              n = [],
              r = 0;
            r < e && t && (t && t.id && n.push(t.id), t.parentNode);
            r++
          )
            t = t.parentNode;
          return n;
        };
      function Vt(t) {
        return parseInt(t, 10);
      }
      var Wt = function () {
        return -1 !== window.navigator.appVersion.indexOf("Win");
      };
      function qt() {
        var t = window.navigator.userAgent;
        if ("undefined" !== typeof t) return !!t.match(/android/gi);
      }
      function Jt() {
        var t = window.navigator.userAgent;
        if ("undefined" !== typeof t)
          return -1 !== t.indexOf("Edge/") || -1 !== t.indexOf("Edg/");
      }
    },
    zT9C: function (t, e, n) {
      (function (t, n) {
        var r = 200,
          o = "__lodash_hash_undefined__",
          i = 9007199254740991,
          a = "[object Arguments]",
          c = "[object Boolean]",
          s = "[object Date]",
          u = "[object Function]",
          l = "[object GeneratorFunction]",
          f = "[object Map]",
          h = "[object Number]",
          d = "[object Object]",
          p = "[object RegExp]",
          v = "[object Set]",
          y = "[object String]",
          g = "[object Symbol]",
          m = "[object ArrayBuffer]",
          w = "[object DataView]",
          b = "[object Float32Array]",
          _ = "[object Float64Array]",
          O = "[object Int8Array]",
          E = "[object Int16Array]",
          S = "[object Int32Array]",
          x = "[object Uint8Array]",
          j = "[object Uint8ClampedArray]",
          k = "[object Uint16Array]",
          L = "[object Uint32Array]",
          T = /\w*$/,
          A = /^\[object .+?Constructor\]$/,
          P = /^(?:0|[1-9]\d*)$/,
          I = {};
        (I[a] =
          I["[object Array]"] =
          I[m] =
          I[w] =
          I[c] =
          I[s] =
          I[b] =
          I[_] =
          I[O] =
          I[E] =
          I[S] =
          I[f] =
          I[h] =
          I[d] =
          I[p] =
          I[v] =
          I[y] =
          I[g] =
          I[x] =
          I[j] =
          I[k] =
          I[L] =
            !0),
          (I["[object Error]"] = I[u] = I["[object WeakMap]"] = !1);
        var N = "object" == typeof t && t && t.Object === Object && t,
          C = "object" == typeof self && self && self.Object === Object && self,
          D = N || C || Function("return this")(),
          R = e && !e.nodeType && e,
          M = R && "object" == typeof n && n && !n.nodeType && n,
          F = M && M.exports === R;
        function U(t, e) {
          return t.set(e[0], e[1]), t;
        }
        function G(t, e) {
          return t.add(e), t;
        }
        function B(t, e, n, r) {
          var o = -1,
            i = t ? t.length : 0;
          for (r && i && (n = t[++o]); ++o < i; ) n = e(n, t[o], o, t);
          return n;
        }
        function H(t) {
          var e = !1;
          if (null != t && "function" != typeof t.toString)
            try {
              e = !!(t + "");
            } catch (n) {}
          return e;
        }
        function z(t) {
          var e = -1,
            n = Array(t.size);
          return (
            t.forEach(function (t, r) {
              n[++e] = [r, t];
            }),
            n
          );
        }
        function V(t, e) {
          return function (n) {
            return t(e(n));
          };
        }
        function W(t) {
          var e = -1,
            n = Array(t.size);
          return (
            t.forEach(function (t) {
              n[++e] = t;
            }),
            n
          );
        }
        var q = Array.prototype,
          J = Function.prototype,
          Y = Object.prototype,
          K = D["__core-js_shared__"],
          $ = (function () {
            var t = /[^.]+$/.exec((K && K.keys && K.keys.IE_PROTO) || "");
            return t ? "Symbol(src)_1." + t : "";
          })(),
          X = J.toString,
          Q = Y.hasOwnProperty,
          Z = Y.toString,
          tt = RegExp(
            "^" +
              X.call(Q)
                .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
                .replace(
                  /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                  "$1.*?",
                ) +
              "$",
          ),
          et = F ? D.Buffer : void 0,
          nt = D.Symbol,
          rt = D.Uint8Array,
          ot = V(Object.getPrototypeOf, Object),
          it = Object.create,
          at = Y.propertyIsEnumerable,
          ct = q.splice,
          st = Object.getOwnPropertySymbols,
          ut = et ? et.isBuffer : void 0,
          lt = V(Object.keys, Object),
          ft = Rt(D, "DataView"),
          ht = Rt(D, "Map"),
          dt = Rt(D, "Promise"),
          pt = Rt(D, "Set"),
          vt = Rt(D, "WeakMap"),
          yt = Rt(Object, "create"),
          gt = Bt(ft),
          mt = Bt(ht),
          wt = Bt(dt),
          bt = Bt(pt),
          _t = Bt(vt),
          Ot = nt ? nt.prototype : void 0,
          Et = Ot ? Ot.valueOf : void 0;
        function St(t) {
          var e = -1,
            n = t ? t.length : 0;
          for (this.clear(); ++e < n; ) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }
        function xt(t) {
          var e = -1,
            n = t ? t.length : 0;
          for (this.clear(); ++e < n; ) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }
        function jt(t) {
          var e = -1,
            n = t ? t.length : 0;
          for (this.clear(); ++e < n; ) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }
        function kt(t) {
          this.__data__ = new xt(t);
        }
        function Lt(t, e) {
          var n =
              zt(t) ||
              (function (t) {
                return (
                  (function (t) {
                    return (
                      (function (t) {
                        return !!t && "object" == typeof t;
                      })(t) && Vt(t)
                    );
                  })(t) &&
                  Q.call(t, "callee") &&
                  (!at.call(t, "callee") || Z.call(t) == a)
                );
              })(t)
                ? (function (t, e) {
                    for (var n = -1, r = Array(t); ++n < t; ) r[n] = e(n);
                    return r;
                  })(t.length, String)
                : [],
            r = n.length,
            o = !!r;
          for (var i in t)
            (!e && !Q.call(t, i)) ||
              (o && ("length" == i || Ut(i, r))) ||
              n.push(i);
          return n;
        }
        function Tt(t, e, n) {
          var r = t[e];
          (Q.call(t, e) && Ht(r, n) && (void 0 !== n || e in t)) || (t[e] = n);
        }
        function At(t, e) {
          for (var n = t.length; n--; ) if (Ht(t[n][0], e)) return n;
          return -1;
        }
        function Pt(t, e, n, r, o, i, A) {
          var P;
          if ((r && (P = i ? r(t, o, i, A) : r(t)), void 0 !== P)) return P;
          if (!Jt(t)) return t;
          var N = zt(t);
          if (N) {
            if (
              ((P = (function (t) {
                var e = t.length,
                  n = t.constructor(e);
                e &&
                  "string" == typeof t[0] &&
                  Q.call(t, "index") &&
                  ((n.index = t.index), (n.input = t.input));
                return n;
              })(t)),
              !e)
            )
              return (function (t, e) {
                var n = -1,
                  r = t.length;
                e || (e = Array(r));
                for (; ++n < r; ) e[n] = t[n];
                return e;
              })(t, P);
          } else {
            var C = Ft(t),
              D = C == u || C == l;
            if (Wt(t))
              return (function (t, e) {
                if (e) return t.slice();
                var n = new t.constructor(t.length);
                return t.copy(n), n;
              })(t, e);
            if (C == d || C == a || (D && !i)) {
              if (H(t)) return i ? t : {};
              if (
                ((P = (function (t) {
                  return "function" != typeof t.constructor || Gt(t)
                    ? {}
                    : ((e = ot(t)), Jt(e) ? it(e) : {});
                  var e;
                })(D ? {} : t)),
                !e)
              )
                return (function (t, e) {
                  return Ct(t, Mt(t), e);
                })(
                  t,
                  (function (t, e) {
                    return t && Ct(e, Yt(e), t);
                  })(P, t),
                );
            } else {
              if (!I[C]) return i ? t : {};
              P = (function (t, e, n, r) {
                var o = t.constructor;
                switch (e) {
                  case m:
                    return Nt(t);
                  case c:
                  case s:
                    return new o(+t);
                  case w:
                    return (function (t, e) {
                      var n = e ? Nt(t.buffer) : t.buffer;
                      return new t.constructor(n, t.byteOffset, t.byteLength);
                    })(t, r);
                  case b:
                  case _:
                  case O:
                  case E:
                  case S:
                  case x:
                  case j:
                  case k:
                  case L:
                    return (function (t, e) {
                      var n = e ? Nt(t.buffer) : t.buffer;
                      return new t.constructor(n, t.byteOffset, t.length);
                    })(t, r);
                  case f:
                    return (function (t, e, n) {
                      return B(e ? n(z(t), !0) : z(t), U, new t.constructor());
                    })(t, r, n);
                  case h:
                  case y:
                    return new o(t);
                  case p:
                    return (function (t) {
                      var e = new t.constructor(t.source, T.exec(t));
                      return (e.lastIndex = t.lastIndex), e;
                    })(t);
                  case v:
                    return (function (t, e, n) {
                      return B(e ? n(W(t), !0) : W(t), G, new t.constructor());
                    })(t, r, n);
                  case g:
                    return (i = t), Et ? Object(Et.call(i)) : {};
                }
                var i;
              })(t, C, Pt, e);
            }
          }
          A || (A = new kt());
          var R = A.get(t);
          if (R) return R;
          if ((A.set(t, P), !N))
            var M = n
              ? (function (t) {
                  return (function (t, e, n) {
                    var r = e(t);
                    return zt(t)
                      ? r
                      : (function (t, e) {
                          for (
                            var n = -1, r = e.length, o = t.length;
                            ++n < r;

                          )
                            t[o + n] = e[n];
                          return t;
                        })(r, n(t));
                  })(t, Yt, Mt);
                })(t)
              : Yt(t);
          return (
            (function (t, e) {
              for (
                var n = -1, r = t ? t.length : 0;
                ++n < r && !1 !== e(t[n], n, t);

              );
            })(M || t, function (o, i) {
              M && (o = t[(i = o)]), Tt(P, i, Pt(o, e, n, r, i, t, A));
            }),
            P
          );
        }
        function It(t) {
          return (
            !(!Jt(t) || ((e = t), $ && $ in e)) &&
            (qt(t) || H(t) ? tt : A).test(Bt(t))
          );
          var e;
        }
        function Nt(t) {
          var e = new t.constructor(t.byteLength);
          return new rt(e).set(new rt(t)), e;
        }
        function Ct(t, e, n, r) {
          n || (n = {});
          for (var o = -1, i = e.length; ++o < i; ) {
            var a = e[o],
              c = r ? r(n[a], t[a], a, n, t) : void 0;
            Tt(n, a, void 0 === c ? t[a] : c);
          }
          return n;
        }
        function Dt(t, e) {
          var n = t.__data__;
          return (function (t) {
            var e = typeof t;
            return "string" == e ||
              "number" == e ||
              "symbol" == e ||
              "boolean" == e
              ? "__proto__" !== t
              : null === t;
          })(e)
            ? n["string" == typeof e ? "string" : "hash"]
            : n.map;
        }
        function Rt(t, e) {
          var n = (function (t, e) {
            return null == t ? void 0 : t[e];
          })(t, e);
          return It(n) ? n : void 0;
        }
        (St.prototype.clear = function () {
          this.__data__ = yt ? yt(null) : {};
        }),
          (St.prototype.delete = function (t) {
            return this.has(t) && delete this.__data__[t];
          }),
          (St.prototype.get = function (t) {
            var e = this.__data__;
            if (yt) {
              var n = e[t];
              return n === o ? void 0 : n;
            }
            return Q.call(e, t) ? e[t] : void 0;
          }),
          (St.prototype.has = function (t) {
            var e = this.__data__;
            return yt ? void 0 !== e[t] : Q.call(e, t);
          }),
          (St.prototype.set = function (t, e) {
            return (this.__data__[t] = yt && void 0 === e ? o : e), this;
          }),
          (xt.prototype.clear = function () {
            this.__data__ = [];
          }),
          (xt.prototype.delete = function (t) {
            var e = this.__data__,
              n = At(e, t);
            return (
              !(n < 0) && (n == e.length - 1 ? e.pop() : ct.call(e, n, 1), !0)
            );
          }),
          (xt.prototype.get = function (t) {
            var e = this.__data__,
              n = At(e, t);
            return n < 0 ? void 0 : e[n][1];
          }),
          (xt.prototype.has = function (t) {
            return At(this.__data__, t) > -1;
          }),
          (xt.prototype.set = function (t, e) {
            var n = this.__data__,
              r = At(n, t);
            return r < 0 ? n.push([t, e]) : (n[r][1] = e), this;
          }),
          (jt.prototype.clear = function () {
            this.__data__ = {
              hash: new St(),
              map: new (ht || xt)(),
              string: new St(),
            };
          }),
          (jt.prototype.delete = function (t) {
            return Dt(this, t).delete(t);
          }),
          (jt.prototype.get = function (t) {
            return Dt(this, t).get(t);
          }),
          (jt.prototype.has = function (t) {
            return Dt(this, t).has(t);
          }),
          (jt.prototype.set = function (t, e) {
            return Dt(this, t).set(t, e), this;
          }),
          (kt.prototype.clear = function () {
            this.__data__ = new xt();
          }),
          (kt.prototype.delete = function (t) {
            return this.__data__.delete(t);
          }),
          (kt.prototype.get = function (t) {
            return this.__data__.get(t);
          }),
          (kt.prototype.has = function (t) {
            return this.__data__.has(t);
          }),
          (kt.prototype.set = function (t, e) {
            var n = this.__data__;
            if (n instanceof xt) {
              var o = n.__data__;
              if (!ht || o.length < r - 1) return o.push([t, e]), this;
              n = this.__data__ = new jt(o);
            }
            return n.set(t, e), this;
          });
        var Mt = st
            ? V(st, Object)
            : function () {
                return [];
              },
          Ft = function (t) {
            return Z.call(t);
          };
        function Ut(t, e) {
          return (
            !!(e = null == e ? i : e) &&
            ("number" == typeof t || P.test(t)) &&
            t > -1 &&
            t % 1 == 0 &&
            t < e
          );
        }
        function Gt(t) {
          var e = t && t.constructor;
          return t === (("function" == typeof e && e.prototype) || Y);
        }
        function Bt(t) {
          if (null != t) {
            try {
              return X.call(t);
            } catch (e) {}
            try {
              return t + "";
            } catch (e) {}
          }
          return "";
        }
        function Ht(t, e) {
          return t === e || (t !== t && e !== e);
        }
        ((ft && Ft(new ft(new ArrayBuffer(1))) != w) ||
          (ht && Ft(new ht()) != f) ||
          (dt && "[object Promise]" != Ft(dt.resolve())) ||
          (pt && Ft(new pt()) != v) ||
          (vt && "[object WeakMap]" != Ft(new vt()))) &&
          (Ft = function (t) {
            var e = Z.call(t),
              n = e == d ? t.constructor : void 0,
              r = n ? Bt(n) : void 0;
            if (r)
              switch (r) {
                case gt:
                  return w;
                case mt:
                  return f;
                case wt:
                  return "[object Promise]";
                case bt:
                  return v;
                case _t:
                  return "[object WeakMap]";
              }
            return e;
          });
        var zt = Array.isArray;
        function Vt(t) {
          return (
            null != t &&
            (function (t) {
              return "number" == typeof t && t > -1 && t % 1 == 0 && t <= i;
            })(t.length) &&
            !qt(t)
          );
        }
        var Wt =
          ut ||
          function () {
            return !1;
          };
        function qt(t) {
          var e = Jt(t) ? Z.call(t) : "";
          return e == u || e == l;
        }
        function Jt(t) {
          var e = typeof t;
          return !!t && ("object" == e || "function" == e);
        }
        function Yt(t) {
          return Vt(t)
            ? Lt(t)
            : (function (t) {
                if (!Gt(t)) return lt(t);
                var e = [];
                for (var n in Object(t))
                  Q.call(t, n) && "constructor" != n && e.push(n);
                return e;
              })(t);
        }
        n.exports = function (t) {
          return Pt(t, !0, !0);
        };
      }).call(this, n("yLpj"), n("YuTi")(t));
    },
  },
  [[4, 1, 0]],
]);
